export function VIFRulesAddSub(cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:
  // helper functions:

  function mc_symbol_clone() {
    var clone = this._cloneProps(
      new this.constructor(
        this.mode,
        this.startPosition,
        this.loop,
        this.reversed,
      ),
    );
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
  }

  function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
  }

  (lib.ValueTextBlack_line = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(2));

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#000000').ss(2, 0, 1).p('AifAAIE/AA');

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f().s('#FFFFFF').ss(2, 0, 1).p('AihAAIFDAA');
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.1, -1, 34.3, 2);

  (lib.ValueText_glow = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .rf(
        [
          'rgba(255,255,255,0.502)',
          'rgba(255,255,255,0.8)',
          'rgba(255,255,255,0)',
        ],
        [0, 0, 1],
        0,
        0,
        0,
        0,
        0,
        20.8,
      )
      .s()
      .p(
        'AiRCSQg9g8ABhWQgBhVA9g8QA8g9BVAAQBVAAA9A9QA9A8gBBVQABBWg9A8Qg9A9hVAAQhVAAg8g9g',
      );
    this.shape.setTransform(0.0184, -0.0236, 1.4528, 1.4492);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueText_glow,
    new cjs.Rectangle(-30, -30, 60, 60),
    null,
  );

  (lib.comsuntexsymbolsValueText = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.smallText = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.smallText.name = 'smallText';
    this.smallText.textAlign = 'center';
    this.smallText.lineHeight = 17;
    this.smallText.lineWidth = 57;
    this.smallText.parent = this;
    this.smallText.setTransform(17.65, 2);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueText,
    new cjs.Rectangle(-13, 0, 61.3, 27.1),
    null,
  );

  (lib.sb = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FF7D32').s().p('AlvCeIAAk7ILfAAIAAE7g');
    this.shape.setTransform(36.75, 15.75);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#66FF00').s().p('AlvCeIAAk7ILfAAIAAE7g');
    this.shape_1.setTransform(36.75, 15.75);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 73.5, 31.5);

  (lib.PostivieFeedback_bg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(153,0,153,0.2)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape.setTransform(-0.0024, -0.0204);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,51,51,0.247)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_1.setTransform(-0.0024, -0.0204);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,153,0,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_2.setTransform(-0.0024, -0.0204);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('rgba(153,204,0,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_3.setTransform(-0.0024, -0.0204);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('rgba(51,153,153,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_4.setTransform(-0.0024, -0.0204);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('rgba(0,102,204,0.247)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_5.setTransform(-0.0024, -0.0204);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('rgba(102,0,204,0.298)')
      .s()
      .p(
        'Al4FSQiBgqhOg+Qi5iaCMi2QA1hFBjgqQBYgnBxgNQBpgMBmAMQBjAMBDAfQCEA+AkBAQAkBAgzBQQgtA+hTAcQhIAZhXgDQhOgEhAgXQg+gXgOgdQgKgXALgaQANggAmgKQAmgLAaANQAWAJAAAPQAAAIgFAFQgEAEABAFQBTAkA4giQAXgNALgWQALgTgEgTQgbiiljBCQhgASg4ArQgyAlgPAzQgNAwASAwQARAvAnAfQAiAbBEAfQBZApBkAWQEcA/EPhoQBeglA4gqQBGg0AnhPQBQiliLiVQgrgvg+gpIg3giQgWgWAdAKQDdB4AuCnQAYBYgZBFQgiBYhQBFQiHB1jzAkQh2AShsAAQi1AAiagyg',
      );
    this.shape_6.setTransform(-0.0024, -0.0204);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('rgba(204,51,153,0.298)')
      .s()
      .p('AtCkrIaFCWIhGCMI2LE1g');
    this.shape_7.setTransform(6.4, 0.55);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('rgba(255,51,51,0.298)')
      .s()
      .p('Av7gaICtkfIJgIDIIWn1ILUG4IlFCKIlWmIIo9Grg');
    this.shape_8.setTransform(0.075, -0.075);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('rgba(255,153,0,0.298)')
      .s()
      .p('Av7gaICtkfIJ+EoIKsjeIIgF8IlFCKIlWmIIo9Grg');
    this.shape_9.setTransform(0.075, -0.075);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('rgba(153,204,0,0.298)')
      .s()
      .p('AvdjRIOXAxIGJEBIFWmJIFFCLIo+FyIqsjeIpgExg');
    this.shape_10.setTransform(3.075, 1.6);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('rgba(102,51,204,0.298)')
      .s()
      .p('AtvCbICgjHIWBjIIC+Hpg');
    this.shape_11.setTransform(-1.5, -1.05);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('rgba(51,153,153,0.298)')
      .s()
      .p('ADvjJIoWH1IrUm4IFFiKIFWGIII9mrIMfFUIitEfg');
    this.shape_12.setTransform(0.025, -0.125);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('rgba(0,51,204,0.298)')
      .s()
      .p('Av7ghIKhjZIBsG9IIWn1ILUG4IlFCKIlMiZIpHC8g');
    this.shape_13.setTransform(0.075, 0.625);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('rgba(204,51,153,0.298)')
      .s()
      .p('Av7iFIFFiKIFgEQIIzkzIMfFUIqhCxIhsmVIoWH1g');
    this.shape_14.setTransform(0.025, 0.575);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 13)
        .to({ state: [{ t: this.shape_8 }] }, 1)
        .to({ state: [{ t: this.shape_9 }] }, 1)
        .to({ state: [{ t: this.shape_10 }] }, 1)
        .to({ state: [{ t: this.shape_11 }] }, 1)
        .to({ state: [{ t: this.shape_12 }] }, 1)
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-102, -38.8, 204.1, 77.6);

  (lib.PostitiveFeedback_text = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape.setTransform(-3.425, 2.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'Ak+BuQgcgaAAgsQAAgqAZgbQAagcAqAAQAkAAAZAaQAYAaAAAiQAAATgMADIgmAEIhBAGQACAMANAGQALAFAOAAQAQAAARgJIAOgJQAEACAJARQAKARAAAFIgDAEQgXAZgwAAQgsAAgbgagAkXAAQgHAIAAAMQAAAFAFAAQANAAAdgEQAHgBAAgCQAAgLgJgIQgIgJgLAAQgMAAgHAKgAM3B9QgKgLAAgPQAAgQAKgKQAJgKAQAAQAPAAAKAKQAKAKAAAQQAAAPgKALQgKAKgPAAQgQAAgJgKgAneBrQgagbAAgpQAAgoAagbQAbgcApAAQAbAAAVAMQAFACAAADIgGAWIgGAVQgCAEgCAAIgLgDQgLgDgHAAQgQAAgKAKQgKAKAAARQAAARALAJQALAKARAAQAIAAAKgEIAKgEQADAAAFAXQAEAWAAAHQAAAHgXAFQgSAEgKAAQgpAAgbgcgAD8BsQgagaAAgpQAAgqAZgbQAZgaArAAQAqAAAaAaQAaAaAAApQAAAqgaAbQgaAagqAAQgpAAgagagAEnANQgJALAAAPQAAAPAJALQAKALAPAAQAOAAAJgLQAJgLAAgPQAAgPgJgLQgJgLgOAAQgPAAgKALgAJNCDQgFgBAAgHIAAhyIgChDIgChEQAAgEAFgBIAeAAIASgCIASgCQACAAAAAGIgBATIgBATIgCA+QAAAFACAAIAEgEQAYgZAjAAQAgAAATAPQAVAQAAAfQAAApgoAVQgEACAAACQAAADARAYIASAYQAAAFgxAAQgTAAgDgFIgYgkQAAgBghgBIAAASIAAATQAAAFgFABIgdAAIgaAAgAKXAHQgOAJAAALQAAAPAEAEQAEACASAAQAmAAAAgbQAAgVgaAAQgLAAgNAHgAG8CCQgGAAAAgGIAAgsIAAgtQAAgqgIgdIAAgCQAAgDADgBIAegEIAegGQADAAABAMQABALACAAQgBAAARgJQARgKARAAQAKAAAAAEIgBAQIgBAPIAAANIABAPQAAAHgIAAIgLAAIgKgBQgPAAgGAFQgFAFAAAOIAAAZIAAAYIABAQIABAQQAAAEgGABIgcAAIgcgBgABxCCQgEgBgDgCQgLgLgWgoQgXApgJAKQgEAEgUAAQgOAAgDgBQgJgCgWgmQgSgfgIgSQgFgMAAgdQAAghACgIQABgEAFAAIAaAAIAaABQADAAAAAGIgBAQIAAARIABAgQABAEAJARQAKARACAAQADAAAJgRIAKgVQACgGAAgaIgBgRIgBgQQAAgGAEAAIAVAAIAMAAIAVAAQAEABAAAFIgBAVIgBAVQAAATACAFIAJAUQAIARADAAQAEAAAJgRQAJgQAAgFIABhBQAAgHAEAAIAZAAIAagBQAFAAABAFQACAIAAAhQAAAdgEAMQgFAMgTAgQgUAhgIAIQgFAFgTAAQgQAAgEgBgApQCCQgEAAgBgCIAAgGIAAgmIABgnQAAg0gEgfIgBgEQAAgDAFAAIAQABIAQABIARgBIAQgBQAEAAAAAEIAAADQgEAkAAAvIAAApIABAoQAAAEgFAAQgGABgWAAQgXAAgGgBgAqdCDIgPgBIgOAAQgEAAgEgHIg8hPIgngyIgDgCQgBAAAAAAQAAABAAAAQgBABAAAAQAAABAAABIACA/IABBBQAAAGgFAAIhAAAQgGAAAAgGIACg8IACg9IgBg+IgChAQAAgEAHAAIAagCIAPgCIAPgCQACAAAFAHIBFBeIAcAlQAFAGADAAQACAAAAgOIgCg7QgCgnAAgTQAAgHAEAAIAhgBIAigBQAEAAAAAGIgCA/IgCA/IAAB6QAAAFgFAAIgOABIgNAAgAM+AoQgRg7AAgIIABgWIAAgXIAAgZIgBgZQAAgHAEAAIAPABIAQAAIAPAAIAQgBQAEAAAAAtQAAAigGAdIgPA8QgCAHgNAAQgPAAgCgGgApNhEQgLgJAAgPQAAgOAMgKQAKgIAPAAQAPAAAKAJQALAJAAAOQAAAhgkAAQgPAAgLgJg',
      );
    this.shape_1.setTransform(-7.025, 0.425);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AhOBuQgMgTAAgFQAAAAAAAAQAAgBABAAQAAAAAAAAQAAgBABAAIAYgEQAQgFAAgLQAAgIgJgKIgRgTQgIgNgBgOQABgZAagTQAYgQAcAAQACAAAKATQAMATAAADQAAACgEADIgJgBQgJAAgIAEQgIAFAAAJQAAAGAJAKQANAOACAFQAKANgBAQQABAIgEALQgEALgGAFQgMALgSAIQgSAIgQAAQgDAAgNgTgAI4BnQgagZAAgpQAAgoAXgaQAYgaAoAAQAjAAAXAYQAXAZAAAhQABASgMACIglAEIg9AFQACAMANAGQAKAFANAAQAQAAAPgJIANgIQAFACAIAQQAJAQAAAEQAAACgDACQgVAXguAAQgpAAgagYgAJdgBQgHAIAAALQAAAFAEAAQANAAAcgEQAGgBAAgCQAAgLgIgHQgIgIgKAAQgMAAgGAJgAj1BnQgagZAAgpQAAgoAYgaQAYgaAoAAQAiAAAXAYQAYAZAAAhQAAASgLACIglAEIg9AFQABAMANAGQALAFAMAAQAQAAAQgJIANgIQAEACAIAQQAJAQAAAEQAAACgDACQgUAXguAAQgqAAgagYgAjQgBQgHAIABALQgBAFAFAAQANAAAcgEQAFgBAAgCQABgLgJgHQgHgIgLAAQgLAAgHAJgALnB1QgJgKAAgPQAAgOAJgKQAKgJAOAAQAPAAAJAJQAKAKgBAOQABAPgKAKQgJAKgPAAQgOAAgKgKgAA9BlQgZgYAAgnQAAgoAYgZQAYgaAoAAQAoAAAZAZQAZAZgBAnQABAogZAZQgZAZgoAAQgmAAgZgZgABmAMQgIAKAAAOQAAAOAIAKQAJALAOAAQANAAAKgLQAIgKAAgOQAAgOgIgLQgKgKgNAAQgOAAgJALgApuB6QgGgBgCgHQgGgZgDgCQgCgBgtAAQgeAAgBACQgEACgDAQQgEAPgFABQgFACgiAAQgbAAAAgFQAAgFAnhsIAvh/QACgHADAAIAOABIAPABIAPAAIANgBQAEAAADAGQAIASApBrQAqBtAAAFQAAADgEABQgFACgbAAQgaAAgHgCgAqxgIQgKAbAAAEQAAAEALAAIASAAQALAAABgCIAAgDQAAgGgIgZQgHgZgEgHQgEAHgIAagAHKB6QgGgBABgHIAAgYIABgZIgBgrQgBgVgTAAQgIAAgIAHQgJAGAAAJIgBArIABAZIAAAZQAAAGgFAAIg2AAQgEAAAAgHIAAgZIABgZIAAgTIgBgUQAAgZgTAAQgIAAgJAGQgJAGAAAHIAAAwIAAAwQAAAEgBABIgGACIgZAAIgZgBIgFgBQgBgBAAgEIABgqIAAgqQAAgdgFgjIAAgDQAAgDADgCQADgBALgBIAPgCIAPgDQAIgDAFAAQAEAAAAAMQAAANACAAIADgDQAQgMAKgFQANgGAQAAQAQAAAMAHQAPAIAEAPQAKgNAPgJQARgIAQAAQAWAAAQAKQAQANAAAWIAAAbIgBAcIABAiIAAAhQAAAGgGABIgaAAQgVAAgFgBgAl7B6IgGgDQgKgKgVgnQgWAogIAJQgFAEgSAAQgNAAgFgBQgIgCgVgkQgRgdgIgSQgEgLAAgaQAAggABgIQACgEAFAAIAYAAIAYABQAEAAABAGIgBAPIgBAQQAAAUACAKQAAAEAKAQQAIAQADAAQACAAAJgQQAHgNACgGQACgHAAgYIgBgQIgBgPQAAgGAEAAIAUAAIAMAAIATAAQAEABAAAFIAAAUIgBATQAAASABAFQACAGAGANQAIAQAEAAQACAAAJgQQAIgPABgFIAAg9QABgGADAAIAYgBIAZAAQAEAAACAEQABAIABAgQAAAbgFAKQgFAMgRAeQgTAggHAHQgFAFgTAAQgPAAgEgBgALvAlQgRg4AAgIIABgVIAAgVIAAgYIgBgYQAAgGADAAIAPAAIAPABIAPgBIAPAAQADAAAAAqQAAAggFAcIgPA5QgBAGgMAAQgOAAgCgFg',
      );
    this.shape_2.setTransform(-6.75, -0.625);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_3.setTransform(-4, 3.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_4.setTransform(-5.075, 0.8);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AC1B6QgOgVAAgFQAAgBAAAAQAAAAAAAAQAAgBABAAQAAAAABAAIAbgFQASgGgBgMQABgJgLgLIgSgVQgKgOAAgQQAAgcAegVQAagSAfAAQADAAAMAVQANAVAAAEQAAACgEADIgLgBQgLAAgIAFQgJAGAAAJQAAAHAJALQAQAQADAFQALAPgBARQAAAKgDALQgFAMgHAGQgOAMgUAJQgUAJgSAAQgEAAgNgVgAK2CCQgLgLAAgQQAAgRALgKQAJgLARAAQAQAAAKALQALAKAAARQAAAQgLALQgJALgRAAQgRAAgJgLgAkgBuQgXgcAAgnQAAgsAZgcQAYgcAtAAQAeAAATAVIABABQACAAACgJQACgKADAAQAHAAAVAEQATAEAIADQABABABAAQAAAAAAAAQABABAAAAQAAABAAAAIgBAEQgFAkAAAmIABAtIACAsQAAAIgHABQgYACggAAQgDAAgCgMQgBgLgCAAIgDADQgXAWgZAAQglAAgagegAjrAMQgJAKgBARQAAAQALALQALAMAQAAQAQAAALgLQALgLAAgRQAAgQgLgLQgLgLgQAAQgRAAgLALgAIYBgIAAgnIABgmQABgJgLAAIgCAAIgCAAQgIAAAAgFIABgJIAAgJIAAgNIgBgMQAAgEAMgBQAIAAAAgDIABgYIgBgYQAAgXAEAAQAFAAAKADIAQADIAeADQAFABAAADIgBAXIgCAYQAAAKAGAAIAUgBIAWAAQAEAAAAADIgBANIgBANIAAAOIAAANQAAAEgGAAIgMAAIgOgBIgOAAQgDAAAAAJIAAAOIAAAOQAAAQAEAGQAFAJAPAAIAPgCIAMgDQAFAAAAAFIgCARIgCASQAAAFgBACIgHAEQgYAOgfAAQg4AAAAgrgAg8BgIABgnIABgmQAAgJgKAAIgCAAIgDAAQgIAAAAgFIABgJIABgJIgBgNIgBgMQAAgEANgBQAHAAABgDIABgYIgBgYQgBgXAFAAQAFAAAKADIAQADIAdADQAEABAAADIgBAXIgCAYQAAAKAHAAIAUgBIAVAAQAEAAABADIgBANIgBANIAAAOIAAANQAAAEgGAAIgNAAIgNgBIgPAAQgCAAgBAJIAAAOIAAAOQABAQADAGQAGAJAPAAIAOgCIANgDQAEAAAAAFIgCARIgBASQAAAFgBACIgHAEQgZAOgeAAQg4AAAAgrgAmPCIQgHgBAAgIIABgyIAAgzQABgXgXAAQgJAAgKAHQgMAGABAIIAAAwIAAAcIAAAdQAAAHgGABIgiAAQgQAAgHgBQgHgCAAgFIAAguIABgvQgBg/gBgqIgBgdQgBgRgDgMIAAgEQAAgBAAAAQAAgBABAAQAAgBABAAQAAAAABgBQAGgBALgBIATgBIAjgEQADAAABAEIgBARIgBARIgCBGQAAABABABQAAAAAAABQAAAAABABQAAAAABAAIAKgHQALgIAKgFQAQgGAOAAQAZAAARANQASAOAAAYIgBCGQAAAHgFABIgdAAQgVAAgIgBgAqvCIQgGgBAAgFIADhFIAChFIgChEQgnAEgXAAQgBAAgBAAQAAAAgBAAQAAAAAAgBQgBAAAAgBIAEgPIADgQIABgTQABgOAEAAIACAAQAgAEA+AAQASAAAvgEIAagCIAEABQAAAAAAAAQABABAAAAQAAABAAAAQAAABAAABIgBAOIAAAPIABAOIABAOQAAAEgDAAIg8gDIgBBFIACBFIACBFQAAABAAABQAAABAAAAQgBABAAAAQAAAAgBABIgFABQgMABgXAAQgZAAgKgBgAGqCIQgEgBgBgCIgBgGIABgoIAAgpQAAg2gDghIgBgEQAAgEAFAAIARABIARABIARgBIARgBQAFAAgBAEIAAAEQgEAmAAAxIABArIAAAqQAAAEgFABQgGABgYAAQgXAAgHgBgAK9ApQgSg+AAgJIABgXIABgYIAAgbIgCgaQAAgHAEAAIARABIAQAAIAQAAIARgBQAEAAAAAvQgBAkgFAfIgQA/QgCAHgOAAQgPAAgDgGgABlgcQgIgBgHgjQgGgcAAgQIAAgYQAAgEADgBQAEgBAYAAQAaAAADABQAEABAAAiQAAAggOAmQgCAEgDAAIgMABIgMgBgAGthJQgLgJAAgQQAAgPAMgKQALgJAPAAQAQAAALAJQAMAKAAAPQAAAignAAQgPAAgMgJg',
      );
    this.shape_5.setTransform(-5.85, 0.675);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_6.setTransform(-6.35, 1.5);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_7.setTransform(-7.4, 1.975);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AgaCBQgJgLgBgQQABgRAJgKQALgLAPAAQAQAAAKALQAKAKAAARQAAAQgKALQgJAKgRABQgPgBgLgKgAgSAoQgSg/AAgIIABgYIABgXIgBgbIgBgaQAAgIAEABIARAAIAPABIAQgBIARAAQADAAAAAuQAAAkgFAgIgQA/QgCAGgNAAQgQAAgCgFg',
      );
    this.shape_8.setTransform(79.55, 0.8);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgyBVIABgnIABgmQAAgIgKAAIgDAAIgCAAQgIAAAAgFIABgKIAAgJIAAgMIgBgNQAAgEANAAQAHgBAAgDIABgXIgBgZQAAgWAFAAQAFAAAKACIAPADIAdAEQAFAAAAADIgBAYIgCAXQAAAKAGAAIAVgBIAVAAQAEAAAAADIgBANIgBAOIAAANIAAAOQAAADgFAAIgNAAIgNgBIgPAAQgDABAAAIIAAAOIAAAOQAAAQAEAHQAFAIAQAAIAOgCIAMgDQAFABAAAEIgCARIgBASQAAAGgCABIgGAFQgZAOgfgBQg3ABAAgsg',
      );
    this.shape_9.setTransform(66.225, 1.75);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AgdCGQgEgBgBgCIgBgGIABgoIAAgpQAAg2gDghIgBgEQAAgEAFAAIARABIAQABIARgBIARgBQAFAAgBAEIAAAEQgEAmAAAxIABArIAAAqQAAAEgFABQgHABgXAAQgWAAgHgBgAgahLQgLgJAAgQQAAgPAMgKQALgJAOAAQAQAAALAJQAMAKAAAPQAAAignAAQgOAAgMgJg',
      );
    this.shape_10.setTransform(53.15, 0.875);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'AgyBVIABgnIABgmQAAgIgKAAIgDAAIgCAAQgIAAAAgFIABgKIAAgJIAAgMIgBgNQAAgEANAAQAHgBAAgDIABgXIgBgZQAAgWAFAAQAFAAAKACIAPADIAdAEQAFAAAAADIgBAYIgCAXQAAAKAGAAIAVgBIAVAAQAEAAAAADIgBANIgBAOIAAANIAAAOQAAADgFAAIgNAAIgNgBIgPAAQgDABAAAIIAAAOIAAAOQAAAQAEAHQAFAIAQAAIAOgCIAMgDQAFABAAAEIgCARIgBASQAAAGgCABIgGAFQgZAOgfgBQg3ABAAgsg',
      );
    this.shape_11.setTransform(30.125, 1.75);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p(
        'AhGBIQgcgbAAgrQAAgsAbgcQAbgdAsAAQAsAAAbAcQAcAcAAArQAAAsgbAcQgcAcgsAAQgqAAgcgcgAgYgaQgJALAAAPQAAAPAJAMQAKAMAOAAQAQAAAKgMQAJgMAAgPQAAgPgKgLQgJgMgQAAQgOAAgKAMg',
      );
    this.shape_12.setTransform(11.975, 4.675);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AguB2QgkgGAAgJQAAgDAIgkQABgEADAAIACAAQAfAPAZAAQANAAAOgHQARgJAAgMIAAgNQgUASgeABQglgBgYgaQgXgZAAglQAAglAWgZQAXgZAlAAQAdAAAPAVQADAEACAAQABABAAgIQAAgPAEAAIAiADIAfADQAEACAAAEIgBAoIgBAoIAAAYIAAAXQAAA4gXAYQgYAZg4AAQgQAAgcgGgAgWg7QgKALAAAOQAAAPAKAKQAKAJANAAQAOAAAJgJQAKgKAAgPQAAgOgKgLQgJgKgOAAQgOAAgJAKg',
      );
    this.shape_13.setTransform(-10.475, 7.25);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p(
        'AAiBdQgEgBgBgEIgBgMQgBgIgCgBIAAAAIAAAAQACABgVANQgWANgSAAQg0AAgJguQgFgXAAgnQAAgtAHgaQADgIAGAAIAbAAIAbAAQAGAAAAAGIAAADQgEAbAAAbQAAAiACAMQADAVAWABQAIAAAKgIQAKgIABgIIAAhhQAAgGABgCQABgCAGAAIAdAAIAdABQAFAAABADIABAEIgCAsIgBAqIABAqIABAqQAAAFgFACQgHACgYAAIgegBg',
      );
    this.shape_14.setTransform(-43.075, 5.05);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AhGBIQgcgbAAgrQAAgsAbgcQAbgdAsAAQAsAAAbAcQAcAcAAArQAAAsgbAcQgcAcgsAAQgqAAgcgcgAgYgaQgJALAAAPQAAAPAJAMQAKAMAOAAQAQAAAKgMQAJgMAAgPQAAgPgKgLQgJgMgQAAQgOAAgKAMg',
      );
    this.shape_15.setTransform(-65.325, 4.675);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p(
        'AgkCIQgGAAABgFIACggIABgfQAAgHgEgHQgYgigshDQgFgIABgFIgCgjIgBgjQAAgGAEAAIAkAAIAlABQAEAAAAADIgBAfIgBAdQAAAGARAXQAOATAIAKIAVgcQARgXAAgGIgBgdIgCgdQAAgFACgBIAEAAIAkgBIAjAAQAEAAAAAIIAAAfIABAgQAAAIgDAGQgaAzgsA2QgGAIAAAIIABAeIABAfQAAABAAABQAAAAAAABQgBAAAAABQAAAAAAAAIgGABQgGABgcAAQgcAAgIgBg',
      );
    this.shape_16.setTransform(-88.3, 0.6);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_17.setTransform(-5.95, 0.175);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_18.setTransform(-6.65, 0.45);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_19.setTransform(-6.625, 0.225);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_20.setTransform(-4.8, 1.125);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        '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',
      );
    this.shape_21.setTransform(-4.425, 3.475);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_4 }] }, 1)
        .to({ state: [{ t: this.shape_5 }] }, 1)
        .to({ state: [{ t: this.shape_6 }] }, 1)
        .to({ state: [{ t: this.shape_7 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_14 },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9 },
              { t: this.shape_8 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_17 }] }, 11)
        .to({ state: [{ t: this.shape_18 }] }, 1)
        .to({ state: [{ t: this.shape_19 }] }, 1)
        .to({ state: [{ t: this.shape_20 }] }, 1)
        .to({ state: [{ t: this.shape_21 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-102.7, -24.4, 191.8, 51.2);

  (lib.verticalMeter = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1),
    );

    // Layer 3
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#D0DA4F').ss(1, 1, 1).p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape.setTransform(16.5, 139.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#D0DA4F').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_1.setTransform(16.5, 139.6);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#D0DA4F')
      .ss(1, 1, 1)
      .p('Ah8gLID5AAIAAAXIj5AAg');
    this.shape_2.setTransform(16.5, 210.05);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f('#D0DA4F').s().p('Ah8AMIAAgXID5AAIAAAXg');
    this.shape_3.setTransform(16.5, 210.05);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f()
      .s('#D0DA4F')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_4.setTransform(16.5, 69);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#D0DA4F').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_5.setTransform(16.5, 69);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f()
      .s('#FFFFFF')
      .ss(1, 1, 1)
      .p(
        'AiG2AIENAAIAAK8IkNAAgAiGq/IENAAIAAK8IkNAAgAiGAEIENAAIAAK8IkNAAgAiGLFIENAAIAAK8IkNAAg',
      );
    this.shape_6.setTransform(16.5, 139.85);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#D0DA4F')
      .s()
      .p(
        'AiGWBIAAq8IENAAIAAK8gAiGLAIAAq8IENAAIAAK8gAiGgDIAAq8IENAAIAAK8gAiGrEIAAq7IENAAIAAK7g',
      );
    this.shape_7.setTransform(16.5, 139.85);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f()
      .s('#BBE42E')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_8.setTransform(16.5, 139.6);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics.f('#BBE42E').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_9.setTransform(16.5, 139.6);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f()
      .s('#BBE42E')
      .ss(1, 1, 1)
      .p('Ah8gLID5AAIAAAXIj5AAg');
    this.shape_10.setTransform(16.5, 210.05);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics.f('#BBE42E').s().p('Ah8AMIAAgXID5AAIAAAXg');
    this.shape_11.setTransform(16.5, 210.05);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f()
      .s('#BBE42E')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_12.setTransform(16.5, 69);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics.f('#BBE42E').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_13.setTransform(16.5, 69);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#BBE42E')
      .s()
      .p(
        'AiGWBIAAq8IENAAIAAK8gAiGLAIAAq8IENAAIAAK8gAiGgDIAAq8IENAAIAAK8gAiGrEIAAq7IENAAIAAK7g',
      );
    this.shape_14.setTransform(16.5, 139.85);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#E8EDA7')
      .s()
      .p(
        'AiGWBIAAq8IENAAIAAK8gAiGLAIAAq8IENAAIAAK8gAiGgDIAAq8IENAAIAAK8gAiGrEIAAq7IENAAIAAK7g',
      );
    this.shape_15.setTransform(16.5, 139.85);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#E8EDA7')
      .s()
      .p('AiGQgIAAq8IENAAIAAK8gAiGFcIAAq6IENAAIAAK6gAiGlkIAAq7IENAAIAAK7g');
    this.shape_16.setTransform(16.5, 104.6);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics.f('#7AA8F9').s().p('AiGFeIAAq7IENAAIAAK7g');
    this.shape_17.setTransform(16.5, 245.725);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#E8EDA7')
      .s()
      .p('AiGK+IAAq7IENAAIAAK7gAiGgCIAAq7IENAAIAAK7g');
    this.shape_18.setTransform(16.5, 69.225);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#7AA8F9')
      .s()
      .p('AiGK+IAAq7IENAAIAAK7gAiGgCIAAq7IENAAIAAK7g');
    this.shape_19.setTransform(16.5, 210.475);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics.f('#E8EDA7').s().p('AiGFeIAAq7IENAAIAAK7g');
    this.shape_20.setTransform(16.5, 33.975);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#7AA8F9')
      .s()
      .p('AiGQgIAAq7IENAAIAAK7gAiGFfIAAq7IENAAIAAK7gAiGlkIAAq7IENAAIAAK7g');
    this.shape_21.setTransform(16.5, 175.1);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#7AA8F9')
      .s()
      .p(
        'AiGWBIAAq8IENAAIAAK8gAiGLAIAAq8IENAAIAAK8gAiGgDIAAq8IENAAIAAK8gAiGrEIAAq7IENAAIAAK7g',
      );
    this.shape_22.setTransform(16.5, 139.85);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f()
      .s('#E8EDA7')
      .ss(1, 1, 1)
      .p('Ah8gLID5AAIAAAXIj5AAg');
    this.shape_23.setTransform(16.5, 210.05);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics.f('#E8EDA7').s().p('Ah8AMIAAgXID5AAIAAAXg');
    this.shape_24.setTransform(16.5, 210.05);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f()
      .s('#E8EDA7')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_25.setTransform(16.5, 69);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics.f('#E8EDA7').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_26.setTransform(16.5, 69);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f()
      .s('#7AA8F9')
      .ss(1, 1, 1)
      .p('Ah8gLID5AAIAAAXIj5AAg');
    this.shape_27.setTransform(16.5, 210.05);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics.f('#7AA8F9').s().p('Ah8AMIAAgXID5AAIAAAXg');
    this.shape_28.setTransform(16.5, 210.05);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f()
      .s('#7AA8F9')
      .ss(1, 1, 1)
      .p('Ah8gRID5AAIAAAjIj5AAg');
    this.shape_29.setTransform(16.5, 69);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics.f('#7AA8F9').s().p('Ah8ARIAAgiID5AAIAAAig');
    this.shape_30.setTransform(16.5, 69);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_14 },
              { t: this.shape_6 },
              { t: this.shape_13 },
              { t: this.shape_12 },
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9 },
              { t: this.shape_8 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_15 }, { t: this.shape_6 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_19 },
              { t: this.shape_18 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_21 },
              { t: this.shape_20 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to({ state: [{ t: this.shape_22 }, { t: this.shape_6 }] }, 1)
        .to(
          {
            state: [
              { t: this.shape_15 },
              { t: this.shape_6 },
              { t: this.shape_26 },
              { t: this.shape_25 },
              { t: this.shape_24 },
              { t: this.shape_23 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_19 },
              { t: this.shape_18 },
              { t: this.shape_6 },
              { t: this.shape_26 },
              { t: this.shape_25 },
              { t: this.shape_28 },
              { t: this.shape_27 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_22 },
              { t: this.shape_6 },
              { t: this.shape_30 },
              { t: this.shape_29 },
              { t: this.shape_28 },
              { t: this.shape_27 },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(2, -2, 29, 283.7);

  (lib.TestWindow = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      /* this.stop();*/
    };
    this.frame_1 = function () {
      /* this.stop();*/
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 0, 0);

  (lib.ruletext = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#000000').s().p('AgGAIIAAgPIANAAIAAAPg');
    this.shape.setTransform(16.6, 20.925);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgQQAAgQAJgJQAJgJANAAQAOAAAHAIQAHAHAAAPIAAAFIgvAAQAAAFABAFQACAEADAEQADACAFABQADACAFAAQAHAAAGgDIAKgFIABAAIAAAMIgMAEIgMABQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgIgEgGQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_1.setTransform(10.825, 18.45);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AAlAiIAAglIgBgIIgBgGIgEgEQgDgBgFAAQgEAAgFACIgJAGIAAADIAAAEIAAApIgKAAIAAglIAAgIQAAgEgCgCQgBgDgDgBQgCgBgFAAQgEAAgFACIgJAGIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAGgDAFAAQAHAAAFADQADADADAFQAGgGAGgCQAFgDAHAAQAKAAAGAHQAFAHAAALIAAAqg',
      );
    this.shape_2.setTransform(1.475, 18.375);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAcQgGgGAAgIQAAgIAEgFQADgDAGgDQAGgCAIgCIARAAIAAgCIgBgHIgEgDIgGgDIgGAAIgJABIgLAEIgBAAIAAgLIAJgDIAMgBIAMABQAFACADADQAEACACAFQACAEAAAGIAAAsIgLAAIAAgHIgEACIgFADIgGADIgIABQgIAAgHgHgAAFAAIgKAAQgEACgDADQgDADAAAFQAAAFADADQAEADAGAAQAFAAAFgCIAJgFIAAgSIgMABg',
      );
    this.shape_3.setTransform(-8.225, 18.5);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'AgOAhIgLgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAEgDABgFQgBgEgCgCQgCgCgGgBIgGgBIgHgCQgIgCgDgDQgEgFgBgGQABgEACgEQABgDADgDQAEgDAFgCQAFgBAFAAIAMABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEACACQADACAGACIAGABIAFABQAIACAFADQADAFAAAHQAAAJgHAGQgHAFgMAAQgIAAgFgBg',
      );
    this.shape_4.setTransform(-14.6, 18.475);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAaQgKgJAAgRQAAgOAJgKQAJgKANAAQAOABAHAHQAHAIAAAPIAAAEIgvAAQAAAHABAEQACAEADADQADADAFACQADABAFAAQAHAAAGgCIAKgGIABAAIAAAMIgMAEIgMACQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgJgEgEQgFgFgIAAQgIAAgFAFg',
      );
    this.shape_5.setTransform(43.825, 1.95);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAtIAAglIAAgIIgCgFQgCgDgCgBQgDgBgFgBQgDABgFACQgFACgEAEIAAAvIgLAAIAAhaIALAAIAAAiQAFgFAFgDQAFgCAGAAQAKAAAGAHQAFAGAAALIAAAqg',
      );
    this.shape_6.setTransform(36.475, 0.7);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAmQgFgGAAgMIAAgiIgIAAIAAgJIAIAAIAAgTIALAAIAAATIAWAAIAAAJIgWAAIAAAdIAAAIQAAADABADIADADIAHABIAGgBIAEgBIABAAIAAAKIgHABIgHABQgJAAgFgFg',
      );
    this.shape_7.setTransform(30.325, 1.1);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AgOAhIgKgEIAAgNIAAAAQAFAEAHADQAGACAGAAQAGAAAEgCQAEgDAAgFQABgEgDgCQgCgCgGgBIgGgBIgHgCQgIgCgEgDQgDgFAAgGQAAgEACgEQABgDADgDQAEgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIgBAAQgEgDgGgCQgGgCgFAAQgGAAgEACQgEADAAAEQAAAEACACQADACAFACIAHABIAGABQAIACAEADQADAFAAAHQABAJgIAGQgHAFgMAAQgIAAgFgBg',
      );
    this.shape_8.setTransform(20.7, 1.975);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p('AgRAtIAMgbIgag+IAMAAIATAwIAVgwIALAAIglBZg');
    this.shape_9.setTransform(13.95, 3.175);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAdQgGgHAAgJQAAgHAEgEQADgEAGgDQAGgDAIAAIARgBIAAgDIgBgFIgEgFIgGgCIgGAAIgJABIgLADIgBAAIAAgLIAJgCIAMAAIAMAAQAFACADACQAEADACAEQACAFAAAGIAAArIgLAAIAAgGIgEADIgFACIgGACIgIACQgIgBgHgFgAAFAAIgKABQgEABgDADQgDADAAAFQAAAFADADQAEADAGAAQAFAAAFgCIAJgFIAAgSIgMABg',
      );
    this.shape_10.setTransform(6.675, 2);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAmQgFgGAAgMIAAgiIgIAAIAAgJIAIAAIAAgTIALAAIAAATIAWAAIAAAJIgWAAIAAAdIAAAIQAAADABADIADADIAHABIAGgBIAEgBIABAAIAAAKIgHABIgHABQgJAAgFgFg',
      );
    this.shape_11.setTransform(0.975, 1.1);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAFgDAAgFQAAgEgDgCQgCgCgHgBIgEgBIgIgCQgIgCgDgDQgFgFAAgGQAAgEACgEQACgDADgDQAEgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAFABIAGABQAJACADADQAFAFAAAHQgBAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_12.setTransform(-4.45, 1.975);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAmQgFgGAAgMIAAgiIgIAAIAAgJIAIAAIAAgTIALAAIAAATIAWAAIAAAJIgWAAIAAAdIAAAIQAAADABADIADADIAHABIAGgBIAEgBIABAAIAAAKIgHABIgHABQgJAAgFgFg',
      );
    this.shape_13.setTransform(-14.175, 1.1);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AgFAsIAAhAIAKAAIAABAgAgFggIAAgLIALAAIAAALg');
    this.shape_14.setTransform(-18.25, 0.85);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAmQgHgKAAgPQAAgJACgGQADgGAEgEQAEgFAFgDQAFgCAFAAQAFAAAEABIAJADIAAgcIALAAIAABaIgLAAIAAgGIgKAGQgFADgFAAQgMgBgHgIgAgLgFQgGAFAAAMQAAAMAEAGQAEAGAJAAQAEAAAFgCIAJgFIAAglIgIgDIgIgBQgIABgFAGg',
      );
    this.shape_15.setTransform(-28.075, 0.8);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAiIAAglIAAgIIgCgGQgCgDgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAFgDAGAAQAKAAAGAHQAFAGAAAMIAAAqg',
      );
    this.shape_16.setTransform(-35.375, 1.875);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAdQgGgHAAgJQAAgHAEgEQADgEAGgDQAGgDAIAAIARgBIAAgDIgBgFIgEgFIgGgCIgGAAIgJABIgLADIgBAAIAAgLIAJgCIAMAAIAMAAQAFACADACQAEADACAEQACAFAAAGIAAArIgLAAIAAgGIgEADIgFACIgGACIgIACQgIgBgHgFgAAFAAIgKABQgEABgDADQgDADAAAFQAAAFADADQAEADAGAAQAFAAAFgCIAJgFIAAgSIgMABg',
      );
    this.shape_17.setTransform(-43.025, 2);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAhIAAhBIALAAIAAAKQAGgFAEgCQAFgDAFAAIAFAAIADABIAAALIAAAAIgFgBIgFAAQgGAAgEACIgIAGIAAAug',
      );
    this.shape_18.setTransform(55.275, -14.525);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAaQgKgJAAgQQAAgQAJgJQAJgKANAAQAOAAAHAJQAHAHAAAOIAAAFIgvAAQAAAGABAFQACAFADACQADADAFABQADACAFAAQAHAAAGgDQAHgDADgCIABAAIAAAMIgMAEIgMACQgPgBgJgIgAgLgTQgGAFAAAIIAkAAQAAgJgEgEQgFgFgIAAQgIAAgFAFg',
      );
    this.shape_19.setTransform(48.575, -14.55);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAtIgIgDIgBACIgKAAIAAhZIALAAIAAAgQAFgEAFgCQAFgDAGAAQALAAAHAJQAHAJAAAPQAAAJgDAGQgCAGgEAFQgEAEgFADQgFADgGgBQgFABgEgCgAgIgJIgJAFIAAAlQAFACADAAIAIABQAIABAFgHQAFgGAAgNQAAgLgEgFQgDgHgJABQgEAAgFACg',
      );
    this.shape_20.setTransform(41.475, -15.7);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AAlAiIAAglIgBgIIgBgGIgEgEQgDgBgFAAQgEAAgFACIgJAGIAAADIAAAEIAAApIgKAAIAAglIAAgIQAAgEgCgCQgBgDgDgBQgCgBgFAAQgEAAgFACIgJAGIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAGgDAFAAQAHAAAFADQADADADAFQAGgGAGgCQAFgDAHAAQAKAAAGAHQAFAHAAALIAAAqg',
      );
    this.shape_21.setTransform(31.725, -14.625);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAbQgFgGAAgMIAAgqIALAAIAAAlIAAAIIACAGQACADACABQADABAFAAQADAAAFgCQAFgCAEgEIAAgwIALAAIAABBIgLAAIAAgIIgKAHQgFADgGAAQgKAAgGgHg',
      );
    this.shape_22.setTransform(22.025, -14.425);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAiIAAglIAAgIIgCgGQgCgDgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAFgDAGAAQAKAAAGAHQAFAGAAAMIAAAqg',
      );
    this.shape_23.setTransform(14.475, -14.625);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAdQgGgGAAgJQAAgIAEgEQADgEAGgDQAGgDAIgBIARgBIAAgCIgBgGIgEgDIgGgCIgGgBIgJACIgLACIgBAAIAAgKIAJgCIAMgBIAMABQAFABADACQAEADACAFQACAEAAAGIAAArIgLAAIAAgHIgEAEIgFACIgGACIgIABQgIAAgHgFgAAFAAIgKAAQgEACgDADQgDADAAAFQAAAGADADQAEACAGAAQAFAAAFgCIAJgGIAAgRIgMABg',
      );
    this.shape_24.setTransform(2.625, -14.5);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAZQgIgJAAgQQAAgPAIgJQAIgKANAAQAOAAAIAKQAIAJAAAPQAAAQgIAJQgIAKgOAAQgNAAgIgKgAgNgSQgFAGAAAMQAAAMAFAHQAFAGAIAAQAJAAAFgGQAFgHAAgMQAAgMgFgGQgFgGgJAAQgIAAgFAGg',
      );
    this.shape_25.setTransform(-8.625, -14.525);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAmQgFgGAAgMIAAghIgIAAIAAgKIAIAAIAAgTIALAAIAAATIAWAAIAAAKIgWAAIAAAcIAAAIQAAADABADIADADIAHABIAGgBIAEgBIABAAIAAAKIgHABIgHABQgJAAgFgFg',
      );
    this.shape_26.setTransform(-14.575, -15.4);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgXAHgLQAHgKAPgBQAQAAAHAMQAHALAAAWQAAAXgHALQgIAMgPgBQgPAAgHgLgAgIghQgEADgCAEQgCAFgBAGIAAAPIAAAQQABAFACAFQACAFAEACQADADAFgBQAFAAAEgBQAEgDACgFIADgKIAAgQIAAgPIgDgLQgCgEgEgDQgDgCgGAAQgFAAgDACg',
      );
    this.shape_27.setTransform(-25.025, -15.6);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAlQgHgIAAgRQAAgIACgFQADgHAEgEQAEgFAFgCQAFgDAFAAQAFAAAEACIAJACIAAgbIALAAIAABZIgLAAIAAgHIgKAHQgFADgFgBQgMABgHgKgAgLgFQgGAFAAAMQAAALAEAHQAEAGAJAAQAEAAAFgCIAJgGIAAgkIgIgDIgIAAQgIgBgFAHg',
      );
    this.shape_28.setTransform(-37.025, -15.7);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAlQgHgIAAgRQAAgIACgFQADgHAEgEQAEgFAFgCQAFgDAFAAQAFAAAEACIAJACIAAgbIALAAIAABZIgLAAIAAgHIgKAHQgFADgFgBQgMABgHgKgAgLgFQgGAFAAAMQAAALAEAHQAEAGAJAAQAEAAAFgCIAJgGIAAgkIgIgDIgIAAQgIgBgFAHg',
      );
    this.shape_29.setTransform(-44.525, -15.7);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#000000')
      .s()
      .p('AAbArIgJgYIgkAAIgJAYIgLAAIAfhWIAPAAIAfBWgAgPAJIAeAAIgPgqg');
    this.shape_30.setTransform(-52.15, -15.6);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAaQgKgJAAgQQAAgQAJgJQAJgKANAAQAOAAAHAJQAHAHAAAOIAAAFIgvAAQAAAGABAFQACAFADACQADADAFABQADACAFAAQAHAAAGgDIAKgFIABAAIAAAMIgMAEIgMACQgPgBgJgIgAgLgTQgGAFAAAIIAkAAQAAgJgEgEQgFgFgIAAQgIAAgFAFg',
      );
    this.shape_31.setTransform(30.825, 34.95);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhBIAJAAIAABBgAgFgfIAAgMIALAAIAAAMg');
    this.shape_32.setTransform(18, 33.85);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics.f('#000000').s().p('AgFAtIAAhZIAKAAIAABZg');
    this.shape_33.setTransform(14.7, 33.7);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAtIgIgDIgBADIgKAAIAAhaIALAAIAAAgQAFgEAFgCQAFgDAGAAQALAAAHAJQAHAJAAAPQAAAJgDAGQgCAGgEAFQgEAEgFADQgFADgGgBQgFABgEgCgAgIgJIgJAFIAAAlQAFACADAAIAIABQAIABAFgHQAFgGAAgNQAAgLgEgFQgDgHgJABQgEAAgFACg',
      );
    this.shape_34.setTransform(-6.925, 33.8);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAuIAAgmIAAgIIgCgFQgCgDgCgBQgDgCgFAAQgDAAgFADQgFACgEADIAAAxIgLAAIAAhaIALAAIAAAgQAFgEAFgDQAFgCAGAAQAKAAAGAHQAFAGAAALIAAArg',
      );
    this.shape_35.setTransform(50.375, 17.2);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAlQgFgFAAgMIAAgiIgIAAIAAgJIAIAAIAAgTIALAAIAAATIAWAAIAAAJIgWAAIAAAdIAAAIQAAADABACIADAEIAHABIAGAAIAEgCIABAAIAAAKIgHACIgHAAQgJAAgFgGg',
      );
    this.shape_36.setTransform(44.225, 17.6);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAiIAAglIAAgIIgCgGQgCgDgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAFgDAGAAQAKAAAGAHQAFAGAAAMIAAAqg',
      );
    this.shape_37.setTransform(33.825, 18.375);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAhIAAhBIALAAIAAAKQAGgFAEgCQAFgDAFAAIAFAAIADABIAAALIAAAAIgFgBIgFAAQgGAAgEACIgIAGIAAAug',
      );
    this.shape_38.setTransform(16.525, 18.475);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgQQAAgQAJgJQAJgJANAAQAOAAAHAIQAHAHAAAPIAAAFIgvAAQAAAFABAFQACAEADAEQADACAFABQADACAFAAQAHAAAGgDIAKgFIABAAIAAAMIgMAEIgMABQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgIgEgGQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_39.setTransform(9.825, 18.45);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAtIgIgEIgBAEIgKAAIAAhaIALAAIAAAgQAFgEAFgDQAFgCAGAAQALAAAHAJQAHAJAAAPQAAAJgDAGQgCAHgEAEQgEAFgFACQgFACgGABQgFgBgEgBgAgIgJIgJAFIAAAkQAFADADABIAIABQAIAAAFgHQAFgFAAgOQAAgLgEgFQgDgHgJAAQgEAAgFADg',
      );
    this.shape_40.setTransform(2.725, 17.3);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAbQgFgGAAgMIAAgqIALAAIAAAlIAAAIIACAGQACADACABQADABAFAAQADAAAFgCQAFgCAEgEIAAgwIALAAIAABBIgLAAIAAgIIgKAHQgFADgGAAQgKAAgGgHg',
      );
    this.shape_41.setTransform(-16.725, 18.575);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f('#000000')
      .s()
      .p('AATAsIgphOIAABOIgLAAIAAhWIASAAIAlBGIAAhGIALAAIAABWg');
    this.shape_42.setTransform(-25, 17.4);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAlQgFgFAAgMIAAgiIgIAAIAAgJIAIAAIAAgTIALAAIAAATIAWAAIAAAJIgWAAIAAAdIAAAIQAAADABACIADAEIAHABIAGAAIAEgCIABAAIAAAKIgHACIgHAAQgJAAgFgGg',
      );
    this.shape_43.setTransform(-36.025, 17.6);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f('#000000')
      .s()
      .p('AASAhIgSgZIgSAZIgNAAIAZghIgZggIAOAAIASAZIASgZIANAAIgZAgIAZAhg');
    this.shape_44.setTransform(-42, 18.475);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgQQAAgQAJgJQAJgJANAAQAOAAAHAIQAHAHAAAPIAAAFIgvAAQAAAFABAFQACAEADAEQADACAFABQADACAFAAQAHAAAGgDIAKgFIABAAIAAAMIgMAEIgMABQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgIgEgGQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_45.setTransform(-49.125, 18.45);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAiIAAglIAAgIIgCgGQgCgDgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAFgDAGAAQAKAAAGAHQAFAGAAAMIAAAqg',
      );
    this.shape_46.setTransform(-56.475, 18.375);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAEgDABgFQgBgEgCgCQgCgCgGgBIgFgBIgIgCQgIgCgDgDQgFgFAAgGQAAgEADgEQABgDADgDQAEgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAGABIAFABQAIACAFADQAEAFgBAHQAAAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_47.setTransform(30.3, 1.975);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhAIAKAAIAABAgAgFggIAAgLIALAAIAAALg');
    this.shape_48.setTransform(25.45, 0.85);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f('#000000')
      .s()
      .p(
        'AAlAiIAAglIgBgIIgBgGIgEgEQgDgBgFAAQgEAAgFACIgJAGIAAADIAAAEIAAApIgKAAIAAglIAAgIQAAgEgCgCQgBgDgDgBQgCgBgFAAQgEAAgFACIgJAGIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAGgDAFAAQAHAAAFADQADADADAFQAGgGAGgCQAFgDAHAAQAKAAAGAHQAFAHAAALIAAAqg',
      );
    this.shape_49.setTransform(13.825, 1.875);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAbQgFgGAAgMIAAgqIALAAIAAAlIAAAIIACAGQACADACABQADABAFAAQADAAAFgCQAFgCAEgEIAAgwIALAAIAABBIgLAAIAAgIIgKAHQgFADgGAAQgKAAgGgHg',
      );
    this.shape_50.setTransform(4.125, 2.075);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAaQgKgJAAgRQAAgOAJgKQAJgKANAAQAOABAHAHQAHAIAAAPIAAAEIgvAAQAAAHABAEQACAEADADQADADAFACQADABAFAAQAHAAAGgCIAKgGIABAAIAAAMIgMAEIgMACQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgJgEgEQgFgFgIAAQgIAAgFAFg',
      );
    this.shape_51.setTransform(-13.625, 1.95);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAtIAAglIAAgIIgCgFQgCgDgCgBQgDgBgFgBQgDABgFACQgFACgEAEIAAAvIgLAAIAAhaIALAAIAAAiQAFgFAFgDQAFgCAGAAQAKAAAGAHQAFAGAAALIAAAqg',
      );
    this.shape_52.setTransform(-20.975, 0.7);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAiIAAglIAAgIIgCgGQgCgDgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAFgDAGAAQAKAAAGAHQAFAGAAAMIAAAqg',
      );
    this.shape_53.setTransform(-45.025, 1.875);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAhIAAhBIALAAIAAAKQAGgFAEgCQAFgDAFAAIAFAAIADABIAAALIAAAAIgFgBIgFAAQgGAAgEACIgIAGIAAAug',
      );
    this.shape_54.setTransform(55.275, -14.525);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAaQgKgJAAgQQAAgQAJgJQAJgKANAAQAOAAAHAJQAHAHAAAOIAAAFIgvAAQAAAGABAFQACAFADACQADADAFABQADACAFAAQAHAAAGgDQAHgDADgCIABAAIAAAMIgMAEIgMACQgPgBgJgIgAgLgTQgGAFAAAIIAkAAQAAgJgEgEQgFgFgIAAQgIAAgFAFg',
      );
    this.shape_55.setTransform(48.575, -14.55);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f('#000000')
      .s()
      .p(
        'AAlAiIAAglIgBgIIgBgGIgEgEQgDgBgFAAQgEAAgFACIgJAGIAAADIAAAEIAAApIgKAAIAAglIAAgIQAAgEgCgCQgBgDgDgBQgCgBgFAAQgEAAgFACIgJAGIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAGgDAFAAQAHAAAFADQADADADAFQAGgGAGgCQAFgDAHAAQAKAAAGAHQAFAHAAALIAAAqg',
      );
    this.shape_56.setTransform(31.725, -14.625);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAbQgFgGAAgMIAAgqIALAAIAAAlIAAAIIACAGQACADACABQADABAFAAQADAAAFgCQAFgCAEgEIAAgwIALAAIAABBIgLAAIAAgIIgKAHQgFADgGAAQgKAAgGgHg',
      );
    this.shape_57.setTransform(22.025, -14.425);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAiIAAglIAAgIIgCgGQgCgDgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAFgDAGAAQAKAAAGAHQAFAGAAAMIAAAqg',
      );
    this.shape_58.setTransform(14.475, -14.625);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAZQgIgJAAgQQAAgPAIgJQAIgKANAAQAOAAAIAKQAIAJAAAPQAAAQgIAJQgIAKgOAAQgNAAgIgKgAgNgSQgFAGAAAMQAAAMAFAHQAFAGAIAAQAJAAAFgGQAFgHAAgMQAAgMgFgGQgFgGgJAAQgIAAgFAGg',
      );
    this.shape_59.setTransform(-8.625, -14.525);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAsIAAgJIASAAIAAg6IgSAAIAAgIIAHAAQAEgBACgBQAEgBABgDQABgCAAgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_60.setTransform(-24.85, -15.625);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgQQAAgQAJgJQAJgJANAAQAOAAAHAIQAHAHAAAPIAAAFIgvAAQAAAFABAFQACAEADAEQADACAFABQADACAFAAQAHAAAGgDQAHgCADgDIABAAIAAAMIgMAEIgMABQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgIgEgGQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_61.setTransform(44.375, 18.45);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAFgDAAgFQAAgEgDgCQgCgCgHgBIgEgBIgHgCQgJgCgDgDQgFgFAAgGQAAgEACgEQACgDAEgDQADgDAFgCQAFgBAFAAIAMABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAFABIAGABQAJACADADQAFAFAAAHQgBAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_62.setTransform(18.95, 18.475);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAEgDABgFQgBgEgCgCQgCgCgGgBIgFgBIgIgCQgIgCgDgDQgFgFAAgGQAAgEADgEQABgDADgDQAEgDAFgCQAFgBAFAAIAMABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAGABIAFABQAIACAFADQADAFAAAHQAAAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_63.setTransform(-15.15, 18.475);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhAIAKAAIAABAgAgFgfIAAgMIALAAIAAAMg');
    this.shape_64.setTransform(-20, 17.35);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAFgDAAgFQAAgEgDgCQgCgCgHgBIgEgBIgIgCQgIgCgDgDQgFgFAAgGQAAgEACgEQACgDADgDQAEgDAFgCQAFgBAFAAIAMABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAFABIAGABQAJACADADQAFAFAAAHQgBAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_65.setTransform(-48.1, 18.475);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAmQgHgKAAgPQAAgJACgGQADgGAEgEQAEgFAFgDQAFgCAFAAQAFAAAEABIAJADIAAgcIALAAIAABaIgLAAIAAgGIgKAGQgFADgFAAQgMgBgHgIgAgLgFQgGAFAAAMQAAAMAEAGQAEAGAJAAQAEAAAFgCIAJgFIAAglIgIgDIgIgBQgIABgFAGg',
      );
    this.shape_66.setTransform(-11.775, 0.8);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhBIAJAAIAABBgAgFggIAAgLIALAAIAAALg');
    this.shape_67.setTransform(50.75, -15.65);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAFgDAAgFQAAgEgDgCQgCgCgHgBIgEgBIgHgCQgJgCgDgDQgFgFAAgGQAAgEACgEQACgDADgDQAEgDAFgCQAFgBAFAAIAMABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAFABIAGABQAJACADADQAFAFAAAHQgBAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_68.setTransform(41.9, -14.525);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAtIAAglIAAgIIgCgGQgCgCgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAvIgLAAIAAhZIALAAIAAAhQAFgFAFgCQAFgDAGAAQAKAAAGAGQAFAHAAALIAAAqg',
      );
    this.shape_69.setTransform(-23.025, -15.8);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f('#000000')
      .s()
      .p('AAbArIgIgYIglAAIgJAYIgMAAIAhhWIAOAAIAgBWgAgOAJIAdAAIgPgqg');
    this.shape_70.setTransform(-54.9, -15.6);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgWAHgMQAHgLAPABQAQAAAHALQAHALAAAWQAAAYgHALQgIAKgPABQgPAAgHgMgAgIghQgEADgCAFQgCAEgBAGIAAAPIAAAQQABAFACAGQACAEAEACQADACAFABQAFAAAEgCQAEgDACgEIADgLIAAgQIAAgPIgDgLQgCgFgEgCQgDgCgGAAQgFAAgDACg',
      );
    this.shape_71.setTransform(26.125, 17.4);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAsIAAgJIASAAIAAg6IgSAAIAAgIIAIAAQAFgBACgBQADgBABgDQABgCAAgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_72.setTransform(18.65, 17.375);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f('#000000')
      .s()
      .p('AghAXIA1gXIg1gWIAAgLIBDAeIAAAHIhDAeg');
    this.shape_73.setTransform(5.6, 17.925);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAGADQAHACAGAAQAGAAAEgCQAFgDgBgFQAAgEgCgCQgCgCgHgBIgEgBIgHgCQgJgCgEgDQgEgFAAgGQAAgEACgEQACgDAEgDQADgDAFgCQAFgBAFAAIAMABIAKAEIAAALIgBAAQgEgDgGgCQgGgCgFAAQgFAAgFACQgEADAAAEQAAAEADACQACACAFACIAGABIAHABQAHACAEADQAFAFAAAHQAAAJgIAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_74.setTransform(-25.8, 18.475);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAFgDAAgFQAAgEgDgCQgCgCgHgBIgEgBIgIgCQgIgCgDgDQgFgFAAgGQAAgEACgEQACgDAEgDQADgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAFABIAGABQAJACADADQAFAFAAAHQgBAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_75.setTransform(37.85, 1.975);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f('#000000')
      .s()
      .p('AARAhIgRgyIgPAyIgKAAIgShBIAMAAIALAyIARgyIAIAAIARAyIALgyIALAAIgRBBg');
    this.shape_76.setTransform(14.85, 1.975);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAtIgIgEIgBADIgKAAIAAhaIALAAIAAAhQAFgEAFgDQAFgCAGAAQALAAAHAJQAHAJAAAQQAAAHgDAHQgCAGgEAFQgEAEgFADQgFADgGAAQgFAAgEgCgAgIgJIgJAFIAAAkQAFADADAAIAIABQAIAAAFgFQAFgHAAgMQAAgMgEgFQgDgGgJgBQgEABgFACg',
      );
    this.shape_77.setTransform(-16.225, 0.8);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhBIAKAAIAABBgAgFggIAAgLIALAAIAAALg');
    this.shape_78.setTransform(54.25, -15.65);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f('#000000')
      .s()
      .p(
        'AgLAtIgKgCIAAgLIABAAIAIADQAGABAGAAQAEAAAEgBIAGgEIADgFIABgIIAAgGIgKAGQgEACgGAAQgMAAgHgIQgHgJAAgOQAAgJACgGQADgGAEgEQAEgEAFgDQAGgCAEAAQAGAAAEABIAIAEIAAgDIALAAIAAA5QAAAQgIAIQgHAIgPAAIgKgBgAgLgdQgGAGAAAMQAAALAEAEQAEAGAJAAQAEAAAFgCIAJgFIAAgiIgIgDIgIgBQgIAAgFAGg',
      );
    this.shape_79.setTransform(48.625, -13.375);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhBIAKAAIAABBgAgFggIAAgLIALAAIAAALg');
    this.shape_80.setTransform(43.45, -15.65);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics.f('#000000').s().p('AgRAFIAAgJIAjAAIAAAJg');
    this.shape_81.setTransform(31.575, -15.075);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics.f('#000000').s().p('AgEAtIAAhZIAKAAIAABZg');
    this.shape_82.setTransform(20.05, -15.8);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f('#000000')
      .s()
      .p(
        'AgLAtIgKgCIAAgLIABAAIAIADQAGABAGAAQAEAAAEgBIAGgEIADgFIABgIIAAgGIgKAGQgEACgGAAQgMAAgHgIQgHgJAAgOQAAgJACgGQADgGAEgEQAEgEAFgDQAGgCAEAAQAGAAAEABIAIAEIAAgDIALAAIAAA5QAAAQgIAIQgHAIgPAAIgKgBgAgLgdQgGAGAAAMQAAALAEAEQAEAGAJAAQAEAAAFgCIAJgFIAAgiIgIgDIgIgBQgIAAgFAGg',
      );
    this.shape_83.setTransform(14.425, -13.375);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f('#000000')
      .s()
      .p('AgFAsIAAhBIAKAAIAABBgAgFggIAAgLIALAAIAAALg');
    this.shape_84.setTransform(1.65, -15.65);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f('#000000')
      .s()
      .p('AARAhIgRgyIgPAyIgLAAIgRhBIAMAAIALAyIARgyIAIAAIARAyIALgyIALAAIgRBBg');
    this.shape_85.setTransform(-22.6, -14.525);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAmQgFgGAAgMIAAghIgIAAIAAgKIAIAAIAAgTIALAAIAAATIAWAAIAAAKIgWAAIAAAcIAAAIQAAADABADIADADIAHABIAGgBIAEgBIABAAIAAAKIgHABIgHABQgJAAgFgFg',
      );
    this.shape_86.setTransform(-29.825, -15.4);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAlQgHgIAAgRQAAgIACgFQADgHAEgEQAEgFAFgCQAFgDAFAAQAFAAAEACIAJACIAAgbIALAAIAABZIgLAAIAAgHIgKAHQgFADgFgBQgMABgHgKgAgLgFQgGAFAAAMQAAALAEAHQAEAGAJAAQAEAAAFgCIAJgGIAAgkIgIgDIgIAAQgIgBgFAHg',
      );
    this.shape_87.setTransform(-47.925, -15.7);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f('#000000')
      .s()
      .p('AAbArIgJgYIgkAAIgJAYIgLAAIAfhWIAPAAIAgBWgAgOAJIAdAAIgPgqg');
    this.shape_88.setTransform(-55.55, -15.6);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f('#000000')
      .s()
      .p(
        'AgGAgQgGgCgEgEQgEgEgDgHQgDgGABgJQgBgPAKgJQAJgJANAAIALABIAKAEIAAAMIgBAAIgKgGQgFgCgGAAQgIAAgFAHQgGAGAAALQAAAMAGAGQAFAHAIAAIAHgBIAHgCIAEgDIADgCIABAAIAAAMIgKAEQgGABgFAAQgHAAgFgCg',
      );
    this.shape_89.setTransform(21, 18.475);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics.f('#000000').s().p('AgEAuIAAhaIAJAAIAABag');
    this.shape_90.setTransform(8.9, 17.2);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f('#000000')
      .s()
      .p(
        'AgcAuIAAhZIALAAIAAAHQAFgEAFgCQAFgDAGAAQAMAAAGAJQAHAJAAAQQAAAIgDAGQgCAGgEAFQgEAEgFADQgFACgGAAQgEAAgEgBQgFgBgEgDIAAAcgAgIggIgJAFIAAAlIAIACIAIABQAIAAAFgGQAFgGAAgLQAAgMgEgGQgEgGgIAAQgEAAgFACg',
      );
    this.shape_91.setTransform(3.725, 19.575);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgJgEIAAgNIAAAAQAFAEAGADQAHACAGAAQAGAAAEgCQAFgDgBgFQAAgEgCgCQgCgCgHgBIgFgBIgGgCQgJgCgEgDQgDgFAAgGQAAgEABgEQACgDAEgDQADgDAFgCQAFgBAFAAIAMABIAKAEIAAALIgBAAQgEgDgGgCQgGgCgFAAQgGAAgEACQgEADAAAEQAAAEACACQADACAFACIAGABIAHABQAHACAEADQAEAFABAHQAAAJgIAGQgHAFgMAAQgIAAgGgBg',
      );
    this.shape_92.setTransform(-7.45, 18.475);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAGADQAHACAGAAQAGAAAEgCQAFgDAAgFQAAgEgDgCQgCgCgHgBIgEgBIgHgCQgJgCgDgDQgFgFAAgGQAAgEACgEQACgDAEgDQADgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIgBAAQgEgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAFABIAGABQAJACADADQAFAFAAAHQAAAJgIAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_93.setTransform(19.75, 1.975);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f('#000000')
      .s()
      .p('AgFAsIAAhAIAKAAIAABAgAgFggIAAgLIALAAIAAALg');
    this.shape_94.setTransform(-51.45, 0.85);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics
      .f('#000000')
      .s()
      .p('AARAhIgRgyIgQAyIgKAAIgRhBIALAAIANAyIAQgyIAIAAIAQAyIAMgyIALAAIgRBBg');
    this.shape_95.setTransform(-12.1, -14.525);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f('#000000')
      .s()
      .p('AAbArIgJgYIgkAAIgIAYIgMAAIAfhWIAPAAIAfBWgAgPAJIAeAAIgPgqg');
    this.shape_96.setTransform(-45.05, -15.6);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhAIAJAAIAABAgAgFggIAAgLIALAAIAAALg');
    this.shape_97.setTransform(30.15, 0.85);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhAIAJAAIAABAgAgFggIAAgLIALAAIAAALg');
    this.shape_98.setTransform(19.35, 0.85);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics.f('#000000').s().p('AgEAtIAAhaIAJAAIAABag');
    this.shape_99.setTransform(-4.05, 0.7);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics
      .f('#000000')
      .s()
      .p('AARAhIgRgyIgQAyIgKAAIgRhBIAMAAIAMAyIAQgyIAIAAIARAyIALgyIALAAIgRBBg');
    this.shape_100.setTransform(25.9, -14.525);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f('#000000')
      .s()
      .p('AgRAtIAMgbIgag+IAMAAIATAwIAUgwIAMAAIgmBZg');
    this.shape_101.setTransform(8.5, -13.325);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f('#000000')
      .s()
      .p(
        'AgKArQgGgBgEgFQgFgFgCgHQgDgJAAgLQAAgLACgJQADgIAFgHQAGgHAIgDQAHgFALAAIAGABIAEABIAAALIgBAAIgEgCIgHgBQgLABgIAHQgIAJgBANIAKgFQAEgBAGAAIAKABQAEABAFADQAEADADAFQADAGAAAHQAAANgJAJQgIAIgNAAQgGAAgFgCgAgJgBIgJADIAAADIAAACQAAAKACAGQACAFADADQACACAEABQADACADAAQAIAAAFgFQAFgFAAgKQAAgGgBgDQgDgEgDgDQgDgBgDAAIgGAAIgJAAg',
      );
    this.shape_102.setTransform(25.75, 33.9);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f('#000000')
      .s()
      .p('AgiARIAAgKIBFAAIAAAKgAgigHIAAgJIBFAAIAAAJg');
    this.shape_103.setTransform(12.775, 34.45);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics
      .f('#000000')
      .s()
      .p(
        'AgKArQgFgBgFgFQgEgFgDgHQgDgJAAgLQAAgLACgJQADgIAFgHQAGgHAIgDQAHgFALAAIAFABIAFABIAAALIAAAAIgFgCIgHgBQgMABgHAHQgIAJgBANIAKgFQAEgBAGAAIAKABQAEABAFADQAEADADAFQADAGAAAHQAAANgJAJQgIAIgNAAQgGAAgFgCgAgJgBIgJADIAAADIAAACQAAAKACAGQABAFAEADQADACADABQADACADAAQAIAAAFgFQAFgFAAgKQAAgGgCgDQgBgEgEgDQgDgBgDAAIgGAAIgJAAg',
      );
    this.shape_104.setTransform(-21.6, 33.9);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f('#000000')
      .s()
      .p(
        'AgOAhIgKgEIAAgNIAAAAQAFAEAHADQAGACAGAAQAGAAAEgCQAEgDAAgFQAAgEgCgCQgCgCgGgBIgGgBIgHgCQgIgCgEgDQgDgFAAgGQAAgEACgEQABgDADgDQAEgDAFgCQAFgBAFAAIAMABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgFAAgEACQgEADAAAEQAAAEACACQADACAFACIAHABIAFABQAIACAFADQADAFAAAHQAAAJgHAGQgHAFgMAAQgIAAgFgBg',
      );
    this.shape_105.setTransform(-10.9, 18.475);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgJgEIAAgNIAAAAQAFAEAGADQAHACAGAAQAGAAAEgCQAFgDgBgFQAAgEgCgCQgCgCgHgBIgFgBIgGgCQgJgCgEgDQgDgFAAgGQAAgEABgEQACgDAEgDQADgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIgBAAQgEgDgGgCQgGgCgFAAQgGAAgEACQgEADAAAEQAAAEACACQADACAFACIAGABIAHABQAHACAEADQAEAFABAHQAAAJgIAGQgHAFgMAAQgIAAgGgBg',
      );
    this.shape_106.setTransform(29, 1.975);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f('#000000')
      .s()
      .p('AgRAtIAMgbIgag+IAMAAIATAwIAUgwIAMAAIglBZg');
    this.shape_107.setTransform(22.25, 3.175);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f('#000000')
      .s()
      .p(
        'AgOAhIgLgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAEgDABgFQgBgEgCgCQgCgCgGgBIgGgBIgHgCQgIgCgDgDQgEgFgBgGQABgEACgEQABgDADgDQAEgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAGABIAFABQAIACAFADQADAFAAAHQAAAJgHAGQgHAFgMAAQgIAAgFgBg',
      );
    this.shape_108.setTransform(3.85, 1.975);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgXAHgKQAHgMAPAAQAQAAAHAMQAHALAAAWQAAAYgHAKQgIAMgPAAQgPAAgHgMgAgIggQgEABgCAGQgCADgBAIIAAAOIAAAPQABAHACAEQACAFAEACQADACAFAAQAFAAAEgCQAEgCACgFIADgLIAAgPIAAgOIgDgMQgCgEgEgCQgDgDgGAAQgFAAgDADg',
      );
    this.shape_109.setTransform(-7.375, 0.9);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f('#000000')
      .s()
      .p('AAbArIgIgYIglAAIgIAYIgNAAIAhhWIAOAAIAfBWgAgPAJIAeAAIgPgqg');
    this.shape_110.setTransform(1.55, -15.6);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f('#000000')
      .s()
      .p('AgKAhIAAgXIAVAAIAAAXgAgKgJIAAgXIAVAAIAAAXg');
    this.shape_111.setTransform(-9.2, -14.55);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f('#000000')
      .s()
      .p(
        'AgcAsIAAgPIASAAIAAguIgSAAIAAgOIAIAAIAGgCIAFgEIACgGIASAAIAABIIASAAIAAAPg',
      );
    this.shape_112.setTransform(-15.675, -15.625);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAmQgGgFAAgMIAAgeIgJAAIAAgOIAJAAIAAgTIAUAAIAAATIAUAAIAAAOIgUAAIAAAXIAAAGIABAEQAAABABAAQAAAAAAABQAAAAABABQAAAAABAAIAGACIAEgBIAEgCIACAAIAAAPIgHABIgKABQgLAAgGgFg',
      );
    this.shape_113.setTransform(-26.975, -15.4);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAhIAAhBIAVAAIAAAKQAGgGAFgCQAGgCAEAAIACAAIADAAIAAAUIgCAAIgEgBIgFAAIgIABIgHACIAAArg',
      );
    this.shape_114.setTransform(-32.275, -14.55);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAdQgHgGAAgJQAAgHAEgFQADgDAGgDQAGgDAIgBIARgBIAAgBQAAgFgEgCQgFgCgHAAIgMABIgIADIgCAAIAAgQIALgCIAPgBQARAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgEADIgFADIgFACIgIABQgJAAgGgGgAADADIgHABIgFADQgBACAAADIAAADQAAABAAAAQAAAAABABQAAAAAAAAQAAAAABABIADACIAFAAQADAAADgBIAGgDIAAgOIgJABg',
      );
    this.shape_115.setTransform(-39.875, -14.525);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f('#000000')
      .s()
      .p(
        'AgjArIAAhWIAkAAIAOABQAGACAFADQAEAEAEAFQACAFAAAIQAAAFgCAHQgCAEgEAEQgFAFgGADQgHACgKAAIgNAAIAAAcgAgNgBIAHAAIAIAAQAFgBACgCIADgFIABgGQAAgEgCgCIgEgEIgHgCIgIAAIgFAAg',
      );
    this.shape_116.setTransform(-47.75, -15.6);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f('#000000')
      .s()
      .p('AgVAsIAphNIgxAAIAAgKIA7AAIAAAOIgnBJg');
    this.shape_117.setTransform(24.225, 33.9);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAmQgIgHAAgMQAAgHAFgFQAEgGAHgDIAAAAQgHgEgDgEQgDgFAAgHQAAgKAHgGQAIgGAMgBQANAAAIAHQAIAGAAAKQAAAGgEAFQgDAGgIADIAAABQAJACAEAFQAEAFAAAIQAAALgJAIQgIAHgOAAQgNAAgJgHgAgPAHQgDAFAAAGQAAAIAFAGQAGAFAIAAQAIAAAFgEQAFgFAAgIQAAgFgCgEQgDgDgGgDIgGgDIgIgCQgFADgEAEgAgLghQgEAEAAAGQAAAEABADQADAEAFACIAGACIAHADQAGgEACgEQADgEAAgFQgBgGgFgFQgEgDgIAAQgGAAgFADg',
      );
    this.shape_118.setTransform(-23.2, 33.9);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f('#000000')
      .s()
      .p(
        'AgMAuIAAg3IgIAAIAAgJIAIAAIAAgCQgBgNAGgFQAGgHAKAAIAHAAIAFABIAAAKIgBAAIgEgBIgGAAQgHAAgDADQgCADAAAJIAAACIATAAIAAAJIgSAAIAAA3g',
      );
    this.shape_119.setTransform(35.7, 17.15);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgQQAAgQAJgJQAJgJANAAQAOAAAHAIQAHAHAAAPIAAAFIgvAAQAAAFABAFQACAEADAEQADACAFABQADACAFAAQAHAAAGgDQAHgCADgDIABAAIAAAMIgMAEIgMABQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgIgEgGQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_120.setTransform(5.675, 18.45);

    this.shape_121 = new cjs.Shape();
    this.shape_121.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAtIgIgEIgBAEIgKAAIAAhaIALAAIAAAgQAFgEAFgDQAFgCAGAAQALAAAHAJQAHAJAAAPQAAAJgDAGQgCAHgEAEQgEAFgFACQgFACgGABQgFgBgEgBgAgIgJIgJAFIAAAkQAFADADABIAIABQAIAAAFgHQAFgFAAgOQAAgLgEgFQgDgHgJAAQgEAAgFADg',
      );
    this.shape_121.setTransform(-1.425, 17.3);

    this.shape_122 = new cjs.Shape();
    this.shape_122.graphics
      .f('#000000')
      .s()
      .p(
        'AgOAhIgLgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAEgDABgFQgBgEgCgCQgCgCgGgBIgGgBIgHgCQgIgCgDgDQgEgFgBgGQABgEACgEQABgDADgDQAEgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEACACQADACAGACIAGABIAFABQAIACAFADQADAFAAAHQAAAJgHAGQgHAFgMAAQgIAAgFgBg',
      );
    this.shape_122.setTransform(53.8, 1.975);

    this.shape_123 = new cjs.Shape();
    this.shape_123.graphics
      .f('#000000')
      .s()
      .p(
        'AASAuIAAggQgFAFgFACQgGACgEAAQgMAAgHgJQgHgJAAgPQAAgIADgHQACgGAEgFQAEgEAFgCQAFgDAFAAQAFAAAEACIAJADIAAgDIALAAIAABZgAgMgcQgFAGAAAMQAAAKAEAGQAEAHAJAAQAEAAAFgCIAJgGIAAgkIgIgDIgIgBQgJAAgFAHg',
      );
    this.shape_123.setTransform(28.525, 3.075);

    this.shape_124 = new cjs.Shape();
    this.shape_124.graphics
      .f('#000000')
      .s()
      .p(
        'AgMAuIAAg3IgIAAIAAgJIAIAAIAAgDQgBgMAGgGQAGgGAKAAIAHABIAFABIAAAKIAAAAIgFgBIgGgBQgGAAgEADQgCADAAAIIAAADIATAAIAAAJIgTAAIAAA3g',
      );
    this.shape_124.setTransform(11.95, 0.65);

    this.shape_125 = new cjs.Shape();
    this.shape_125.graphics.f('#000000').s().p('AgEAtIAAhaIAKAAIAABag');
    this.shape_125.setTransform(7.8, 0.7);

    this.shape_126 = new cjs.Shape();
    this.shape_126.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAFgDAAgFQAAgEgDgCQgCgCgHgBIgEgBIgIgCQgIgCgDgDQgFgFAAgGQAAgEACgEQACgDADgDQAEgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAFABIAGABQAJACADADQAFAFAAAHQgBAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_126.setTransform(-22.45, 1.975);

    this.shape_127 = new cjs.Shape();
    this.shape_127.graphics
      .f('#000000')
      .s()
      .p(
        'AgjArIAAhWIAkAAIAOABQAGACAFADQAEAEAEAFQACAFAAAIQAAAFgCAHQgCAEgEAEQgFAFgGADQgHACgJAAIgOAAIAAAcgAgNgBIAHAAIAIAAQAEgBADgCIADgFIABgGQAAgEgCgCIgEgEIgHgCIgIAAIgFAAg',
      );
    this.shape_127.setTransform(-49.2, -15.6);

    this.shape_128 = new cjs.Shape();
    this.shape_128.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAaQgKgJAAgRQAAgOAJgKQAJgKANAAQAOABAHAHQAHAIAAAPIAAAEIgvAAQAAAHABAEQACAEADADQADADAFACQADABAFAAQAHAAAGgCIAKgGIABAAIAAAMIgMAEIgMACQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgJgEgEQgFgFgIAAQgIAAgFAFg',
      );
    this.shape_128.setTransform(-10.375, 1.95);

    this.shape_129 = new cjs.Shape();
    this.shape_129.graphics
      .f('#000000')
      .s()
      .p('AASAhIgSgZIgSAZIgNAAIAZghIgYggIANAAIARAZIATgZIANAAIgZAgIAZAhg');
    this.shape_129.setTransform(36.15, -14.525);

    this.shape_130 = new cjs.Shape();
    this.shape_130.graphics.f('#000000').s().p('AgGAIIAAgPIANAAIAAAPg');
    this.shape_130.setTransform(14.2, -12.075);

    this.shape_131 = new cjs.Shape();
    this.shape_131.graphics.f('#000000').s().p('AgGAIIAAgPIANAAIAAAPg');
    this.shape_131.setTransform(9.85, -12.075);

    this.shape_132 = new cjs.Shape();
    this.shape_132.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAmQgFgGAAgMIAAghIgIAAIAAgKIAIAAIAAgTIALAAIAAATIAWAAIAAAKIgWAAIAAAcIAAAIQAAADABADIADADIAHABIAGgBIAEgBIABAAIAAAKIgHABIgHABQgJAAgFgFg',
      );
    this.shape_132.setTransform(5.325, -15.4);

    this.shape_133 = new cjs.Shape();
    this.shape_133.graphics
      .f('#000000')
      .s()
      .p(
        'AgGAgQgGgCgFgEQgDgEgDgHQgCgGgBgJQAAgPAJgJQAKgJANAAIALABIAKAEIAAAMIgBAAIgKgGQgFgCgFAAQgJAAgFAHQgGAGAAALQAAAMAGAGQAEAHAKAAIAGgBIAGgCIAFgDIADgCIABAAIAAAMIgKAEQgFABgGAAQgGAAgGgCg',
      );
    this.shape_133.setTransform(-0.05, -14.525);

    this.shape_134 = new cjs.Shape();
    this.shape_134.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAmQgFgGAAgMIAAghIgIAAIAAgKIAIAAIAAgTIALAAIAAATIAWAAIAAAKIgWAAIAAAcIAAAIQAAADABADIADADIAHABIAGgBIAEgBIABAAIAAAKIgHABIgHABQgJAAgFgFg',
      );
    this.shape_134.setTransform(-17.725, -15.4);

    this.shape_135 = new cjs.Shape();
    this.shape_135.graphics
      .f('#000000')
      .s()
      .p(
        'AgRAsIgQgGIAAgOIABAAQAHAFAJADQAIADAIAAQAJAAAHgEQAFgEAAgHQAAgFgCgDQgDgDgGgBIgJgCIgKgCQgMgDgFgFQgGgGAAgJQAAgLAJgHQAJgHAOAAQAJAAAIACQAHABAGADIAAAOIgBAAQgEgEgJgDQgIgDgIAAQgIAAgHAEQgFAEAAAGQAAAFADADQADADAHACIAJACIAMACQAKADAEAEQAFAFABAKQgBAFgCAFQgCAFgEADQgFAEgHACQgGACgHAAQgKAAgHgBg',
      );
    this.shape_135.setTransform(-39.3, -15.625);

    this.shape_136 = new cjs.Shape();
    this.shape_136.graphics
      .f('#000000')
      .s()
      .p('AgFAsIAAhAIAKAAIAABAgAgFgfIAAgMIALAAIAAAMg');
    this.shape_136.setTransform(4.15, 17.35);

    this.shape_137 = new cjs.Shape();
    this.shape_137.graphics
      .f('#000000')
      .s()
      .p('AgFAsIAAhAIAKAAIAABAgAgFgfIAAgMIALAAIAAAMg');
    this.shape_137.setTransform(-6.65, 17.35);

    this.shape_138 = new cjs.Shape();
    this.shape_138.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAmQgHgKAAgQQAAgIACgGQADgGAEgFQAEgEAFgDQAFgCAFAAQAFAAAEABIAJAEIAAgcIALAAIAABaIgLAAIAAgHIgKAGQgFACgFABQgMAAgHgJgAgLgFQgGAFAAAMQAAALAEAHQAEAGAJAAQAEAAAFgCIAJgFIAAglIgIgDIgIgBQgIAAgFAHg',
      );
    this.shape_138.setTransform(-12.275, 17.3);

    this.shape_139 = new cjs.Shape();
    this.shape_139.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAmQgHgKAAgQQAAgIACgGQADgGAEgFQAEgEAFgDQAFgCAFAAQAFAAAEABIAJAEIAAgcIALAAIAABaIgLAAIAAgHIgKAGQgFACgFABQgMAAgHgJgAgLgFQgGAFAAAMQAAALAEAHQAEAGAJAAQAEAAAFgCIAJgFIAAglIgIgDIgIgBQgIAAgFAHg',
      );
    this.shape_139.setTransform(-56.825, 17.3);

    this.shape_140 = new cjs.Shape();
    this.shape_140.graphics
      .f('#000000')
      .s()
      .p(
        'AgNAuIAAg3IgHAAIAAgJIAHAAIAAgDQABgMAFgGQAGgGAKAAIAGABIAGABIAAAKIAAAAIgGgBIgEgBQgIAAgCADQgDADAAAIIAAADIATAAIAAAJIgTAAIAAA3g',
      );
    this.shape_140.setTransform(23.85, 0.65);

    this.shape_141 = new cjs.Shape();
    this.shape_141.graphics
      .f('#000000')
      .s()
      .p(
        'AgLAtIgKgCIAAgLIABAAIAIADQAGABAGAAQAEAAAEgBIAGgEIADgFIABgIIAAgGIgKAGQgEACgGAAQgMAAgHgIQgHgJAAgOQAAgJACgGQADgGAEgEQAEgEAFgDQAGgCAEAAQAGAAAEABIAIAEIAAgDIALAAIAAA5QAAAQgIAIQgHAIgPAAIgKgBgAgLgdQgGAGAAAMQAAALAEAEQAEAGAJAAQAEAAAFgCIAJgFIAAgiIgIgDIgIgBQgIAAgFAGg',
      );
    this.shape_141.setTransform(36.925, -13.375);

    this.shape_142 = new cjs.Shape();
    this.shape_142.graphics
      .f('#000000')
      .s()
      .p(
        'AgGAgQgGgCgEgEQgFgEgCgHQgDgGABgJQgBgPAKgJQAIgJAOAAIALABIAKAEIAAAMIgBAAIgKgGQgFgCgGAAQgIAAgFAHQgGAGAAALQAAAMAGAGQAFAHAIAAIAHgBIAHgCIAEgDIADgCIABAAIAAAMIgKAEQgGABgFAAQgHAAgFgCg',
      );
    this.shape_142.setTransform(-7, -14.525);

    this.shape_143 = new cjs.Shape();
    this.shape_143.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAdQgGgGAAgJQAAgIAEgEQADgEAGgDQAGgDAIgBIARgBIAAgCIgBgGIgEgDIgGgCIgGgBIgJACIgLACIgBAAIAAgKIAJgCIAMgBIAMABQAFABADACQAEADACAFQACAEAAAGIAAArIgLAAIAAgHIgEAEIgFACIgGACIgIABQgIAAgHgFgAAFAAIgKAAQgEACgDADQgDADAAAFQAAAGADADQAEACAGAAQAFAAAFgCIAJgGIAAgRIgMABg',
      );
    this.shape_143.setTransform(-14.075, -14.5);

    this.shape_144 = new cjs.Shape();
    this.shape_144.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAhIAAhBIALAAIAAAKQAGgFAEgCQAFgDAFAAIAFAAIADABIAAALIAAAAIgFgBIgFAAQgGAAgEACIgIAGIAAAug',
      );
    this.shape_144.setTransform(-19.225, -14.525);

    this.shape_145 = new cjs.Shape();
    this.shape_145.graphics
      .f('#000000')
      .s()
      .p(
        'AgRAsIgPgGIAAgOIAAAAQAHAFAJADQAIADAIAAQAKAAAFgEQAHgEgBgHQAAgFgCgDQgDgDgGgBIgJgCIgLgCQgLgDgFgFQgGgGAAgJQAAgLAJgHQAKgHANAAQAJAAAHACQAIABAGADIAAAOIAAAAQgFgEgJgDQgIgDgIAAQgJAAgFAEQgGAEAAAGQAAAFADADQACADAIACIAKACIALACQAKADAFAEQAEAFAAAKQAAAFgCAFQgCAFgFADQgEAEgHACQgFACgJAAQgJAAgHgBg',
      );
    this.shape_145.setTransform(-46.25, -15.625);

    this.shape_146 = new cjs.Shape();
    this.shape_146.graphics
      .f('#000000')
      .s()
      .p(
        'AgGAgQgGgCgEgEQgFgEgCgHQgDgGABgJQgBgPAKgJQAIgJAOAAQAFAAAGABIAKAEIAAAMIgBAAIgKgGQgFgCgGAAQgIAAgFAHQgGAGAAALQAAAMAGAGQAFAHAIAAIAHgBIAHgCIAEgDIADgCIABAAIAAAMIgKAEQgGABgFAAQgHAAgFgCg',
      );
    this.shape_146.setTransform(6.05, 1.975);

    this.shape_147 = new cjs.Shape();
    this.shape_147.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAcQgGgGAAgIQAAgIAEgFQADgDAGgDQAGgCAIgCIARAAIAAgCIgBgHIgEgDIgGgDIgGAAIgJABIgLAEIgBAAIAAgLIAJgDIAMgBIAMABQAFACADADQAEACACAFQACAEAAAGIAAAsIgLAAIAAgHIgEACIgFADIgGADIgIABQgIAAgHgHgAAFAAIgKAAQgEACgDADQgDADAAAFQAAAFADADQAEADAGAAQAFAAAFgCIAJgFIAAgSIgMABg',
      );
    this.shape_147.setTransform(-33.475, 18.5);

    this.shape_148 = new cjs.Shape();
    this.shape_148.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAuIAAgmIAAgIIgCgFQgCgDgCgBQgDgCgFAAQgDAAgFADQgFACgEADIAAAxIgLAAIAAhaIALAAIAAAgQAFgEAFgDQAFgCAGAAQAKAAAGAHQAFAGAAALIAAArg',
      );
    this.shape_148.setTransform(-40.625, 17.2);

    this.shape_149 = new cjs.Shape();
    this.shape_149.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAEgDABgFQgBgEgCgCQgCgCgGgBIgFgBIgIgCQgIgCgDgDQgFgFAAgGQAAgEADgEQABgDADgDQAEgDAFgCQAFgBAFAAQAGAAAGABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAGABIAFABQAIACAFADQADAFABAHQgBAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_149.setTransform(6.45, 1.975);

    this.shape_150 = new cjs.Shape();
    this.shape_150.graphics
      .f('#000000')
      .s()
      .p(
        'AgNAuIAAg3IgHAAIAAgKIAHAAIAAgCQABgMAFgGQAGgGAKAAIAGAAIAGABIAAALIgBAAIgFgCIgEAAQgIAAgCADQgDADAAAIIAAACIATAAIAAAKIgTAAIAAA3g',
      );
    this.shape_150.setTransform(41.6, -15.85);

    this.shape_151 = new cjs.Shape();
    this.shape_151.graphics.f('#000000').s().p('AgFAtIAAhZIALAAIAABZg');
    this.shape_151.setTransform(11.2, -15.8);

    this.shape_152 = new cjs.Shape();
    this.shape_152.graphics
      .f('#000000')
      .s()
      .p('AgFAhIgahBIAMAAIATAzIAUgzIAMAAIgaBBg');
    this.shape_152.setTransform(-0.95, -14.525);

    this.shape_153 = new cjs.Shape();
    this.shape_153.graphics
      .f('#000000')
      .s()
      .p(
        'AgOAhIgKgEIAAgNIAAAAQAFAEAGADQAHACAGAAQAGAAAEgCQAEgDAAgFQABgEgDgCQgCgCgGgBIgGgBIgHgCQgIgCgEgDQgDgFAAgGQAAgEACgEQABgDADgDQAEgDAFgCQAFgBAFAAIAMABIAKAEIAAALIgBAAQgEgDgGgCQgGgCgFAAQgGAAgEACQgEADAAAEQAAAEACACQADACAFACIAHABIAGABQAIACAEADQADAFAAAHQABAJgIAGQgHAFgMAAQgIAAgFgBg',
      );
    this.shape_153.setTransform(-11.7, -14.525);

    this.shape_154 = new cjs.Shape();
    this.shape_154.graphics.f('#000000').s().p('AgDARIgDghIANAAIgDAhg');
    this.shape_154.setTransform(-16.5, -18.65);

    this.shape_155 = new cjs.Shape();
    this.shape_155.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArQgHgEgGgFQgFgHgDgIQgDgJAAgKQAAgKADgIQADgIAGgHQAFgFAHgEQAIgDAIAAQAJAAAIADQAHAEAGAFQAFAGADAIQADAJAAAKQAAAKgDAJQgDAIgFAHQgGAFgHAEQgIACgJAAQgIAAgIgCgAgUgaQgHAKAAAQQAAARAHAJQAIAJAMAAQANAAAIgJQAHgJAAgRQAAgQgHgKQgIgIgNgBQgMABgIAIg',
      );
    this.shape_155.setTransform(-37.575, -15.6);

    this.shape_156 = new cjs.Shape();
    this.shape_156.graphics
      .f('#000000')
      .s()
      .p('AARAhIgRgyIgQAyIgKAAIgRhBIAMAAIALAyIARgyIAIAAIARAyIALgyIALAAIgRBBg');
    this.shape_156.setTransform(39.85, -14.525);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_30 },
            { t: this.shape_29, p: { x: -44.525 } },
            { t: this.shape_28, p: { x: -37.025 } },
            { t: this.shape_27, p: { x: -25.025, y: -15.6 } },
            { t: this.shape_26, p: { x: -14.575 } },
            { t: this.shape_25, p: { x: -8.625, y: -14.525 } },
            { t: this.shape_24, p: { x: 2.625 } },
            { t: this.shape_23, p: { x: 14.475, y: -14.625 } },
            { t: this.shape_22, p: { x: 22.025, y: -14.425 } },
            { t: this.shape_21, p: { x: 31.725, y: -14.625 } },
            { t: this.shape_20, p: { x: 41.475 } },
            { t: this.shape_19, p: { x: 48.575, y: -14.55 } },
            { t: this.shape_18, p: { x: 55.275, y: -14.525 } },
            { t: this.shape_17, p: { x: -43.025 } },
            { t: this.shape_16, p: { x: -35.375, y: 1.875 } },
            { t: this.shape_15, p: { x: -28.075 } },
            { t: this.shape_14, p: { x: -18.25 } },
            { t: this.shape_13 },
            { t: this.shape_12, p: { x: -4.45 } },
            { t: this.shape_11, p: { x: 0.975 } },
            { t: this.shape_10, p: { x: 6.675 } },
            { t: this.shape_9, p: { x: 13.95 } },
            { t: this.shape_8 },
            { t: this.shape_7, p: { x: 30.325 } },
            { t: this.shape_6, p: { x: 36.475 } },
            { t: this.shape_5, p: { x: 43.825 } },
            { t: this.shape_4, p: { x: -14.6, y: 18.475 } },
            { t: this.shape_3, p: { x: -8.225 } },
            { t: this.shape_2, p: { x: 1.475, y: 18.375 } },
            { t: this.shape_1, p: { x: 10.825 } },
            { t: this.shape, p: { x: 16.6, y: 20.925 } },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_30 },
              { t: this.shape_29, p: { x: -44.525 } },
              { t: this.shape_28, p: { x: -37.025 } },
              { t: this.shape_60 },
              { t: this.shape_26, p: { x: -14.575 } },
              { t: this.shape_59, p: { x: -8.625, y: -14.525 } },
              { t: this.shape_24, p: { x: 2.625 } },
              { t: this.shape_58 },
              { t: this.shape_57, p: { x: 22.025 } },
              { t: this.shape_56 },
              { t: this.shape_20, p: { x: 41.475 } },
              { t: this.shape_55 },
              { t: this.shape_54, p: { x: 55.275, y: -14.525 } },
              { t: this.shape_10, p: { x: -52.675 } },
              { t: this.shape_53, p: { x: -45.025, y: 1.875 } },
              { t: this.shape_15, p: { x: -37.725 } },
              { t: this.shape_11, p: { x: -27.125 } },
              { t: this.shape_52 },
              { t: this.shape_51, p: { x: -13.625 } },
              { t: this.shape_12, p: { x: -2.65 } },
              { t: this.shape_50, p: { x: 4.125, y: 2.075 } },
              { t: this.shape_49, p: { x: 13.825, y: 1.875 } },
              { t: this.shape_48, p: { x: 25.45 } },
              { t: this.shape_47 },
              { t: this.shape_7, p: { x: 39.925 } },
              { t: this.shape_6, p: { x: 46.075 } },
              { t: this.shape_5, p: { x: 53.425 } },
              { t: this.shape_46, p: { x: -56.475, y: 18.375 } },
              { t: this.shape_45 },
              { t: this.shape_44 },
              { t: this.shape_43, p: { x: -36.025 } },
              { t: this.shape_42 },
              { t: this.shape_41, p: { x: -16.725, y: 18.575 } },
              { t: this.shape_21, p: { x: -7.025, y: 18.375 } },
              { t: this.shape_40, p: { x: 2.725 } },
              { t: this.shape_39, p: { x: 9.825 } },
              { t: this.shape_38, p: { x: 16.525, y: 18.475 } },
              { t: this.shape_25, p: { x: 26.325, y: 18.475 } },
              { t: this.shape_37, p: { x: 33.825, y: 18.375 } },
              { t: this.shape_36, p: { x: 44.225 } },
              { t: this.shape_35, p: { x: 50.375 } },
              { t: this.shape_1, p: { x: 57.725 } },
              { t: this.shape_23, p: { x: -33.925, y: 34.875 } },
              { t: this.shape_22, p: { x: -26.375, y: 35.075 } },
              { t: this.shape_2, p: { x: -16.675, y: 34.875 } },
              { t: this.shape_34 },
              { t: this.shape_19, p: { x: 0.175, y: 34.95 } },
              { t: this.shape_18, p: { x: 6.875, y: 34.975 } },
              { t: this.shape_33, p: { x: 14.7, y: 33.7 } },
              { t: this.shape_32 },
              { t: this.shape_16, p: { x: 23.475, y: 34.875 } },
              { t: this.shape_31, p: { x: 30.825, y: 34.95 } },
              { t: this.shape, p: { x: 36.6, y: 37.425 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_70, p: { x: -54.9 } },
              { t: this.shape_29, p: { x: -47.275 } },
              { t: this.shape_28, p: { x: -39.775 } },
              { t: this.shape_26, p: { x: -29.175 } },
              { t: this.shape_69, p: { x: -23.025 } },
              { t: this.shape_19, p: { x: -15.675, y: -14.55 } },
              { t: this.shape_46, p: { x: -4.075, y: -14.625 } },
              { t: this.shape_41, p: { x: 3.475, y: -14.425 } },
              { t: this.shape_49, p: { x: 13.175, y: -14.625 } },
              { t: this.shape_20, p: { x: 22.925 } },
              { t: this.shape_31, p: { x: 30.025, y: -14.55 } },
              { t: this.shape_54, p: { x: 36.725, y: -14.525 } },
              { t: this.shape_68 },
              { t: this.shape_67 },
              { t: this.shape_37, p: { x: 56.225, y: -14.625 } },
              { t: this.shape_17, p: { x: -50.325 } },
              { t: this.shape_23, p: { x: -42.675, y: 1.875 } },
              { t: this.shape_9, p: { x: -35.45 } },
              { t: this.shape_25, p: { x: -24.075, y: 1.975 } },
              { t: this.shape_38, p: { x: -17.275, y: 1.975 } },
              { t: this.shape_66, p: { x: -11.775 } },
              { t: this.shape_51, p: { x: -4.225 } },
              { t: this.shape_18, p: { x: 2.475, y: 1.975 } },
              { t: this.shape_10, p: { x: 12.025 } },
              { t: this.shape_16, p: { x: 19.675, y: 1.875 } },
              { t: this.shape_15, p: { x: 26.975 } },
              { t: this.shape_7, p: { x: 37.575 } },
              { t: this.shape_6, p: { x: 43.725 } },
              { t: this.shape_5, p: { x: 51.075 } },
              { t: this.shape_65, p: { x: -48.1 } },
              { t: this.shape_22, p: { x: -41.325, y: 18.575 } },
              { t: this.shape_21, p: { x: -31.625, y: 18.375 } },
              { t: this.shape_64 },
              { t: this.shape_63, p: { x: -15.15, y: 18.475 } },
              { t: this.shape_36, p: { x: -5.525 } },
              { t: this.shape_35, p: { x: 0.625 } },
              { t: this.shape_1, p: { x: 7.975 } },
              { t: this.shape_62 },
              { t: this.shape_3, p: { x: 25.325 } },
              { t: this.shape_2, p: { x: 35.025, y: 18.375 } },
              { t: this.shape_61, p: { x: 44.375 } },
              { t: this.shape, p: { x: 50.15, y: 20.925 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_88, p: { x: -55.55 } },
              { t: this.shape_87, p: { x: -47.925 } },
              { t: this.shape_29, p: { x: -40.425 } },
              { t: this.shape_86, p: { x: -29.825 } },
              { t: this.shape_85 },
              { t: this.shape_59, p: { x: -14.075, y: -14.525 } },
              { t: this.shape_63, p: { x: -3, y: -14.525 } },
              { t: this.shape_84, p: { x: 1.65 } },
              { t: this.shape_23, p: { x: 7.125, y: -14.625 } },
              { t: this.shape_83, p: { x: 14.425, y: -13.375 } },
              { t: this.shape_82, p: { x: 20.05 } },
              { t: this.shape_19, p: { x: 25.275, y: -14.55 } },
              { t: this.shape_81, p: { x: 31.575, y: -15.075 } },
              { t: this.shape_28, p: { x: 37.825 } },
              { t: this.shape_80 },
              { t: this.shape_79, p: { x: 48.625, y: -13.375 } },
              { t: this.shape_78, p: { x: 54.25 } },
              { t: this.shape_26, p: { x: 58.325 } },
              { t: this.shape_16, p: { x: -43.225, y: 1.875 } },
              { t: this.shape_41, p: { x: -35.675, y: 2.075 } },
              { t: this.shape_21, p: { x: -25.975, y: 1.875 } },
              { t: this.shape_77, p: { x: -16.225 } },
              { t: this.shape_51, p: { x: -9.125 } },
              { t: this.shape_18, p: { x: -2.425, y: 1.975 } },
              { t: this.shape_12, p: { x: 2.75 } },
              { t: this.shape_76 },
              { t: this.shape_6, p: { x: 23.575 } },
              { t: this.shape_25, p: { x: 30.975, y: 1.975 } },
              { t: this.shape_75 },
              { t: this.shape_5, p: { x: 44.425 } },
              { t: this.shape_74 },
              { t: this.shape_22, p: { x: -19.025, y: 18.575 } },
              { t: this.shape_2, p: { x: -9.325, y: 18.375 } },
              { t: this.shape_73 },
              { t: this.shape_72, p: { x: 18.65, y: 17.375 } },
              { t: this.shape_71 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_96 },
              { t: this.shape_87, p: { x: -37.425 } },
              { t: this.shape_29, p: { x: -29.925 } },
              { t: this.shape_26, p: { x: -19.325 } },
              { t: this.shape_95 },
              { t: this.shape_59, p: { x: -3.575, y: -14.525 } },
              { t: this.shape_28, p: { x: 7.825 } },
              { t: this.shape_25, p: { x: 15.425, y: -14.525 } },
              { t: this.shape_41, p: { x: 22.875, y: -14.425 } },
              { t: this.shape_20, p: { x: 30.675 } },
              { t: this.shape_33, p: { x: 35.85, y: -15.8 } },
              { t: this.shape_31, p: { x: 41.075, y: -14.55 } },
              { t: this.shape_81, p: { x: 47.375, y: -15.075 } },
              { t: this.shape_15, p: { x: -57.075 } },
              { t: this.shape_94 },
              { t: this.shape_79, p: { x: -46.275, y: 3.125 } },
              { t: this.shape_14, p: { x: -40.65 } },
              { t: this.shape_11, p: { x: -36.575 } },
              { t: this.shape_37, p: { x: -26.225, y: 1.875 } },
              { t: this.shape_22, p: { x: -18.675, y: 2.075 } },
              { t: this.shape_2, p: { x: -8.975, y: 1.875 } },
              { t: this.shape_77, p: { x: 0.775 } },
              { t: this.shape_51, p: { x: 7.875 } },
              { t: this.shape_18, p: { x: 14.575, y: 1.975 } },
              { t: this.shape_93 },
              { t: this.shape_48, p: { x: 28.6 } },
              { t: this.shape_23, p: { x: 34.075, y: 1.875 } },
              { t: this.shape_7, p: { x: 44.475 } },
              { t: this.shape_6, p: { x: 50.625 } },
              { t: this.shape_5, p: { x: 57.975 } },
              { t: this.shape_36, p: { x: -27.725 } },
              { t: this.shape_1, p: { x: -21.825 } },
              { t: this.shape_16, p: { x: -14.425, y: 18.375 } },
              { t: this.shape_92, p: { x: -7.45 } },
              { t: this.shape_91, p: { x: 3.725, y: 19.575 } },
              { t: this.shape_90, p: { x: 8.9 } },
              { t: this.shape_3, p: { x: 13.925 } },
              { t: this.shape_89 },
              { t: this.shape_61, p: { x: 27.525 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_88, p: { x: -33.05 } },
              { t: this.shape_29, p: { x: -25.425 } },
              { t: this.shape_28, p: { x: -17.925 } },
              { t: this.shape_24, p: { x: -6.375 } },
              { t: this.shape_23, p: { x: 1.275, y: -14.625 } },
              { t: this.shape_101, p: { x: 8.5 } },
              { t: this.shape_26, p: { x: 18.675 } },
              { t: this.shape_100 },
              { t: this.shape_59, p: { x: 34.425, y: -14.525 } },
              { t: this.shape_66, p: { x: -32.075 } },
              { t: this.shape_25, p: { x: -24.475, y: 1.975 } },
              { t: this.shape_41, p: { x: -17.025, y: 2.075 } },
              { t: this.shape_77, p: { x: -9.225 } },
              { t: this.shape_99, p: { x: -4.05 } },
              { t: this.shape_5, p: { x: 1.175 } },
              { t: this.shape_81, p: { x: 7.475, y: 1.425 } },
              { t: this.shape_15, p: { x: 13.725 } },
              { t: this.shape_98, p: { x: 19.35 } },
              { t: this.shape_79, p: { x: 24.525, y: 3.125 } },
              { t: this.shape_97, p: { x: 30.15 } },
              { t: this.shape_7, p: { x: 34.225 } },
              { t: this.shape_16, p: { x: -22.075, y: 18.375 } },
              { t: this.shape_22, p: { x: -14.525, y: 18.575 } },
              { t: this.shape_2, p: { x: -4.825, y: 18.375 } },
              { t: this.shape_40, p: { x: 4.925 } },
              { t: this.shape_1, p: { x: 12.025 } },
              { t: this.shape_18, p: { x: 18.725, y: 18.475 } },
              { t: this.shape_65, p: { x: 23.9 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_116 },
              { t: this.shape_115, p: { x: -39.875 } },
              { t: this.shape_114, p: { x: -32.275 } },
              { t: this.shape_113, p: { x: -26.975 } },
              { t: this.shape_112, p: { x: -15.675 } },
              { t: this.shape_111, p: { x: -9.2 } },
              { t: this.shape_110 },
              { t: this.shape_23, p: { x: 13.675, y: -14.625 } },
              { t: this.shape_41, p: { x: 21.225, y: -14.425 } },
              { t: this.shape_49, p: { x: 30.925, y: -14.625 } },
              { t: this.shape_20, p: { x: 40.675 } },
              { t: this.shape_19, p: { x: 47.775, y: -14.55 } },
              { t: this.shape_18, p: { x: 54.475, y: -14.525 } },
              { t: this.shape_21, p: { x: -45.875, y: 1.875 } },
              { t: this.shape_48, p: { x: -38.45 } },
              { t: this.shape_16, p: { x: -32.975, y: 1.875 } },
              { t: this.shape_22, p: { x: -25.425, y: 2.075 } },
              { t: this.shape_12, p: { x: -18.4 } },
              { t: this.shape_109 },
              { t: this.shape_108 },
              { t: this.shape_11, p: { x: 9.275 } },
              { t: this.shape_10, p: { x: 14.975 } },
              { t: this.shape_107 },
              { t: this.shape_106 },
              { t: this.shape_7, p: { x: 38.625 } },
              { t: this.shape_6, p: { x: 44.775 } },
              { t: this.shape_5, p: { x: 52.125 } },
              { t: this.shape_105 },
              { t: this.shape_3, p: { x: -4.525 } },
              { t: this.shape_2, p: { x: 5.175, y: 18.375 } },
              { t: this.shape_1, p: { x: 14.525 } },
              { t: this.shape_104 },
              { t: this.shape_81, p: { x: -10.925, y: 34.425 } },
              { t: this.shape_27, p: { x: -0.175, y: 33.9 } },
              { t: this.shape_103, p: { x: 12.775 } },
              { t: this.shape_102 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_127 },
              { t: this.shape_115, p: { x: -41.325 } },
              { t: this.shape_114, p: { x: -33.725 } },
              { t: this.shape_113, p: { x: -28.425 } },
              { t: this.shape_112, p: { x: -17.125 } },
              { t: this.shape_111, p: { x: -10.65 } },
              { t: this.shape_70, p: { x: 0 } },
              { t: this.shape_37, p: { x: 12.125, y: -14.625 } },
              { t: this.shape_57, p: { x: 19.675 } },
              { t: this.shape_49, p: { x: 29.375, y: -14.625 } },
              { t: this.shape_20, p: { x: 39.125 } },
              { t: this.shape_31, p: { x: 46.225, y: -14.55 } },
              { t: this.shape_54, p: { x: 52.925, y: -14.525 } },
              { t: this.shape_21, p: { x: -49.925, y: 1.875 } },
              { t: this.shape_48, p: { x: -42.5 } },
              { t: this.shape_23, p: { x: -37.025, y: 1.875 } },
              { t: this.shape_50, p: { x: -29.475, y: 2.075 } },
              { t: this.shape_126 },
              { t: this.shape_97, p: { x: -13.6 } },
              { t: this.shape_7, p: { x: -9.525 } },
              { t: this.shape_12, p: { x: -4 } },
              { t: this.shape_51, p: { x: 2.575 } },
              { t: this.shape_125, p: { x: 7.8 } },
              { t: this.shape_124 },
              { t: this.shape_5, p: { x: 21.425 } },
              { t: this.shape_123 },
              { t: this.shape_41, p: { x: 36.275, y: 2.075 } },
              { t: this.shape_10, p: { x: 43.475 } },
              { t: this.shape_99, p: { x: 48.95 } },
              { t: this.shape_122 },
              { t: this.shape_36, p: { x: -53.525 } },
              { t: this.shape_35, p: { x: -47.375 } },
              { t: this.shape_39, p: { x: -40.025 } },
              { t: this.shape_16, p: { x: -28.425, y: 18.375 } },
              { t: this.shape_22, p: { x: -20.875, y: 18.575 } },
              { t: this.shape_2, p: { x: -11.175, y: 18.375 } },
              { t: this.shape_121, p: { x: -1.425 } },
              { t: this.shape_120 },
              { t: this.shape_38, p: { x: 12.375, y: 18.475 } },
              { t: this.shape_40, p: { x: 22.525 } },
              { t: this.shape_1, p: { x: 29.625 } },
              { t: this.shape_119 },
              { t: this.shape_25, p: { x: 41.025, y: 18.475 } },
              { t: this.shape_18, p: { x: 47.825, y: 18.475 } },
              { t: this.shape_61, p: { x: 53.375 } },
              { t: this.shape_118 },
              { t: this.shape_81, p: { x: -12.425, y: 34.425 } },
              { t: this.shape_72, p: { x: -1.5, y: 33.875 } },
              { t: this.shape_103, p: { x: 11.275 } },
              { t: this.shape_117 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_135, p: { x: -39.3 } },
              { t: this.shape_22, p: { x: -31.475, y: -14.425 } },
              { t: this.shape_20, p: { x: -23.675 } },
              { t: this.shape_134, p: { x: -17.725 } },
              { t: this.shape_18, p: { x: -12.275, y: -14.525 } },
              { t: this.shape_24, p: { x: -7.125 } },
              { t: this.shape_133, p: { x: -0.05 } },
              { t: this.shape_132, p: { x: 5.325 } },
              { t: this.shape_131 },
              { t: this.shape_130 },
              { t: this.shape, p: { x: 18.55, y: -12.075 } },
              { t: this.shape_86, p: { x: 23.125 } },
              { t: this.shape_31, p: { x: 29.025, y: -14.55 } },
              { t: this.shape_129 },
              { t: this.shape_26, p: { x: 42.125 } },
              { t: this.shape_16, p: { x: -17.725, y: 1.875 } },
              { t: this.shape_128, p: { x: -10.375 } },
              { t: this.shape_51, p: { x: -3.225 } },
              { t: this.shape_66, p: { x: 3.875 } },
              { t: this.shape_5, p: { x: 11.425 } },
              { t: this.shape_15, p: { x: 18.525 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_145, p: { x: -46.25 } },
              { t: this.shape_57, p: { x: -38.425 } },
              { t: this.shape_20, p: { x: -30.625 } },
              { t: this.shape_86, p: { x: -24.675 } },
              { t: this.shape_144 },
              { t: this.shape_143, p: { x: -14.075 } },
              { t: this.shape_142, p: { x: -7 } },
              { t: this.shape_26, p: { x: -1.625 } },
              { t: this.shape_24, p: { x: 8.275 } },
              { t: this.shape_63, p: { x: 19.5, y: -14.525 } },
              { t: this.shape_84, p: { x: 24.15 } },
              { t: this.shape_37, p: { x: 29.625, y: -14.625 } },
              { t: this.shape_141 },
              { t: this.shape_82, p: { x: 42.55 } },
              { t: this.shape_19, p: { x: 47.775, y: -14.55 } },
              { t: this.shape_15, p: { x: -56.475 } },
              { t: this.shape_98, p: { x: -50.85 } },
              { t: this.shape_83, p: { x: -45.675, y: 3.125 } },
              { t: this.shape_97, p: { x: -40.05 } },
              { t: this.shape_7, p: { x: -35.975 } },
              { t: this.shape_23, p: { x: -25.625, y: 1.875 } },
              { t: this.shape_50, p: { x: -18.075, y: 2.075 } },
              { t: this.shape_49, p: { x: -8.375, y: 1.875 } },
              { t: this.shape_77, p: { x: 1.375 } },
              { t: this.shape_5, p: { x: 8.475 } },
              { t: this.shape_54, p: { x: 15.175, y: 1.975 } },
              { t: this.shape_140 },
              { t: this.shape_38, p: { x: 28.675, y: 1.975 } },
              { t: this.shape_59, p: { x: 34.275, y: 1.975 } },
              { t: this.shape_21, p: { x: 43.825, y: 1.875 } },
              { t: this.shape_10, p: { x: 57.175 } },
              { t: this.shape_139 },
              { t: this.shape_25, p: { x: -49.225, y: 18.475 } },
              { t: this.shape_41, p: { x: -41.775, y: 18.575 } },
              { t: this.shape_121, p: { x: -33.975 } },
              { t: this.shape_90, p: { x: -28.8 } },
              { t: this.shape_61, p: { x: -23.575 } },
              { t: this.shape_138, p: { x: -12.275 } },
              { t: this.shape_137 },
              { t: this.shape_79, p: { x: -1.475, y: 19.625 } },
              { t: this.shape_136 },
              { t: this.shape_36, p: { x: 8.225 } },
              { t: this.shape_16, p: { x: 18.575, y: 18.375 } },
              { t: this.shape_22, p: { x: 26.125, y: 18.575 } },
              { t: this.shape_2, p: { x: 35.825, y: 18.375 } },
              { t: this.shape_40, p: { x: 45.575 } },
              { t: this.shape_1, p: { x: 52.675 } },
              { t: this.shape_18, p: { x: 59.375, y: 18.475 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_145, p: { x: -55.25 } },
              { t: this.shape_22, p: { x: -47.425, y: -14.425 } },
              { t: this.shape_20, p: { x: -39.625 } },
              { t: this.shape_134, p: { x: -33.675 } },
              { t: this.shape_18, p: { x: -28.225, y: -14.525 } },
              { t: this.shape_24, p: { x: -23.075 } },
              { t: this.shape_142, p: { x: -16 } },
              { t: this.shape_132, p: { x: -10.625 } },
              { t: this.shape_78, p: { x: -2.45 } },
              { t: this.shape_23, p: { x: 3.025, y: -14.625 } },
              { t: this.shape_86, p: { x: 13.425 } },
              { t: this.shape_69, p: { x: 19.575 } },
              { t: this.shape_31, p: { x: 26.925, y: -14.55 } },
              { t: this.shape_26, p: { x: 37.125 } },
              { t: this.shape_19, p: { x: 43.025, y: -14.55 } },
              { t: this.shape_16, p: { x: 50.425, y: -14.625 } },
              { t: this.shape_4, p: { x: 57.4, y: -14.525 } },
              { t: this.shape_91, p: { x: -11.225, y: 3.075 } },
              { t: this.shape_125, p: { x: -6.05 } },
              { t: this.shape_10, p: { x: -1.025 } },
              { t: this.shape_146 },
              { t: this.shape_5, p: { x: 12.575 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_155 },
              { t: this.shape_53, p: { x: -29.025, y: -14.625 } },
              { t: this.shape_31, p: { x: -21.675, y: -14.55 } },
              { t: this.shape_154 },
              { t: this.shape_153 },
              { t: this.shape_152 },
              { t: this.shape_24, p: { x: 5.725 } },
              { t: this.shape_151 },
              { t: this.shape_50, p: { x: 16.625, y: -14.425 } },
              { t: this.shape_19, p: { x: 24.025, y: -14.55 } },
              { t: this.shape_25, p: { x: 35.425, y: -14.525 } },
              { t: this.shape_150 },
              { t: this.shape_2, p: { x: -50.775, y: 1.875 } },
              { t: this.shape_14, p: { x: -43.35 } },
              { t: this.shape_46, p: { x: -37.875, y: 1.875 } },
              { t: this.shape_41, p: { x: -30.325, y: 2.075 } },
              { t: this.shape_128, p: { x: -22.925 } },
              { t: this.shape_37, p: { x: -15.525, y: 1.875 } },
              { t: this.shape_15, p: { x: -8.225 } },
              { t: this.shape_48, p: { x: 1.6 } },
              { t: this.shape_149 },
              { t: this.shape_79, p: { x: 17.175, y: 3.125 } },
              { t: this.shape_54, p: { x: 24.275, y: 1.975 } },
              { t: this.shape_51, p: { x: 29.825 } },
              { t: this.shape_10, p: { x: 36.775 } },
              { t: this.shape_7, p: { x: 43.025 } },
              { t: this.shape_5, p: { x: 48.925 } },
              { t: this.shape_38, p: { x: 55.625, y: 1.975 } },
              { t: this.shape_43, p: { x: -46.775 } },
              { t: this.shape_148 },
              { t: this.shape_147 },
              { t: this.shape_23, p: { x: -25.825, y: 18.375 } },
              { t: this.shape_92, p: { x: -14.65 } },
              { t: this.shape_22, p: { x: -7.875, y: 18.575 } },
              { t: this.shape_40, p: { x: -0.075 } },
              { t: this.shape_36, p: { x: 5.875 } },
              { t: this.shape_18, p: { x: 11.325, y: 18.475 } },
              { t: this.shape_3, p: { x: 16.475 } },
              { t: this.shape_35, p: { x: 24.125 } },
              { t: this.shape_61, p: { x: 31.475 } },
              { t: this.shape_16, p: { x: 38.875, y: 18.375 } },
              { t: this.shape_138, p: { x: 46.175 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_135, p: { x: -46.95 } },
              { t: this.shape_50, p: { x: -39.125, y: -14.425 } },
              { t: this.shape_20, p: { x: -31.325 } },
              { t: this.shape_132, p: { x: -25.375 } },
              { t: this.shape_38, p: { x: -19.925, y: -14.525 } },
              { t: this.shape_143, p: { x: -14.775 } },
              { t: this.shape_133, p: { x: -7.7 } },
              { t: this.shape_86, p: { x: -2.325 } },
              { t: this.shape_24, p: { x: 7.575 } },
              { t: this.shape_23, p: { x: 15.225, y: -14.625 } },
              { t: this.shape_101, p: { x: 22.45 } },
              { t: this.shape_26, p: { x: 32.625 } },
              { t: this.shape_156 },
              { t: this.shape_59, p: { x: 48.375, y: -14.525 } },
              { t: this.shape_66, p: { x: -32.075 } },
              { t: this.shape_25, p: { x: -24.475, y: 1.975 } },
              { t: this.shape_41, p: { x: -17.025, y: 2.075 } },
              { t: this.shape_77, p: { x: -9.225 } },
              { t: this.shape_99, p: { x: -4.05 } },
              { t: this.shape_5, p: { x: 1.175 } },
              { t: this.shape_81, p: { x: 7.475, y: 1.425 } },
              { t: this.shape_15, p: { x: 13.725 } },
              { t: this.shape_98, p: { x: 19.35 } },
              { t: this.shape_79, p: { x: 24.525, y: 3.125 } },
              { t: this.shape_97, p: { x: 30.15 } },
              { t: this.shape_7, p: { x: 34.225 } },
              { t: this.shape_16, p: { x: -22.075, y: 18.375 } },
              { t: this.shape_22, p: { x: -14.525, y: 18.575 } },
              { t: this.shape_2, p: { x: -4.825, y: 18.375 } },
              { t: this.shape_40, p: { x: 4.925 } },
              { t: this.shape_1, p: { x: 12.025 } },
              { t: this.shape_18, p: { x: 18.725, y: 18.475 } },
              { t: this.shape_65, p: { x: 23.9 } },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-63, -25.3, 130, 68);

  (lib.ruleheader = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAnQgKgOAAgZQAAgZAKgOQAJgOASAAQARAAAKANQAJANAAAVIAAANIgxAAQABAOAEAGQAFAGAJAAQAHAAAGgBQAGgCAGgEIAAAUQgMAIgQAAQgVAAgJgPgAgHgcQgEAGAAAMIAZAAQAAgLgDgGQgEgHgGAAQgFAAgDAGg',
      );
    this.shape.setTransform(99.275, 132.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f('#000000').s().p('AgMBIIAAiPIAZAAIAACPg');
    this.shape_1.setTransform(92.6, 130.775);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgKAAgSIAAhDIAZAAIAAA7QAAAYAKAAQAIAAACgIQADgIAAgPIAAg0IAZAAIAABnIgUAAIgCgOIgBAAQgIAQgPAAQgNAAgHgKg',
      );
    this.shape_2.setTransform(85.55, 132.9);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AANBEIgUg1IgIAAIAAA1IgaAAIAAiHIAfAAQAsAAAAAnQAAANgFAJQgEAIgLAGIAcA8gAgPgFIAFAAQASAAgBgVQAAgTgRAAIgFAAg',
      );
    this.shape_3.setTransform(76.5, 131.225);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA9QgLgJgFgPQgFgQAAgVQAAgiAMgRQAMgSAXAAQARAAAKAIQALAJAFAQQAFAPAAAVQAAAVgFAQQgFAQgLAIQgLAJgQAAQgPAAgLgJgAgUAAQAAAvAUAAQALAAAFgMQAFgLAAgYQAAgugVAAQgUAAAAAug',
      );
    this.shape_4.setTransform(62.025, 131.2);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AAOBEIgWg1IgHAAIAAA1IgaAAIAAiHIAfAAQAsAAAAAnQAAANgFAJQgEAIgLAGIAcA8gAgPgFIAFAAQASAAgBgVQAAgTgRAAIgFAAg',
      );
    this.shape_5.setTransform(52.1, 131.225);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p('AgdBEIAAiHIA7AAIAAAWIghAAIAAAgIAfAAIAAAVIgfAAIAAAlIAhAAIAAAXg');
    this.shape_6.setTransform(42.8, 131.225);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p('AgjBEIAAgTIAqheIgqAAIAAgWIBGAAIAAATIgqBdIAsAAIAAAXg');
    this.shape_7.setTransform(34.5, 131.225);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AgeA7QgIgOAAgaQAAgYAIgOQAIgPAOAAQAOAAAIAQIABAAIgBgLIAAgHIAAgkIAZAAIAACPIgUAAIgEgLIgBAAQgFAHgFADQgEADgHAAQgPAAgIgOgAgNATQAAAhANAAQAHAAADgHQAEgHAAgQIAAgFQAAgQgEgGQgDgHgHAAQgNAAAAAfg',
      );
    this.shape_8.setTransform(93.125, 101.475);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgeA7QgIgOAAgaQAAgYAIgOQAIgPAOAAQAOAAAIAQIABAAIgBgLIAAgHIAAgkIAZAAIAACPIgUAAIgEgLIgBAAQgFAHgFADQgEADgHAAQgPAAgIgOgAgNATQAAAhANAAQAHAAADgHQAEgHAAgQIAAgFQAAgQgEgGQgDgHgHAAQgNAAAAAfg',
      );
    this.shape_9.setTransform(83.625, 101.475);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAWBEIgHghIgdAAIgHAhIgcAAIAhiHIAgAAIAiCHgAgBgkIgCANIgHAjIAVAAIgHgiIgDgNIgBgMIgBALg',
      );
    this.shape_10.setTransform(74.05, 101.825);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'AgQA0QgHgBgGgDIAAgYQAFAEAGACQAHACAHABQAJgBAAgJQAAgEgCgDQgDgEgJgFQgKgFgFgGQgFgIAAgLQAAgOAIgIQAJgIANAAQAIAAAHADQAHACAGADIgHATIgJgEQgFgCgFAAQgJAAAAAIQAAAAAAABQAAAAABABQAAAAAAABQAAABABAAIAEAFIAJAFQAJAGAGAHQAGAGAAANQAAAQgJAHQgIAJgPAAQgIAAgGgCg',
      );
    this.shape_11.setTransform(62.125, 103.4);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p('AgdBEIAAiHIA7AAIAAAWIghAAIAAAlIAfAAIAAAVIgfAAIAAA3g');
    this.shape_12.setTransform(54.925, 101.825);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics.f('#000000').s().p('AgMBEIAAiHIAZAAIAACHg');
    this.shape_13.setTransform(48.15, 101.825);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p('AgOBEIgiiHIAbAAIARBMIACAKIACALIAAAKIABgKIACgLIACgKIARhMIAbAAIgiCHg');
    this.shape_14.setTransform(40.775, 101.825);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgKAAgSIAAhDIAZAAIAAA7QgBAYALAAQAIAAACgIQADgIABgPIAAg0IAYAAIAABnIgUAAIgCgOIgBAAQgIAQgPAAQgNAAgHgKg',
      );
    this.shape_15.setTransform(82.5, 132.9);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p('AgeBEIAAiHIA9AAIAAAWIgjAAIAAAgIAgAAIAAAVIggAAIAAAlIAjAAIAAAXg');
    this.shape_16.setTransform(60.75, 131.225);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AARBEIgoheIAAAAIABASIAAANIAAA/IgYAAIAAiHIAfAAIAmBcIABAAIgBgSIgBgMIAAg+IAZAAIAACHg',
      );
    this.shape_17.setTransform(50.6, 131.225);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics.f('#000000').s().p('AgMBIIAAiPIAYAAIAACPg');
    this.shape_18.setTransform(104.05, 130.775);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgKAAgSIAAhDIAZAAIAAA7QgBAYAKAAQAJAAACgIQAEgIAAgPIAAg0IAYAAIAABnIgUAAIgCgOIgBAAQgIAQgPAAQgNAAgHgKg',
      );
    this.shape_19.setTransform(97, 132.9);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p(
        'AANBEIgUg1IgIAAIAAA1IgbAAIAAiHIAgAAQAsAAAAAnQAAANgFAJQgEAIgLAGIAcA8gAgPgFIAGAAQARAAAAgVQgBgTgRAAIgFAAg',
      );
    this.shape_20.setTransform(87.95, 131.225);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AAOBEIgWg1IgIAAIAAA1IgZAAIAAiHIAfAAQAsAAAAAnQAAANgFAJQgEAIgKAGIAbA8gAgQgFIAGAAQARAAAAgVQAAgTgRAAIgGAAg',
      );
    this.shape_21.setTransform(53.8, 131.225);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p(
        'AANBEIgUg1IgJAAIAAA1IgaAAIAAiHIAgAAQAsAAAAAnQAAANgFAJQgFAIgJAGIAcA8gAgQgFIAHAAQAQAAABgVQAAgTgSAAIgGAAg',
      );
    this.shape_22.setTransform(44.05, 131.225);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p(
        'AAkBEIAAhFIABgOIABgQIgBAAIgbBjIgUAAIgahjIgBAAIABARIAAANIAABFIgYAAIAAiHIAkAAIAYBcIABAAIAZhcIAjAAIAACHg',
      );
    this.shape_23.setTransform(26.225, 131.225);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics.f('#000000').s().p('AgMBEIAAiHIAZAAIAACHg');
    this.shape_24.setTransform(48.15, 101.825);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AgbA1QgJgQAAglQAAgjAJgRQAJgRASAAQAmAAAABFQgBAUgDAQQgDAQgJAJQgHAJgPAAQgRAAgKgRgAgIgiQgDALAAAXQAAAYADAMQACALAGAAQAHAAADgLQABgMAAgYQAAgXgBgLQgDgMgHAAQgFAAgDAMg',
      );
    this.shape_25.setTransform(96.15, 131.225);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p('AAEBEIAAhOIABgZIgEAEIgCAFIgMAMIgQgPIAkgmIAXAAIAACHg');
    this.shape_26.setTransform(86.65, 131.225);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f('#000000')
      .s()
      .p('AgmAXIAxgXIgxgWIAAgWIBNAmIAAANIhNAmg');
    this.shape_27.setTransform(74.9, 131.175);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f('#000000')
      .s()
      .p(
        'AgeA5QgLgLAAgXIAAhbIAaAAIAABaQAAANAEAFQAEAGAHAAQAIAAAEgGQAEgFAAgNIAAhaIAaAAIAABaQAAAYgLALQgLAMgUAAQgTAAgLgMg',
      );
    this.shape_28.setTransform(47, 131.325);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#000000')
      .s()
      .p(
        'AgTBEQgIgCgIgEIAAgaQAIAEAIADQAIACAHAAQAGAAAEgEQADgEAAgGQAAgFgBgDQgBgDgEgEIgLgIQgIgEgGgFQgFgFgEgHQgDgHAAgLQAAgRAKgKQALgLARAAQAIAAAIACQAIADAHAEIgHAXQgNgIgKAAQgGAAgDAEQgEADAAAGQAAAFACADQABAEAEADIALAHQANAIAGAIQAHAJAAANQAAAMgFAKQgFAJgJAFQgJAGgLAAQgJAAgHgCg',
      );
    this.shape_29.setTransform(37.525, 131.2239);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#000000')
      .s()
      .p(
        'AgWApQgJgOAAgbQAAgOAEgMQAEgNAJgHQAIgHANAAQAIAAAGACQAGACAFADIgGAUQgJgGgIAAQgIAAgDAJQgEAJAAAOQAAAgAPABQALAAAKgIIAAAVQgFAEgGACQgGACgGAAQgTAAgKgNg',
      );
    this.shape_30.setTransform(92.525, 132.8);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAxQgFgEgCgIQgDgIAAgIQAAgQAJgHQAJgIAQgBIANgBIAAgEQAAgJgDgDQgDgFgGAAQgIAAgMAHIgHgSQAOgJATAAQAPAAAHAJQAIAKAAASIAABEIgSAAIgEgOIAAAAQgFAIgGAEQgEAEgKAAQgJAAgFgFgAgKAUQAAAOAJAAQAFAAAEgGQAEgFAAgKIAAgJIgHAAQgPABAAAPg',
      );
    this.shape_31.setTransform(83.95, 132.8);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f('#000000')
      .s()
      .p(
        'AglBEIAAiHIAjAAQAUAAAKALQAKALAAAUQAAAVgLALQgKANgUAAIgIAAIAAAwgAgLgCIAFAAQAIAAAFgFQAFgFAAgNQAAgKgEgFQgFgFgHAAIgHAAg',
      );
    this.shape_32.setTransform(70.875, 131.225);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f('#000000')
      .s()
      .p(
        'AgQA1QgHgCgGgDIAAgYQAFADAGADQAHADAHAAQAJAAAAgKQAAgEgCgDQgDgEgJgEQgKgGgFgHQgFgHAAgMQAAgNAIgIQAJgIANAAQAIAAAHACQAHACAGAEIgHATIgJgEQgFgDgFAAQgJABAAAHQAAABAAABQAAAAABABQAAAAAAABQAAAAABABIAEAEIAJAHQAJAFAGAGQAGAIAAALQAAARgJAHQgIAJgPAAQgIAAgGgBg',
      );
    this.shape_33.setTransform(58.975, 132.8);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f('#000000')
      .s()
      .p(
        'AANA1IAAg9QAAgLgDgFQgCgGgGAAQgHAAgDAIQgDAHAAASIAAAyIgZAAIAAhnIATAAIAEAOIABAAQAHgQAPAAQANAAAHAJQAHAKAAASIAABEg',
      );
    this.shape_34.setTransform(50.65, 132.7);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAnQgKgOAAgZQAAgZAKgOQAJgOASAAQARAAAKANQAJANAAAVIAAANIgxAAQABAOAEAGQAFAGAJAAQAHAAAGgBQAGgCAGgEIAAAUQgMAIgQAAQgVAAgJgPgAgHgcQgEAGAAAMIAZAAQAAgLgDgGQgEgHgGAAQgFAAgDAGg',
      );
    this.shape_35.setTransform(41.575, 132.825);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f('#000000')
      .s()
      .p('AgLBEIAAhwIgaAAIAAgXIBLAAIAAAXIgZAAIAABwg');
    this.shape_36.setTransform(33.1, 131.225);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgKAAIAAgOIAMgGIAGgXIAQAAIAAAWIASAAIAAAVIgSAAIAAAyQAAAGACADQACADAEAAQAFAAAHgDIAAAUQgJAFgLAAQgNAAgFgIg',
      );
    this.shape_37.setTransform(105.5, 131.8);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhmIAXAAIAABmgAgNg5QAAgPANAAQANAAAAAPQAAAOgNAAQgNAAAAgOg');
    this.shape_38.setTransform(100.2, 130.75);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f('#000000')
      .s()
      .p(
        'AggBEQgJgHAAgOQAAgJAFgHQAFgGAJgDQgEgCgDgEQgDgEAAgFQAAgGADgDIAHgIQgGgDgEgJQgDgIAAgKQAAgQAJgJQAJgKAQAAIAIABIAFABIAeAAIAAAPIgMADQADAHAAAJQAAAQgJAKQgJAJgPAAIgIgBIgDADIgBAFQAAAGALAAIAQAAQANAAAGAHQAHAHAAAPQAAASgMAKQgMAKgWAAQgRgBgKgHgAgPAiQgDAEAAAGQAAAHAEADQAEADAHAAQAKAAAFgEQAGgEAAgIQAAgGgDgCQgDgCgIAAIgMAAQgFAAgCADgAgKgnQAAASAKAAQAIAAAAgSQAAgTgIAAQgKAAAAATg',
      );
    this.shape_39.setTransform(93.525, 135);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f('#000000')
      .s()
      .p('AgLBIIAAhmIAYAAIAABmgAgMg5QgBgPANAAQANAAAAAPQAAAOgNAAQgNAAABgOg');
    this.shape_40.setTransform(86.85, 130.75);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAAOARQANARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAGgLQAIgMgBgWQAAgXgGgLQgHgKgMAAIgHAAg',
      );
    this.shape_41.setTransform(79.45, 131.225);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics.f('#000000').s().p('AgLBIIAAiPIAYAAIAACPg');
    this.shape_42.setTransform(59.55, 130.775);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f('#000000')
      .s()
      .p(
        'AgDBGQgFgDgFgHIgBAAIgEALIgUAAIAAiPIAZAAIAAAkIAAAHIgBALIABAAQAEgIAGgEQAFgDAHAAQAOAAAIAOQAIAOAAAYQAAAZgIAPQgIAOgOAAQgIAAgEgDgAgKgEQgDAGAAAOIAAAFQAAAQAEAIQADAHAHAAQAGAAADgIQAEgIAAgRQAAgfgNAAQgIAAgDAIg',
      );
    this.shape_43.setTransform(52.675, 130.875);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAuQgJgHgFgMQgEgMAAgPQAAgPAEgMQAFgMAJgHQAIgHANAAQASAAALAOQAKAOABAZQAAAOgFAMQgDANgJAHQgJAIgOAAQgNAAgIgIgAgKgYQgEAIABAQQgBAQAEAJQADAIAHAAQAHAAAEgIQADgJAAgQQAAgQgDgIQgEgIgHAAQgHAAgDAIg',
      );
    this.shape_44.setTransform(33.65, 132.8);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAANARQAOARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAGgLQAIgMAAgWQgBgXgGgLQgHgKgMAAIgHAAg',
      );
    this.shape_45.setTransform(23.9, 131.225);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgKAAIAAgOIAMgGIAFgXIARAAIAAAWIASAAIAAAVIgSAAIAAAyQAAAGABAEQACACAFAAQAGAAAFgCIAAATQgIAFgLAAQgMAAgGgIg',
      );
    this.shape_46.setTransform(111.65, 102.4);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f('#000000')
      .s()
      .p(
        'AgWApQgJgOAAgbQAAgPAEgMQAEgMAJgHQAIgHANAAQAIAAAGACQAGABAFAEIgGAUQgJgGgIABQgIAAgDAIQgEAJAAAOQAAAhAPAAQALgBAKgHIAAAVQgFAEgGACQgGACgGAAQgTAAgKgNg',
      );
    this.shape_47.setTransform(105.025, 103.4);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAxQgFgEgDgIQgCgIAAgHQAAgRAJgHQAJgIAQgBIAMgBIAAgEQAAgJgCgEQgDgEgGAAQgIAAgMAHIgHgSQAOgJATAAQAPAAAHAJQAIAKAAATIAABDIgSAAIgEgOIAAAAQgFAIgGAEQgEAEgKAAQgIAAgGgFgAgKAVQAAANAJAAQAFAAAEgFQADgGAAgKIAAgJIgGAAQgPABAAAQg',
      );
    this.shape_48.setTransform(96.45, 103.4);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA1IAAhnIATAAIAEARIABAAQACgIAFgFQAGgGAHAAIAJACIgDAaQgDgCgFAAQgJABgFAGQgDAIAAALIAAA1g',
      );
    this.shape_49.setTransform(89.475, 103.3);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f('#000000')
      .s()
      .p(
        'AgKA4QgGgJAAgQIAAgzIgLAAIAAgOIANgGIAFgXIAQAAIAAAWIATAAIAAAVIgTAAIAAAyQAAAGACAEQADACAEAAQAFAAAGgCIAAATQgIAFgLAAQgNAAgFgIg',
      );
    this.shape_50.setTransform(82.7, 102.4);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics
      .f('#000000')
      .s()
      .p(
        'AgdArQgHgLAAgRIAAhDIAZAAIAAA7QgBAYAKAAQAJAAACgIQAEgJAAgOIAAg0IAYAAIAABnIgUAAIgCgNIgBAAQgIAPgPAAQgNAAgHgKg',
      );
    this.shape_51.setTransform(65.5, 103.5);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAAOARQANARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAHgLQAGgMAAgWQABgXgHgLQgGgKgMAAIgIAAg',
      );
    this.shape_52.setTransform(103.15, 131.225);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAANARQAOARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAHgLQAGgMABgWQAAgXgHgLQgGgKgMAAIgIAAg',
      );
    this.shape_53.setTransform(92.55, 131.225);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f('#000000')
      .s()
      .p(
        'AAkA1IAAg8QAAgXgKAAQgIAAgCAIQgDAHgBAQIAAA0IgXAAIAAg9QAAgWgKAAQgIAAgDAJQgCAJgBAPIAAAyIgZAAIAAhnIAUAAIADAOIACAAQAFgQATAAQAIAAAFAFQAFAEACAGIACAAQAEgHAFgEQAGgEAJAAQAaAAAAAlIAABEg',
      );
    this.shape_54.setTransform(76.55, 132.7);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAuQgJgHgFgMQgDgMAAgPQAAgPADgMQAEgMAKgHQAIgHANAAQASAAAKAOQALAOAAAZQAAAOgDAMQgEANgJAHQgJAIgOAAQgNAAgIgIgAgKgYQgEAIAAAQQAAAQAEAJQAEAIAGAAQAIAAADgIQADgJAAgQQAAgQgDgIQgDgIgIAAQgGAAgEAIg',
      );
    this.shape_55.setTransform(64.85, 132.8);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f('#000000')
      .s()
      .p(
        'AgaA1IAAhnIATAAIAEARIABAAQACgHAFgGQAGgGAHAAIAJABIgDAbQgDgBgFAAQgJgBgFAIQgDAHAAALIAAA1g',
      );
    this.shape_56.setTransform(57.375, 132.7);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f('#000000')
      .s()
      .p(
        'AgRBJIAAhTIgMAAIAAgNIAMgHIAAgDQABgUAGgJQAGgKANAAIAKABIALAEIgGASIgFgBIgEgBQgEAAgCAEQgCADAAAJIAAAFIARAAIAAAUIgRAAIAABTg',
      );
    this.shape_57.setTransform(51.1, 130.725);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f('#000000')
      .s()
      .p(
        'AgqBEIAAiHIAiAAQAYAAAOARQANARAAAfQAAAhgOATQgOASgZAAgAgQAtIAGAAQANAAAGgLQAIgMgBgWQAAgXgGgLQgGgKgNAAIgHAAg',
      );
    this.shape_58.setTransform(39.5, 131.225);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f('#000000')
      .s()
      .p(
        'AgTBEQgIgCgIgEIAAgaQAIAEAIADQAIACAHAAQAGAAAEgEQADgEAAgGQAAgFgBgDQgBgDgEgEIgLgIQgIgEgGgFQgFgFgEgHQgDgHAAgLQAAgRAKgKQALgLARAAQAIAAAIACQAIADAHAEIgHAXQgNgIgKAAQgGAAgDAEQgEADAAAGQAAAFACADQABAEAEADIALAHQANAIAGAIQAHAJAAANQAAAMgFAKQgFAJgJAFQgJAGgLAAQgJAAgHgCg',
      );
    this.shape_59.setTransform(56.625, 101.8239);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f('#000000')
      .s()
      .p(
        'AgDBGQgFgDgFgHIgBAAIgEALIgUAAIAAiPIAZAAIAAAkIAAAHIgBALIABAAQAEgIAGgEQAFgDAHAAQAOAAAIAOQAIAOAAAYQAAAZgIAPQgIAOgOAAQgIAAgEgDgAgKgEQgDAGAAAOIAAAFQAAAQAEAIQADAHAHAAQAGAAADgIQAEgIAAgRQAAgfgNAAQgIAAgDAIg',
      );
    this.shape_60.setTransform(75.175, 101.475);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_14, p: { x: 40.775 } },
            { t: this.shape_13, p: { x: 48.15, y: 101.825 } },
            { t: this.shape_12, p: { x: 54.925 } },
            { t: this.shape_11, p: { x: 62.125 } },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4, p: { x: 62.025 } },
            { t: this.shape_3, p: { x: 76.5 } },
            { t: this.shape_2 },
            { t: this.shape_1, p: { x: 92.6 } },
            { t: this.shape, p: { x: 99.275 } },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 40.775 } },
              { t: this.shape_13, p: { x: 48.15, y: 101.825 } },
              { t: this.shape_12, p: { x: 54.925 } },
              { t: this.shape_11, p: { x: 62.125 } },
              { t: this.shape_10 },
              { t: this.shape_9 },
              { t: this.shape_8 },
              { t: this.shape_4, p: { x: 39.075 } },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_3, p: { x: 73.45 } },
              { t: this.shape_15 },
              { t: this.shape_1, p: { x: 89.55 } },
              { t: this.shape, p: { x: 96.225 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 40.775 } },
              { t: this.shape_24, p: { x: 48.15 } },
              { t: this.shape_12, p: { x: 54.925 } },
              { t: this.shape_11, p: { x: 62.125 } },
              { t: this.shape_10 },
              { t: this.shape_9 },
              { t: this.shape_8 },
              { t: this.shape_23, p: { x: 26.225 } },
              { t: this.shape_13, p: { x: 36.05, y: 131.225 } },
              { t: this.shape_22 },
              { t: this.shape_21 },
              { t: this.shape_4, p: { x: 63.725 } },
              { t: this.shape_3, p: { x: 74.8 } },
              { t: this.shape_20 },
              { t: this.shape_19, p: { x: 97 } },
              { t: this.shape_18 },
              { t: this.shape, p: { x: 110.725 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 40.775 } },
              { t: this.shape_13, p: { x: 48.15, y: 101.825 } },
              { t: this.shape_12, p: { x: 54.925 } },
              { t: this.shape_11, p: { x: 62.125 } },
              { t: this.shape_10 },
              { t: this.shape_9 },
              { t: this.shape_8 },
              { t: this.shape_29, p: { x: 37.525, y: 131.2239 } },
              { t: this.shape_28 },
              { t: this.shape_23, p: { x: 59.675 } },
              { t: this.shape_27 },
              { t: this.shape_26 },
              { t: this.shape_25 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 40.775 } },
              { t: this.shape_13, p: { x: 48.15, y: 101.825 } },
              { t: this.shape_12, p: { x: 54.925 } },
              { t: this.shape_11, p: { x: 62.125 } },
              { t: this.shape_10 },
              { t: this.shape_9 },
              { t: this.shape_8 },
              { t: this.shape_36 },
              { t: this.shape_35 },
              { t: this.shape_34 },
              { t: this.shape_33, p: { x: 58.975 } },
              { t: this.shape_32 },
              { t: this.shape_1, p: { x: 77.5 } },
              { t: this.shape_31 },
              { t: this.shape_30 },
              { t: this.shape, p: { x: 100.575 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 40.775 } },
              { t: this.shape_13, p: { x: 48.15, y: 101.825 } },
              { t: this.shape_12, p: { x: 54.925 } },
              { t: this.shape_11, p: { x: 62.125 } },
              { t: this.shape_10 },
              { t: this.shape_9 },
              { t: this.shape_8 },
              { t: this.shape_45 },
              { t: this.shape_44 },
              { t: this.shape_19, p: { x: 43 } },
              { t: this.shape_43, p: { x: 52.675, y: 130.875 } },
              { t: this.shape_42 },
              { t: this.shape, p: { x: 66.225 } },
              { t: this.shape_41 },
              { t: this.shape_40 },
              { t: this.shape_39 },
              { t: this.shape_38 },
              { t: this.shape_37 },
              { t: this.shape_33, p: { x: 112.075 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 24.175 } },
              { t: this.shape_13, p: { x: 31.55, y: 101.825 } },
              { t: this.shape_12, p: { x: 38.325 } },
              { t: this.shape_11, p: { x: 45.525 } },
              { t: this.shape_29, p: { x: 56.625, y: 101.8239 } },
              { t: this.shape_51 },
              { t: this.shape_43, p: { x: 75.175, y: 101.475 } },
              { t: this.shape_50 },
              { t: this.shape_49 },
              { t: this.shape_48 },
              { t: this.shape_47 },
              { t: this.shape_46 },
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4, p: { x: 62.025 } },
              { t: this.shape_3, p: { x: 76.5 } },
              { t: this.shape_2 },
              { t: this.shape_1, p: { x: 92.6 } },
              { t: this.shape, p: { x: 99.275 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 24.175 } },
              { t: this.shape_13, p: { x: 31.55, y: 101.825 } },
              { t: this.shape_12, p: { x: 38.325 } },
              { t: this.shape_11, p: { x: 45.525 } },
              { t: this.shape_29, p: { x: 56.625, y: 101.8239 } },
              { t: this.shape_51 },
              { t: this.shape_43, p: { x: 75.175, y: 101.475 } },
              { t: this.shape_50 },
              { t: this.shape_49 },
              { t: this.shape_48 },
              { t: this.shape_47 },
              { t: this.shape_46 },
              { t: this.shape_4, p: { x: 39.075 } },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_3, p: { x: 73.45 } },
              { t: this.shape_15 },
              { t: this.shape_1, p: { x: 89.55 } },
              { t: this.shape, p: { x: 96.225 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 24.175 } },
              { t: this.shape_24, p: { x: 31.55 } },
              { t: this.shape_12, p: { x: 38.325 } },
              { t: this.shape_11, p: { x: 45.525 } },
              { t: this.shape_29, p: { x: 56.625, y: 101.8239 } },
              { t: this.shape_51 },
              { t: this.shape_43, p: { x: 75.175, y: 101.475 } },
              { t: this.shape_50 },
              { t: this.shape_49 },
              { t: this.shape_48 },
              { t: this.shape_47 },
              { t: this.shape_46 },
              { t: this.shape_23, p: { x: 26.225 } },
              { t: this.shape_13, p: { x: 36.05, y: 131.225 } },
              { t: this.shape_22 },
              { t: this.shape_21 },
              { t: this.shape_4, p: { x: 63.725 } },
              { t: this.shape_3, p: { x: 74.8 } },
              { t: this.shape_20 },
              { t: this.shape_19, p: { x: 97 } },
              { t: this.shape_18 },
              { t: this.shape, p: { x: 110.725 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 24.175 } },
              { t: this.shape_13, p: { x: 31.55, y: 101.825 } },
              { t: this.shape_12, p: { x: 38.325 } },
              { t: this.shape_11, p: { x: 45.525 } },
              { t: this.shape_59 },
              { t: this.shape_51 },
              { t: this.shape_43, p: { x: 75.175, y: 101.475 } },
              { t: this.shape_50 },
              { t: this.shape_49 },
              { t: this.shape_48 },
              { t: this.shape_47 },
              { t: this.shape_46 },
              { t: this.shape_29, p: { x: 29.875, y: 131.2239 } },
              { t: this.shape_58 },
              { t: this.shape_57 },
              { t: this.shape_56 },
              { t: this.shape_55 },
              { t: this.shape_54 },
              { t: this.shape_53 },
              { t: this.shape_52 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 24.175 } },
              { t: this.shape_13, p: { x: 31.55, y: 101.825 } },
              { t: this.shape_12, p: { x: 38.325 } },
              { t: this.shape_11, p: { x: 45.525 } },
              { t: this.shape_29, p: { x: 56.625, y: 101.8239 } },
              { t: this.shape_51 },
              { t: this.shape_43, p: { x: 75.175, y: 101.475 } },
              { t: this.shape_50 },
              { t: this.shape_49 },
              { t: this.shape_48 },
              { t: this.shape_47 },
              { t: this.shape_46 },
              { t: this.shape_36 },
              { t: this.shape_35 },
              { t: this.shape_34 },
              { t: this.shape_33, p: { x: 58.975 } },
              { t: this.shape_32 },
              { t: this.shape_1, p: { x: 77.5 } },
              { t: this.shape_31 },
              { t: this.shape_30 },
              { t: this.shape, p: { x: 100.575 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 24.175 } },
              { t: this.shape_13, p: { x: 31.55, y: 101.825 } },
              { t: this.shape_12, p: { x: 38.325 } },
              { t: this.shape_11, p: { x: 45.525 } },
              { t: this.shape_29, p: { x: 56.625, y: 101.8239 } },
              { t: this.shape_51 },
              { t: this.shape_60 },
              { t: this.shape_50 },
              { t: this.shape_49 },
              { t: this.shape_48 },
              { t: this.shape_47 },
              { t: this.shape_46 },
              { t: this.shape_45 },
              { t: this.shape_44 },
              { t: this.shape_19, p: { x: 43 } },
              { t: this.shape_43, p: { x: 52.675, y: 130.875 } },
              { t: this.shape_42 },
              { t: this.shape, p: { x: 66.225 } },
              { t: this.shape_41 },
              { t: this.shape_40 },
              { t: this.shape_39 },
              { t: this.shape_38 },
              { t: this.shape_37 },
              { t: this.shape_33, p: { x: 112.075 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_14, p: { x: 24.175 } },
              { t: this.shape_13, p: { x: 31.55, y: 101.825 } },
              { t: this.shape_12, p: { x: 38.325 } },
              { t: this.shape_11, p: { x: 45.525 } },
              { t: this.shape_29, p: { x: 56.625, y: 101.8239 } },
              { t: this.shape_51 },
              { t: this.shape_60 },
              { t: this.shape_50 },
              { t: this.shape_49 },
              { t: this.shape_48 },
              { t: this.shape_47 },
              { t: this.shape_46 },
              { t: this.shape_45 },
              { t: this.shape_44 },
              { t: this.shape_19, p: { x: 43 } },
              { t: this.shape_43, p: { x: 52.675, y: 130.875 } },
              { t: this.shape_42 },
              { t: this.shape, p: { x: 66.225 } },
              { t: this.shape_41 },
              { t: this.shape_40 },
              { t: this.shape_39 },
              { t: this.shape_38 },
              { t: this.shape_37 },
              { t: this.shape_33, p: { x: 112.075 } },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(14, 85.3, 106, 60.8);

  (lib.OperationButtons = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(4));

    // icon
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p('AAxgwIBqAAAiaAxIAAhhIBqAAIAAhqIBhAAAgwCbIAAhq');
    this.shape.setTransform(-0.05, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p('AAxiaIAABqACbgwIAABhIhqAAIAABqIhhAAAgwAxIhqAA');
    this.shape_1.setTransform(-0.05, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AgvCbIAAhqIhrAAIAAhhIBrAAIAAhqIBgAAIAABqIBqAAIAABhIhqAAIAABqg');
    this.shape_2.setTransform(-0.05, 0);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics.f().s('#666666').ss(1, 1, 1).p('AiaAxIAAhhIE1AA');
    this.shape_3.setTransform(-0.05, 0.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics.f().s('#CCCCCC').ss(1, 1, 1).p('ACbgwIAABhIk1AA');
    this.shape_4.setTransform(-0.05, 0.025);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AiaAxIAAhhIE1AAIAABhg');
    this.shape_5.setTransform(-0.05, 0.025);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p('ACQApIhFBFIhLhLIhKBLIhFhFAhEgiIhLhLACQhtIhLBL');
    this.shape_6.setTransform(0.05, 3.5);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p('AiPgoIBFhFIBKBLIBLhLIBFBFAiPBuIBLhMABFAiIBLBM');
    this.shape_7.setTransform(0.05, -3.4);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p('AAABFIhKBLIhFhFIBLhLIhLhKIBFhFIBKBLIBLhLIBFBFIhLBKIBLBLIhFBFg');
    this.shape_8.setTransform(0.05, 0.05);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f()
      .s('#666666')
      .ss(1, 1, 1)
      .p(
        'AgZhPQgDgEgDgDQgJgOACgPQADgQAOgJQAMgJAPADQAIABAMAHAgZCUQgDgEgDgDQgJgOACgPQADgQAOgJQAMgJAPADQAIABALAGAiaA1IAAhhIE1AA',
      );
    this.shape_9.setTransform(0, -0.436);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f()
      .s('#CCCCCC')
      .ss(1, 1, 1)
      .p(
        'AAeiQQADAFACAFQADAKgCAKQgCAKgFAHQgDAEgFAEQgNAJgPgDQgHgBgFgDAAdBTQAKAOgDAQQgCAPgNAKQgNAJgPgDQgHgBgFgDACbg4IAABhIk1AA',
      );
    this.shape_10.setTransform(0, 0.761);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('rgba(255,255,255,0.8)')
      .s()
      .p(
        'AgGCYIgNgEIgFgFIgHgHQgJgNACgPQADgQAOgJQAMgJAPACQAIABAKAHIAFAGQAKAPgDAQQgCAPgNAJQgKAHgLAAIgGAAgAiaAwIAAhgIE1AAIAABggAgGhLQgIgCgFgDIgFgEIgHgHQgJgNACgQQADgPAOgJQAMgKAPADQAIABALAIIAFAFIAFAKQADAKgCAKQgCAKgFAHQgDAFgFADQgLAHgKAAIgGAAg',
      );
    this.shape_11.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .to(
          {
            state: [
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_8 },
              { t: this.shape_7 },
              { t: this.shape_6 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_11 },
              { t: this.shape_10 },
              { t: this.shape_9 },
            ],
          },
          1,
        )
        .wait(1),
    );

    // color
    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .rf(['#A415EA', '#541D67'], [0, 1], -1.9, -8.5, 0, -1.9, -8.5, 40.1)
      .s()
      .p(
        'AiODMQhVg7gRhmQgThlA7hVQA7hUBngSQBkgRBVA7QBVA7ASBmQASBlg8BUQg7BUhlATQgYAEgWAAQhLAAhBgug',
      );
    this.shape_12.setTransform(-0.0061, 0.0189);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .rf(['#1BB448', '#265945'], [0, 1], -1.9, -8.4, 0, -1.9, -8.4, 40)
      .s()
      .p(
        'AiODNQhVg8gShmQgShlA7hUQA8hUBmgTQBkgRBVA7QBUA7ATBmQASBlg8BUQg7BVhmASQgXAEgWAAQhLAAhBgtg',
      );
    this.shape_13.setTransform(0.0146, -0.0135);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .rf(['#351DE2', '#2C2659'], [0, 1], -1.9, -8.6, 0, -1.9, -8.6, 40.1)
      .s()
      .p(
        'AiODMQhVg7gShmQgShlA7hUQA8hWBmgRQBkgSBVA8QBUA7ATBmQARBlg7BUQg8BVhlASQgYAEgWAAQhLAAhAgug',
      );
    this.shape_14.setTransform(0.0045, 0);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .rf(['#FF0000', '#990000'], [0, 1], -1.8, -8.5, 0, -1.8, -8.5, 40.1)
      .s()
      .p(
        'AiODMQhVg7gShmQgShlA8hVQA7hUBmgSQBkgSBVA8QBUA7ATBmQASBlg8BUQg7BUhlATQgYAEgVAAQhMAAhBgug',
      );
    this.shape_15.setTransform(-0.0102, 0.0013);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_12 }] })
        .to({ state: [{ t: this.shape_13 }] }, 1)
        .to({ state: [{ t: this.shape_14 }] }, 1)
        .to({ state: [{ t: this.shape_15 }] }, 1)
        .wait(1),
    );

    // shine
    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .lf(
        ['rgba(255,255,255,0.502)', 'rgba(255,255,255,0)'],
        [0, 0.682],
        0,
        -19.1,
        0,
        19.2,
      )
      .s()
      .p(
        'AiHCHQg4g3AAhQQAAhPA4g4QA5g3BOAAQBPAAA5A3QA4A4AABPQAABQg4A3Qg5A4hPAAQhOAAg5g4g',
      );
    this.shape_16.setTransform(0.15, -2.3);

    this.timeline.addTween(cjs.Tween.get(this.shape_16).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-25, -25, 50, 50);

  (lib.mRectangle = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#D0DA4F')
      .s()
      .p('EgJhAp7QhBgBAAhAMAAAhRzQAAhBBBABITDAAQBBgBAABBMAAABRzQAABAhBABg');
    this.shape.setTransform(67.5, 267.25);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.mRectangle,
    new cjs.Rectangle(0, -1, 135, 536.5),
    null,
  );

  (lib.lbls = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAlQgHgJAAgQQAAgIACgGQACgGAFgFQAEgFAFgCQAGgCAGAAIAIABIAIADIAAgcIAVAAIAABaIgVAAIAAgGQgFAEgFACQgEADgGAAQgMAAgHgKgAgIgCQgEAFAAAJQAAAJAEAFQADAEAGABIAGgCIAGgDIAAgfIgFgBIgEAAQgHAAgFAEg',
      );
    this.shape.setTransform(-11.575, 0.35);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AAMAiIAAghIAAgHIgCgGQAAAAgBgBQAAAAAAAAQgBgBAAAAQgBgBgBAAIgFgBIgFABIgHADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAGgDQAEgCAHAAQAKAAAGAGQAGAHAAAMIAAAqg',
      );
    this.shape_1.setTransform(-19.8, 1.425);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAbQgGgFAAgNIAAgqIAVAAIAAAhIABAHQAAAEABACQAAAAABABQAAAAAAABQABAAAAAAQABABAAAAIAGABIAGgBIAGgDIAAguIAVAAIAABBIgVAAIAAgIIgLAIQgEACgGAAQgLAAgGgHg',
      );
    this.shape_2.setTransform(-28.4, 1.6);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAZQgKgJAAgQQAAgPAKgKQAJgJAQAAQARAAAKAJQAJAKAAAPQAAAQgJAJQgKAKgRAAQgQAAgJgKgAgEgTIgFAEIgDAGIgBAJIABAJQABAFACACIAEADIAGABIAFgBQADAAACgDIACgGIABgKIgBgJQgBgDgBgDIgFgDIgGgBIgEAAg',
      );
    this.shape_3.setTransform(-36.8, 1.5);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAhIAAhBIAVAAIAAAKQAGgGAFgCQAGgCAEAAIACAAIADAAIAAAVIgCAAIgEgBIgFAAIgIAAIgHACIAAArg',
      );
    this.shape_4.setTransform(-43.475, 1.5);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAaQgLgJAAgRQAAgPAKgKQAKgJARAAQAQAAAHAIQAJAJAAAPIAAAGIgvAAQAAAIAFAEQAGAEAJAAQAHAAAHgDIAJgEIACAAIAAAQIgNAFQgGABgIAAQgTAAgKgJgAgIgSQgEAEAAAGIAaAAQAAgGgEgEQgDgCgGAAQgGAAgDACg',
      );
    this.shape_5.setTransform(42.55, 1.5);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p(
        'AAhAiIAAghIgBgHIgBgGQAAAAAAgBQgBAAAAAAQgBgBAAAAQgBgBAAAAIgGgBIgFABIgHADIAAAuIgUAAIAAghIAAgHIgBgGIgDgDIgGgBIgGABIgGADIAAAuIgVAAIAAhBIAVAAIAAAHQAGgEAFgCQAFgDAGAAQAGAAAEADQAFADADAGQAGgGAGgDQAGgDAGAAQALAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_6.setTransform(32.275, 1.425);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAdQgHgGAAgJQAAgHAEgFQADgDAGgDQAGgDAIgBIARgBIAAgBQAAgFgEgCQgFgCgHAAIgMABIgIADIgCAAIAAgQIALgCIAPgBQARAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgEADIgFADIgFACIgIABQgJAAgGgGgAADADIgHABIgFADQgBACAAADIAAADQAAABAAAAQAAAAABABQAAAAAAAAQAAABABAAIADACIAFAAQADAAADgBIAGgDIAAgOIgJABg',
      );
    this.shape_7.setTransform(21.675, 1.525);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAtIgLgCIAAgQIACAAIAKADIAJABIAJgBQAEgBACgCIACgFIABgHIAAgBQgEADgEABQgFACgFAAQgNAAgIgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAGgCQAFgCAGAAIAJABIAIADIABgDIAUAAIAAA6QAAAJgCAGQgDAHgFADQgFAEgGABQgHACgHAAIgOgBgAgIgZQgEAFAAAIQAAAKAEACQADAEAGAAIAGgBIAGgCIAAgdIgEgBIgFgBQgHAAgFAFg',
      );
    this.shape_8.setTransform(13.475, 2.675);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAlQgHgJAAgQQAAgIACgGQACgGAFgFQAEgFAFgCQAGgCAGAAIAIABIAIADIAAgcIAVAAIAABaIgVAAIAAgGQgFAEgFACQgEADgGAAQgMAAgHgKgAgIgCQgEAFAAAJQAAAJAEAFQADAEAGABIAGgCIAGgDIAAgfIgFgBIgEAAQgHAAgFAEg',
      );
    this.shape_9.setTransform(-11.575, 0.35);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p(
        'AAMAiIAAghIAAgHIgCgGQAAAAgBgBQAAAAAAAAQgBgBAAAAQgBgBgBAAIgFgBIgFABIgHADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAGgDQAEgCAHAAQAKAAAGAGQAGAHAAAMIAAAqg',
      );
    this.shape_10.setTransform(-19.8, 1.425);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'AgaAbQgGgFAAgNIAAgqIAVAAIAAAhIABAHQAAAEABACQAAAAABABQAAAAAAABQABAAAAAAQABABAAAAIAGABIAGgBIAGgDIAAguIAVAAIAABBIgVAAIAAgIIgLAIQgEACgGAAQgLAAgGgHg',
      );
    this.shape_11.setTransform(-28.4, 1.6);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAZQgKgJAAgQQAAgPAKgKQAJgJAQAAQARAAAKAJQAJAKAAAPQAAAQgJAJQgKAKgRAAQgQAAgJgKgAgEgTIgFAEIgDAGIgBAJIABAJQABAFACACIAEADIAGABIAFgBQADAAACgDIACgGIABgKIgBgJQgBgDgBgDIgFgDIgGgBIgEAAg',
      );
    this.shape_12.setTransform(-36.8, 1.5);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAhIAAhBIAVAAIAAAKQAGgGAFgCQAGgCAEAAIACAAIADAAIAAAVIgCAAIgEgBIgFAAIgIAAIgHACIAAArg',
      );
    this.shape_13.setTransform(-43.475, 1.5);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAaQgLgJAAgRQAAgPAKgKQAKgJARAAQAQAAAHAIQAJAJAAAPIAAAGIgvAAQAAAIAFAEQAGAEAJAAQAHAAAHgDIAJgEIACAAIAAAQIgNAFQgGABgIAAQgTAAgKgJgAgIgSQgEAEAAAGIAaAAQAAgGgEgEQgDgCgGAAQgGAAgDACg',
      );
    this.shape_14.setTransform(42.55, 1.5);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AAhAiIAAghIgBgHIgBgGQAAAAAAgBQgBAAAAAAQgBgBAAAAQgBgBAAAAIgGgBIgFABIgHADIAAAuIgUAAIAAghIAAgHIgBgGIgDgDIgGgBIgGABIgGADIAAAuIgVAAIAAhBIAVAAIAAAHQAGgEAFgCQAFgDAGAAQAGAAAEADQAFADADAGQAGgGAGgDQAGgDAGAAQALAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_15.setTransform(32.275, 1.425);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAdQgHgGAAgJQAAgHAEgFQADgDAGgDQAGgDAIgBIARgBIAAgBQAAgFgEgCQgFgCgHAAIgMABIgIADIgCAAIAAgQIALgCIAPgBQARAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgEADIgFADIgFACIgIABQgJAAgGgGgAADADIgHABIgFADQgBACAAADIAAADQAAABAAAAQAAAAABABQAAAAAAAAQAAABABAAIADACIAFAAQADAAADgBIAGgDIAAgOIgJABg',
      );
    this.shape_16.setTransform(21.675, 1.525);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAtIgLgCIAAgQIACAAIAKADIAJABIAJgBQAEgBACgCIACgFIABgHIAAgBQgEADgEABQgFACgFAAQgNAAgIgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAGgCQAFgCAGAAIAJABIAIADIABgDIAUAAIAAA6QAAAJgCAGQgDAHgFADQgFAEgGABQgHACgHAAIgOgBgAgIgZQgEAFAAAIQAAAKAEACQADAEAGAAIAGgBIAGgCIAAgdIgEgBIgFgBQgHAAgFAFg',
      );
    this.shape_17.setTransform(13.475, 2.675);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_17 },
            { t: this.shape_16 },
            { t: this.shape_15 },
            { t: this.shape_14 },
            { t: this.shape_13 },
            { t: this.shape_12 },
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.lbls,
    new cjs.Rectangle(-49, -9.2, 99, 18.5),
    null,
  );

  (lib.Examples = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgTA9QgIgCgHgDIAAgcQAGAEAIADQAHADAIAAQALAAAAgLQAAgFgDgEQgDgEgLgFQgLgHgGgHQgGgJAAgNQAAgQAKgJQAKgJAQAAQAJAAAHACQAIADAIAEIgIAWIgLgGQgGgCgGAAQgJAAAAAJIABAGQABACAEADIAKAHQALAHAHAHQAHAIAAAOQAAASgKAKQgKAJgRAAQgJAAgIgBg',
      );
    this.shape.setTransform(84.475, 20.725);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p(
        'AgfAuQgLgRAAgcQAAgeALgQQALgQAVAAQAUAAALAPQALAOAAAZIAAAPIg5AAQABAQAFAIQAGAHAKAAQAIAAAHgCQAGgCAIgFIAAAYQgOAIgTAAQgYAAgLgQgAgJggQgEAGAAAPIAdAAQAAgNgEgHQgEgIgHAAQgGAAgEAHg',
      );
    this.shape_1.setTransform(75.375, 20.725);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics.f('#000000').s().p('AgNBTIAAilIAbAAIAAClg');
    this.shape_2.setTransform(67.625, 18.4);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p(
        'AgsBYIAAitIAXAAIAEAQIACAAQAFgKAGgEQAFgEAIAAQARAAAKARQAJAQAAAeQAAAcgJAQQgKARgQAAQgIAAgGgFQgGgEgFgJIgBAAIABAMIAAAIIAAAxgAgLg2QgEAIAAATIAAAGQAAASAEAHQAEAIAHAAQAQAAAAgkQAAgngQAAQgHAAgEAJg',
      );
    this.shape_3.setTransform(59.675, 23.275);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'AApA9IAAhGQAAgagMAAQgIAAgDAJQgDAJgBARIAAA9IgcAAIAAhGQAAgagLAAQgJAAgDAKQgEAKAAATIAAA5IgcAAIAAh3IAXAAIADAPIABAAQAIgRAUAAQAKAAAGAFQAGAEACAIIACAAQAFgJAGgEQAGgEAKAAQAfAAAAArIAABOg',
      );
    this.shape_4.setTransform(45.75, 20.625);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AgdA5QgGgFgDgJQgDgJAAgJQAAgTALgJQAKgJATgBIAOgBIAAgFQAAgJgDgFQgDgFgHAAQgKAAgOAIIgIgVQARgKAVAAQARAAAKALQAJAKAAAWIAABOIgVAAIgFgQIAAAAQgGAJgHAFQgFAEgLAAQgKAAgGgFgAAFAFQgRABAAASQAAAQALAAQAFAAAFgHQAEgHAAgLIAAgLg',
      );
    this.shape_5.setTransform(32.125, 20.725);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p('AAPA8IgPgmIgPAmIgeAAIAcg8Igbg7IAfAAIANAkIAOgkIAfAAIgbA7IAcA8g');
    this.shape_6.setTransform(22.525, 20.725);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p('AgiBOIAAibIBFAAIAAAZIgnAAIAAAlIAlAAIAAAZIglAAIAAAqIAnAAIAAAag');
    this.shape_7.setTransform(13.275, 18.9);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .to({ state: [] }, 1)
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          2,
        )
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_7 },
              { t: this.shape_6 },
              { t: this.shape_5 },
              { t: this.shape_4 },
              { t: this.shape_3 },
              { t: this.shape_2 },
              { t: this.shape_1 },
              { t: this.shape },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, 0, 97, 35.8);

  (lib.eq = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };
    this.frame_5 = function () {
      this.stop();
    };
    this.frame_6 = function () {
      this.stop();
    };
    this.frame_7 = function () {
      this.stop();
    };
    this.frame_8 = function () {
      this.stop();
    };
    this.frame_9 = function () {
      this.stop();
    };
    this.frame_10 = function () {
      this.stop();
    };
    this.frame_11 = function () {
      this.stop();
    };
    this.frame_12 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1)
        .call(this.frame_5)
        .wait(1)
        .call(this.frame_6)
        .wait(1)
        .call(this.frame_7)
        .wait(1)
        .call(this.frame_8)
        .wait(1)
        .call(this.frame_9)
        .wait(1)
        .call(this.frame_10)
        .wait(1)
        .call(this.frame_11)
        .wait(1)
        .call(this.frame_12)
        .wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArIgMgDIAAgMIABAAQAFADAHACQAGACAHAAIAGgBIAHgDIAEgHQACgDAAgEQAAgFgCgDQgBgDgDgCIgGgCIgIgBIgFAAIAAgIIAEAAQAIAAAGgFQAFgDAAgHQAAgDgCgDIgDgEQgDgCgDAAIgFAAQgGAAgGACQgGACgGADIAAAAIAAgMIALgEIANgBIAKABIAJADQAEADADAEQACAEAAAGQAAAGgFAGQgGAFgHACIAAABIAHACIAGADIAFAGQACADAAAHQAAAFgDAGQgCAEgEAFQgEADgGACQgGADgGAAQgHAAgHgDg',
      );
    this.shape.setTransform(89.375, 26.2);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#000000')
      .s()
      .p('AgiARIAAgJIBFAAIAAAJgAgigHIAAgJIBFAAIAAAJg');
    this.shape_1.setTransform(76.425, 26.75);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgXAHgKQAHgLAPAAQAQgBAHAMQAHALAAAWQAAAYgHAKQgIAMgPAAQgPAAgHgMgAgIggQgEABgCAGQgCADgBAIIAAAOIAAAPQABAHACAFQACAEAEACQADADAFAAQAFgBAEgCQAEgCACgEIADgMIAAgPIAAgOIgDgMQgCgEgEgCQgDgDgGAAQgFAAgDADg',
      );
    this.shape_2.setTransform(63.475, 26.2);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#000000')
      .s()
      .p('AgEAlIAAggIggAAIAAgJIAgAAIAAggIAJAAIAAAgIAgAAIAAAJIggAAIAAAgg');
    this.shape_3.setTransform(50.575, 26.725);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArIgMgDIAAgMIABAAQAFADAHACQAGACAHAAIAGgBIAHgDIAEgHQACgDAAgEQAAgFgCgDQgBgDgDgCIgGgCIgIgBIgFAAIAAgIIAEAAQAIAAAGgFQAFgDAAgHQAAgDgCgDIgDgEQgDgCgDAAIgFAAQgGAAgGACQgGACgGADIAAAAIAAgMIALgEIANgBIAKABIAJADQAEADADAEQACAEAAAGQAAAGgFAGQgGAFgHACIAAABIAHACIAGADIAFAGQACADAAAHQAAAFgDAGQgCAEgEAFQgEADgGACQgGADgGAAQgHAAgHgDg',
      );
    this.shape_4.setTransform(37.675, 26.2);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#000000')
      .s()
      .p(
        'AgRArQgGgCgFgCIAAgMIABAAQAFADAHACQAGACAGAAIAIgBQADgBADgDQADgCABgEQACgEgBgFQABgEgCgDQgCgDgCgCIgIgCIgIgBIgKABIgJAAIAAgsIAzAAIAAALIgnAAIAAAWIAEAAIAFAAQAHAAAEABQAGABAEAEQAFADACAEQADAFABAIQAAAGgDAFQgCAGgEAEQgEAEgGACQgGACgHAAIgOgBg',
      );
    this.shape_5.setTransform(89.45, 9.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#000000')
      .s()
      .p('AgiARIAAgKIBFAAIAAAKgAgigHIAAgJIBFAAIAAAJg');
    this.shape_6.setTransform(76.425, 10.25);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#000000')
      .s()
      .p(
        'AgRArQgGgCgFgCIAAgMIABAAQAFADAGACQAHACAGAAIAIgBQADgBADgDQADgCABgEQABgEAAgFQAAgEgBgDQgBgDgEgCIgHgCIgJgBIgKABIgIAAIAAgsIAzAAIAAALIgnAAIAAAWIAEAAIAFAAQAHAAAEABQAGABAEAEQAFADADAEQACAFAAAIQAAAGgCAFQgCAGgEAEQgEAEgGACQgGACgGAAIgPgBg',
      );
    this.shape_7.setTransform(63.6, 9.8);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#000000')
      .s()
      .p('AgEAlIAAggIggAAIAAgJIAgAAIAAggIAJAAIAAAgIAgAAIAAAJIggAAIAAAgg');
    this.shape_8.setTransform(50.575, 10.225);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgXAHgLQAHgKAPgBQAQAAAHAMQAHALAAAWQAAAYgHAKQgIALgPAAQgPAAgHgLgAgIggQgEACgCAEQgCAFgBAHIAAAOIAAAQQABAFACAFQACAFAEACQADADAFgBQAFAAAEgBQAEgDACgFIADgKIAAgQIAAgOIgDgMQgCgFgEgBQgDgDgGAAQgFAAgDADg',
      );
    this.shape_9.setTransform(37.625, 9.7);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#000000')
      .s()
      .p('AgVArIAphLIgxAAIAAgKIA7AAIAAAMIgnBJg');
    this.shape_10.setTransform(89.375, 26.2);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAsIAAgJIASAAIAAg6IgSAAIAAgIIAIAAQAFgBACgBQADgBABgDQABgCAAgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_11.setTransform(63.65, 26.175);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#000000')
      .s()
      .p(
        'AgKArQgGgCgEgDQgEgGgDgIQgDgHAAgMQAAgKACgJQADgJAFgIQAFgGAJgEQAHgDALAAIAFAAIAGABIAAALIgBAAIgFgBIgHgBQgMAAgHAIQgIAHgBAOIAKgFQAFgBAFAAIAKABQAEABAFADQAFAEACAEQADAGAAAHQAAAOgJAIQgIAJgOAAQgFAAgFgDgAgJgBIgJADIAAACIAAADQAAAKACAFQABAFAEAEQADACADABQADACACAAQAJAAAFgFQAFgFAAgLQAAgFgCgEQgCgDgDgCQgCgBgEgBIgGgBIgJABg',
      );
    this.shape_12.setTransform(37.7, 26.2);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#000000')
      .s()
      .p(
        'AAJArIAAgYIgpAAIAAgNIApgxIALAAIAAA0IANAAIAAAKIgNAAIAAAYgAgYAJIAhAAIAAgmg',
      );
    this.shape_13.setTransform(89.25, 9.7);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArIgMgDIAAgNIABAAQAFAEAHACQAGACAHAAIAGgBIAHgDIAEgHQACgCAAgFQAAgFgCgDQgBgDgDgCIgGgDIgIAAIgFAAIAAgJIAEAAQAIAAAGgDQAFgEAAgHQAAgEgCgCIgDgDQgDgCgDgBIgFgBQgGAAgGADQgGABgGAEIAAAAIAAgMIALgEIANgCIAKABIAJAFQAEACADAEQACAEAAAGQAAAGgFAGQgGAGgHABIAAABIAHACIAGACIAFAHQACAEAAAFQAAAHgDAEQgCAGgEADQgEAFgGABQgGACgGAAQgHAAgHgCg',
      );
    this.shape_14.setTransform(63.525, 9.7);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAsIAAgJIASAAIAAg6IgSAAIAAgIIAHAAQAFgBABgBQAEgBABgDQACgCgBgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_15.setTransform(37.8, 9.675);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#000000')
      .s()
      .p(
        'AgRArQgGgBgFgDIAAgMIABAAQAFADAGACQAHACAGAAIAIgBQADgBADgDQADgDABgDQACgDgBgGQABgEgCgDQgBgDgEgCIgHgCIgIgBIgLABIgIAAIAAgrIAzAAIAAAKIgnAAIAAAWIAEAAIAFAAQAHAAAEACQAGABAEACQAFAEACAEQADAFAAAIQAAAGgCAGQgCAFgEAEQgEAEgGACQgGADgGAAIgPgCg',
      );
    this.shape_16.setTransform(102.4, 26.3);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#000000')
      .s()
      .p('AgVArIAphLIgxAAIAAgKIA7AAIAAAMIgnBJg');
    this.shape_17.setTransform(50.625, 26.2);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArQgHgBgFgDIAAgMIACAAQAEADAHACQAGACAGAAIAHgBQAEgBADgDQADgDABgDQABgDAAgGQAAgEgBgDQgBgDgDgCIgIgCIgIgBIgKABIgJAAIAAgrIA0AAIAAAKIgpAAIAAAWIAGAAIAEAAQAGAAAGACQAFABAFACQAEAEACAEQAEAFAAAIQgBAGgCAGQgCAFgEAEQgEAEgGACQgGADgHAAIgNgCg',
      );
    this.shape_18.setTransform(24.85, 26.3);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#000000')
      .s()
      .p(
        'AgdAsIAAgLIANgLIALgLQAKgLAFgFQAEgGAAgIQAAgGgEgEQgFgFgHAAQgGAAgGADQgGABgGAEIAAAAIAAgMIALgEIANgCQANABAHAGQAIAHAAALQAAAEgCAFIgDAIIgGAGIgHAIIgMAMIgMALIAtAAIAAAJg',
      );
    this.shape_19.setTransform(102.35, 9.6);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#000000')
      .s()
      .p('AgEAlIAAggIggAAIAAgJIAgAAIAAggIAJAAIAAAgIAgAAIAAAJIggAAIAAAgg');
    this.shape_20.setTransform(89.375, 10.225);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArIgMgDIAAgNIABAAQAFAEAHACQAGACAHAAIAGgBIAHgDIAEgHQACgCAAgFQAAgFgCgDQgBgDgDgCIgGgDIgIAAIgFAAIAAgJIAEAAQAIAAAGgDQAFgEAAgHQAAgEgCgCIgDgDQgDgCgDgBIgFgBQgGAAgGADQgGABgGAEIAAAAIAAgMIALgEIANgCIAKABIAJAFQAEACADAEQACAEAAAGQAAAGgFAGQgGAGgHABIAAABIAHACIAGACIAFAHQACAEAAAFQAAAHgDAEQgCAGgEADQgEAFgGABQgGACgGAAQgHAAgHgCg',
      );
    this.shape_21.setTransform(50.625, 9.7);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#000000')
      .s()
      .p('AgEAlIAAggIggAAIAAgJIAgAAIAAggIAJAAIAAAgIAgAAIAAAJIggAAIAAAgg');
    this.shape_22.setTransform(37.675, 10.225);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#000000')
      .s()
      .p(
        'AgcAsIAAgLIAMgLIALgLQALgLADgFQAFgGAAgIQAAgGgFgEQgEgFgHAAQgFAAgHADQgGABgGAEIgBAAIAAgMIALgEIAOgCQAMABAIAGQAIAHAAALQAAAEgBAFIgEAIIgFAGIgIAIIgMAMIgNALIAuAAIAAAJg',
      );
    this.shape_23.setTransform(24.8, 9.6);

    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics
      .f('#000000')
      .s()
      .p(
        'AgQAtIgGgBIAAgLIABAAIAFACIAHAAQAMAAAIgHQAGgIACgOIgKAFQgGABgEAAIgKgBQgEgBgFgDQgFgDgCgFQgDgFAAgIQAAgNAJgJQAIgIANAAQAFAAAGACQAGACADAEQAFAEADAIQADAIAAAMQAAAKgCAKQgEAJgFAHQgFAGgIAEQgHADgLAAIgFAAgAgNgdQgFAFAAAJQAAAGACADQABAEAEACIAGACIAGABIAJgCIAJgCIAAgDIAAgDQAAgJgCgFQgBgGgEgDIgGgEIgGgBQgIAAgFAGg',
      );
    this.shape_24.setTransform(59.6, 26.175);

    this.shape_25 = new cjs.Shape();
    this.shape_25.graphics
      .f('#000000')
      .s()
      .p(
        'AAJArIAAgYIgpAAIAAgOIAqgvIAKAAIAAA0IANAAIAAAJIgNAAIAAAYgAgYAKIAhAAIAAgng',
      );
    this.shape_25.setTransform(33.75, 26.2);

    this.shape_26 = new cjs.Shape();
    this.shape_26.graphics
      .f('#000000')
      .s()
      .p(
        'AgdAsIAAgLIANgLIALgLQAKgLAFgFQAEgGAAgIQAAgGgEgEQgFgFgHAAQgGAAgGADQgGABgGAEIAAAAIAAgMIALgEIANgCQANABAHAGQAIAHAAALQAAAEgCAFIgDAIIgGAGIgHAIIgMAMIgMALIAuAAIAAAJg',
      );
    this.shape_26.setTransform(93.25, 9.6);

    this.shape_27 = new cjs.Shape();
    this.shape_27.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAsIAAgJIASAAIAAg6IgSAAIAAgIIAIAAQAFgBACgBQADgBABgDQABgCAAgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_27.setTransform(85.7, 9.675);

    this.shape_28 = new cjs.Shape();
    this.shape_28.graphics
      .f('#000000')
      .s()
      .p('AgVArIAphLIgxAAIAAgLIA7AAIAAAOIgnBIg');
    this.shape_28.setTransform(59.725, 9.7);

    this.shape_29 = new cjs.Shape();
    this.shape_29.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArQgHgCgEgCIAAgMIABAAQAEADAHACQAGACAGAAIAHgBQAEgBADgDQADgCABgEQACgEAAgFQAAgEgCgDQgBgDgDgCIgIgCIgJgBIgJABIgJAAIAAgsIA0AAIAAALIgpAAIAAAWIAGAAIAEAAQAGAAAGABQAFABAFAEQAEADADAEQADAFAAAIQgBAGgCAFQgCAGgEAEQgEAEgGACQgGACgHAAIgNgBg',
      );
    this.shape_29.setTransform(33.95, 9.8);

    this.shape_30 = new cjs.Shape();
    this.shape_30.graphics
      .f('#000000')
      .s()
      .p(
        'AgcAsIAAgMIAMgKIALgLQALgLAEgFQAEgHAAgHQAAgHgEgEQgFgDgHAAQgFAAgHACQgGACgGADIAAAAIAAgMIALgEIANgBQANgBAHAHQAIAGAAALQAAAFgBAFIgEAIIgFAGIgIAIIgMAMIgMAKIAtAAIAAAKg',
      );
    this.shape_30.setTransform(97.05, 26.1);

    this.shape_31 = new cjs.Shape();
    this.shape_31.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAsIAAgJIASAAIAAg6IgSAAIAAgIIAIAAQAFgBACgBQADgBABgDQACgCAAgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_31.setTransform(89.5, 26.175);

    this.shape_32 = new cjs.Shape();
    this.shape_32.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgXAHgKQAHgLAPAAQAQgBAHAMQAHALAAAWQAAAYgHAKQgIAMgPAAQgPAAgHgMgAgIggQgEABgCAGQgCADgBAIIAAAOIAAAPQABAHACAFQACAEAEACQADADAFAAQAFgBAEgCQAEgCACgEIADgMIAAgPIAAgOIgDgMQgCgEgEgCQgDgDgGAAQgFAAgDADg',
      );
    this.shape_32.setTransform(63.475, 26.2);

    this.shape_33 = new cjs.Shape();
    this.shape_33.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgXAHgKQAHgLAPAAQAQgBAHAMQAHALAAAWQAAAYgHAKQgIAMgPAAQgPAAgHgMgAgIggQgEABgCAGQgCADgBAIIAAAOIAAAPQABAHACAFQACAEAEACQADADAFAAQAFgBAEgCQAEgCACgEIADgMIAAgPIAAgOIgDgMQgCgEgEgCQgDgDgGAAQgFAAgDADg',
      );
    this.shape_33.setTransform(29.975, 26.2);

    this.shape_34 = new cjs.Shape();
    this.shape_34.graphics
      .f('#000000')
      .s()
      .p(
        'AgRArQgGgBgEgDIAAgMIABAAQAEADAGACQAHACAGAAIAHgBQAEgBADgDQADgDABgDQABgDABgGQgBgEgBgDQgCgDgDgCIgHgCIgJgBIgKABIgIAAIAAgrIAzAAIAAAKIgoAAIAAAWIAGAAIAEAAQAHAAAFACQAFABAEACQAFAEADAEQACAFAAAIQABAGgDAGQgCAFgEAEQgEAEgGACQgGADgGAAIgPgCg',
      );
    this.shape_34.setTransform(22.45, 26.3);

    this.shape_35 = new cjs.Shape();
    this.shape_35.graphics
      .f('#000000')
      .s()
      .p(
        'AgRArQgGgCgFgCIAAgMIABAAQAFADAGACQAHACAGAAIAIgBQADgBADgDQADgCABgEQABgEAAgFQAAgEgBgDQgBgDgEgCIgHgCIgJgBIgKABIgIAAIAAgsIAzAAIAAALIgnAAIAAAWIAEAAIAFAAQAHAAAEABQAGABAEAEQAFADACAEQADAFAAAIQAAAGgCAFQgCAGgEAEQgEAEgGACQgGACgGAAIgPgBg',
      );
    this.shape_35.setTransform(93.3, 9.8);

    this.shape_36 = new cjs.Shape();
    this.shape_36.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgXAHgLQAHgKAPgBQAQAAAHAMQAHALAAAWQAAAYgHAKQgIALgPAAQgPAAgHgLgAgIggQgEACgCAEQgCAFgBAHIAAAOIAAAQQABAFACAFQACAFAEACQADADAFgBQAFAAAEgBQAEgDACgFIADgKIAAgQIAAgOIgDgMQgCgFgEgBQgDgDgGAAQgFAAgDADg',
      );
    this.shape_36.setTransform(67.325, 9.7);

    this.shape_37 = new cjs.Shape();
    this.shape_37.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgXAHgLQAHgKAPgBQAQAAAHAMQAHALAAAWQAAAYgHAKQgIALgPAAQgPAAgHgLgAgIggQgEACgCAEQgCAFgBAHIAAAOIAAAQQABAFACAFQACAFAEACQADADAFgBQAFAAAEgBQAEgDACgFIADgKIAAgQIAAgOIgDgMQgCgFgEgBQgDgDgGAAQgFAAgDADg',
      );
    this.shape_37.setTransform(33.825, 9.7);

    this.shape_38 = new cjs.Shape();
    this.shape_38.graphics
      .f('#000000')
      .s()
      .p(
        'AgcAsIAAgLIAMgLIAMgLQAJgLAEgFQAFgGAAgIQAAgGgFgEQgEgFgHAAQgFAAgGADQgHABgGAEIgBAAIAAgMIALgEIAOgCQAMABAIAGQAIAHAAALQAAAEgBAFIgEAIIgFAGIgIAIIgMAMIgNALIAuAAIAAAJg',
      );
    this.shape_38.setTransform(26.25, 9.6);

    this.shape_39 = new cjs.Shape();
    this.shape_39.graphics
      .f('#000000')
      .s()
      .p(
        'AgcAsIAAgLIAMgLIAMgLQAJgLAEgFQAFgGAAgIQAAgGgFgEQgEgFgHAAQgFAAgGADQgHABgGAEIgBAAIAAgMIALgEIAOgCQAMABAIAGQAIAHAAALQAAAEgBAFIgEAIIgFAGIgIAIIgMAMIgNALIAuAAIAAAJg',
      );
    this.shape_39.setTransform(26.25, 9.6);

    this.shape_40 = new cjs.Shape();
    this.shape_40.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgXAHgLQAHgKAPgBQAQAAAHAMQAHALAAAWQAAAYgHAKQgIALgPAAQgPAAgHgLgAgIggQgEACgCAEQgCAFgBAHIAAAOIAAAPQABAGACAFQACAFAEACQADADAFgBQAFAAAEgCQAEgCACgFIADgLIAAgPIAAgOIgDgMQgCgFgEgBQgDgDgGAAQgFAAgDADg',
      );
    this.shape_40.setTransform(87.175, 59.2);

    this.shape_41 = new cjs.Shape();
    this.shape_41.graphics.f('#000000').s().p('AgRAFIAAgJIAjAAIAAAJg');
    this.shape_41.setTransform(50.575, 59.725);

    this.shape_42 = new cjs.Shape();
    this.shape_42.graphics
      .f('#000000')
      .s()
      .p(
        'AAJArIAAgYIgpAAIAAgNIApgxIALAAIAAA0IANAAIAAAKIgNAAIAAAYgAgYAJIAhAAIAAgmg',
      );
    this.shape_42.setTransform(39.75, 59.2);

    this.shape_43 = new cjs.Shape();
    this.shape_43.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAiQgHgLAAgXQAAgWAHgMQAHgLAPABQAQAAAHALQAHALAAAWQAAAXgHAMQgIALgPgBQgPAAgHgLgAgIghQgEADgCAEQgCAFgBAGIAAAPIAAAQQABAGACAFQACAEAEACQADACAFABQAFAAAEgCQAEgDACgEIADgLIAAgQIAAgPIgDgLQgCgFgEgCQgDgCgGAAQgFAAgDACg',
      );
    this.shape_43.setTransform(63.475, 42.7);

    this.shape_44 = new cjs.Shape();
    this.shape_44.graphics
      .f('#000000')
      .s()
      .p(
        'AgOAhIgLgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAEgDABgFQgBgEgCgCQgCgCgGgBIgGgBIgHgCQgIgCgDgDQgEgFgBgGQABgEACgEQABgDADgDQAEgDAFgCQAFgBAFAAIAMABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAGABIAFABQAIACAFADQADAFAAAHQAAAJgHAGQgHAFgMAAQgIAAgFgBg',
      );
    this.shape_44.setTransform(116.8, 27.275);

    this.shape_45 = new cjs.Shape();
    this.shape_45.graphics.f('#000000').s().p('AgEAtIAAhaIAJAAIAABag');
    this.shape_45.setTransform(111.95, 26);

    this.shape_46 = new cjs.Shape();
    this.shape_46.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAcQgGgFAAgKQAAgHAEgFQADgDAGgDQAGgDAIAAIARgBIAAgDIgBgFIgEgFIgGgCIgGAAIgJABIgLAEIgBAAIAAgMIAJgCIAMAAIAMAAQAFACADADQAEACACAEQACAFAAAGIAAArIgLAAIAAgGIgEACIgFADIgGADIgIABQgIgBgHgGgAAFAAIgKABQgEABgDADQgDADAAAFQAAAFADADQAEADAGAAQAFAAAFgCIAJgFIAAgSIgMABg',
      );
    this.shape_46.setTransform(106.475, 27.3);

    this.shape_47 = new cjs.Shape();
    this.shape_47.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAbQgFgGAAgMIAAgqIALAAIAAAlIAAAIIACAGQACADACABQADABAFAAQADAAAFgCQAFgCAEgEIAAgwIALAAIAABBIgLAAIAAgIIgKAHQgFADgGAAQgKAAgGgHg',
      );
    this.shape_47.setTransform(99.275, 27.375);

    this.shape_48 = new cjs.Shape();
    this.shape_48.graphics
      .f('#000000')
      .s()
      .p(
        'AASAuIAAggQgFAFgFACQgGACgEAAQgMAAgHgJQgHgJAAgPQAAgIADgHQACgGAEgFQAEgEAFgCQAFgDAFAAQAFAAAEACIAJADIAAgDIALAAIAABZgAgMgcQgFAGAAAMQAAAKAEAGQAEAHAJAAQAEAAAFgCIAJgGIAAgkIgIgDIgIgBQgJAAgFAHg',
      );
    this.shape_48.setTransform(91.525, 28.375);

    this.shape_49 = new cjs.Shape();
    this.shape_49.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgRQAAgOAJgKQAJgKANAAQAOABAHAHQAHAIAAAPIAAAEIgvAAQAAAHABAEQACAEADADQADADAFACQADABAFAAQAHAAAGgCQAHgDADgDIABAAIAAAMIgMAEQgGACgGgBQgPABgJgKgAgLgTQgGAFAAAIIAkAAQAAgJgEgFQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_49.setTransform(84.425, 27.25);

    this.shape_50 = new cjs.Shape();
    this.shape_50.graphics
      .f('#000000')
      .s()
      .p(
        'AgMAuIAAg3IgIAAIAAgJIAIAAIAAgDQgBgLAGgHQAGgGAKAAIAHABIAFABIAAAJIAAAAIgFAAIgGgBQgGAAgEADQgCADAAAIIAAADIATAAIAAAJIgTAAIAAA3g',
      );
    this.shape_50.setTransform(74.95, 25.95);

    this.shape_51 = new cjs.Shape();
    this.shape_51.graphics.f('#000000').s().p('AgEAtIAAhaIAKAAIAABag');
    this.shape_51.setTransform(70.8, 26);

    this.shape_52 = new cjs.Shape();
    this.shape_52.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgRQAAgOAJgKQAJgKANAAQAOABAHAHQAHAIAAAPIAAAEIgvAAQAAAHABAEQACAEADADQADADAFACQADABAFAAQAHAAAGgCIAKgGIABAAIAAAMIgMAEQgGACgGgBQgPABgJgKgAgLgTQgGAFAAAIIAkAAQAAgJgEgFQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_52.setTransform(65.575, 27.25);

    this.shape_53 = new cjs.Shape();
    this.shape_53.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAFgDAAgFQAAgEgDgCQgCgCgHgBIgEgBIgIgCQgIgCgDgDQgFgFAAgGQAAgEACgEQACgDADgDQAEgDAFgCQAFgBAFAAIAMABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAFABIAGABQAJACADADQAFAFAAAHQgBAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_53.setTransform(59, 27.275);

    this.shape_54 = new cjs.Shape();
    this.shape_54.graphics
      .f('#000000')
      .s()
      .p(
        'AgHAlQgFgFAAgMIAAgiIgIAAIAAgJIAIAAIAAgTIALAAIAAATIAWAAIAAAJIgWAAIAAAdIAAAIQAAADABADIADADIAHABIAGgBIAEgBIABAAIAAAKIgHACIgHAAQgJAAgFgGg',
      );
    this.shape_54.setTransform(53.475, 26.4);

    this.shape_55 = new cjs.Shape();
    this.shape_55.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhAIAKAAIAABAgAgFggIAAgLIALAAIAAALg');
    this.shape_55.setTransform(49.4, 26.15);

    this.shape_56 = new cjs.Shape();
    this.shape_56.graphics
      .f('#000000')
      .s()
      .p(
        'AgPAhIgKgEIAAgNIABAAQAFAEAHADQAGACAGAAQAGAAAEgCQAFgDAAgFQAAgEgDgCQgCgCgHgBIgEgBIgIgCQgIgCgDgDQgFgFAAgGQAAgEACgEQACgDAEgDQADgDAFgCQAFgBAFAAIAMABIAKAEIAAALIAAAAQgFgDgGgCQgGgCgGAAQgEAAgFACQgEADAAAEQAAAEADACQACACAGACIAFABIAGABQAJACADADQAFAFAAAHQgBAJgHAGQgHAFgMAAQgHAAgHgBg',
      );
    this.shape_56.setTransform(40.55, 27.275);

    this.shape_57 = new cjs.Shape();
    this.shape_57.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAbQgFgGAAgMIAAgqIALAAIAAAlIAAAIIACAGQACADACABQADABAFAAQADAAAFgCQAFgCAEgEIAAgwIALAAIAABBIgLAAIAAgIIgKAHQgFADgGAAQgKAAgGgHg',
      );
    this.shape_57.setTransform(33.525, 27.375);

    this.shape_58 = new cjs.Shape();
    this.shape_58.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAiIAAglIAAgIIgCgGQgCgDgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAFgDAGAAQAKAAAGAHQAFAGAAAMIAAAqg',
      );
    this.shape_58.setTransform(25.975, 27.175);

    this.shape_59 = new cjs.Shape();
    this.shape_59.graphics
      .f('#000000')
      .s()
      .p('AgEAsIAAhAIAKAAIAABAgAgFggIAAgLIALAAIAAALg');
    this.shape_59.setTransform(20.5, 26.15);

    this.shape_60 = new cjs.Shape();
    this.shape_60.graphics
      .f('#000000')
      .s()
      .p(
        'AAlAiIAAglIgBgIIgBgGIgEgEQgDgBgFAAQgEAAgFACIgJAGIAAADIAAAEIAAApIgKAAIAAglIAAgIQAAgEgCgCQgBgDgDgBQgCgBgFAAQgEAAgFACIgJAGIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAGgDAFAAQAHAAAFADQADADADAFQAGgGAGgCQAFgDAHAAQAKAAAGAHQAFAHAAALIAAAqg',
      );
    this.shape_60.setTransform(13.075, 27.175);

    this.shape_61 = new cjs.Shape();
    this.shape_61.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAhIAAhBIALAAIAAAKQAGgFAEgCQAFgDAFAAIAFAAIADABIAAALIAAAAIgFgBIgFAAQgGAAgEACIgIAGIAAAug',
      );
    this.shape_61.setTransform(115.975, 10.775);

    this.shape_62 = new cjs.Shape();
    this.shape_62.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAaQgKgJAAgQQAAgQAJgJQAJgKANAAQAOAAAHAIQAHAIAAAOIAAAFIgvAAQAAAGABAFQACAEADADQADADAFACQADABAFAAQAHAAAGgDQAHgCADgDIABAAIAAAMIgMAEIgMACQgPgBgJgIgAgLgTQgGAFAAAIIAkAAQAAgJgEgEQgFgFgIAAQgIAAgFAFg',
      );
    this.shape_62.setTransform(109.275, 10.75);

    this.shape_63 = new cjs.Shape();
    this.shape_63.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAtIgIgDIgBACIgKAAIAAhaIALAAIAAAhQAFgEAFgCQAFgDAGAAQALAAAHAJQAHAJAAAPQAAAIgDAHQgCAGgEAFQgEAEgFADQgFACgGAAQgFAAgEgBgAgIgJIgJAFIAAAlQAFACADAAIAIABQAIAAAFgFQAFgHAAgNQAAgLgEgFQgDgGgJAAQgEgBgFADg',
      );
    this.shape_63.setTransform(102.175, 9.6);

    this.shape_64 = new cjs.Shape();
    this.shape_64.graphics
      .f('#000000')
      .s()
      .p(
        'AAlAiIAAglIgBgIIgBgGIgEgEQgDgBgFAAQgEAAgFACIgJAGIAAADIAAAEIAAApIgKAAIAAglIAAgIQAAgEgCgCQgBgDgDgBQgCgBgFAAQgEAAgFACIgJAGIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAGgDAFAAQAHAAAFADQADADADAFQAGgGAGgCQAFgDAHAAQAKAAAGAHQAFAHAAALIAAAqg',
      );
    this.shape_64.setTransform(92.425, 10.675);

    this.shape_65 = new cjs.Shape();
    this.shape_65.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAbQgFgGAAgMIAAgqIALAAIAAAlIAAAIIACAGQACADACABQADABAFAAQADAAAFgCQAFgCAEgEIAAgwIALAAIAABBIgLAAIAAgIIgKAHQgFADgGAAQgKAAgGgHg',
      );
    this.shape_65.setTransform(82.725, 10.875);

    this.shape_66 = new cjs.Shape();
    this.shape_66.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAiIAAglIAAgIIgCgGQgCgDgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAFgDAGAAQAKAAAGAHQAFAGAAAMIAAAqg',
      );
    this.shape_66.setTransform(75.175, 10.675);

    this.shape_67 = new cjs.Shape();
    this.shape_67.graphics
      .f('#000000')
      .s()
      .p('AAbArIgJgYIgkAAIgJAYIgLAAIAfhWIAPAAIAfBWgAgPAJIAeAAIgPgpg');
    this.shape_67.setTransform(63.05, 9.7);

    this.shape_68 = new cjs.Shape();
    this.shape_68.graphics
      .f('#000000')
      .s()
      .p('AgKAhIAAgXIAVAAIAAAXgAgKgJIAAgXIAVAAIAAAXg');
    this.shape_68.setTransform(52.3, 10.75);

    this.shape_69 = new cjs.Shape();
    this.shape_69.graphics
      .f('#000000')
      .s()
      .p(
        'AghAsIAAgOIAPgMIANgLQAGgHADgEQADgFAAgFQAAgGgEgDQgDgDgHgBQgFAAgGACIgLAHIgCAAIAAgUIAMgEQAIgCAIAAQAQAAAIAHQAJAIAAAMQAAAIgEAIQgEAGgJAIIgKAJIgHAGIAmAAIAAAQg',
      );
    this.shape_69.setTransform(45.875, 9.6);

    this.shape_70 = new cjs.Shape();
    this.shape_70.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAmQgGgFAAgMIAAgeIgJAAIAAgOIAJAAIAAgTIAUAAIAAATIAUAAIAAAOIgUAAIAAAXIAAAGIABAEQAAABABAAQAAAAAAABQAAAAABABQAAAAABABIAGABIAEgBIAEgCIACAAIAAAPIgHABIgKABQgLAAgGgFg',
      );
    this.shape_70.setTransform(34.525, 9.9);

    this.shape_71 = new cjs.Shape();
    this.shape_71.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAhIAAhBIAVAAIAAAKQAGgGAFgCQAGgCAEAAIACAAIADAAIAAAVIgCAAIgEgCIgFAAIgIABIgHACIAAArg',
      );
    this.shape_71.setTransform(29.225, 10.75);

    this.shape_72 = new cjs.Shape();
    this.shape_72.graphics
      .f('#000000')
      .s()
      .p(
        'AgZAdQgHgGAAgJQAAgHAEgFQADgDAGgDQAGgDAIgBIARgBIAAgBQAAgFgEgCQgFgCgHAAIgMABIgIADIgCAAIAAgQIALgCIAPgBQARAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgEADIgFADIgFACIgIABQgJAAgGgGgAADADIgHABIgFADQgBACAAADIAAADQAAABAAAAQAAAAABABQAAAAAAAAQAAAAABABIADACIAFAAQADAAADgBIAGgDIAAgOIgJABg',
      );
    this.shape_72.setTransform(21.625, 10.775);

    this.shape_73 = new cjs.Shape();
    this.shape_73.graphics
      .f('#000000')
      .s()
      .p(
        'AgjArIAAhWIAkAAIAOACQAGABAEADQAFADAEAGQACAFAAAIQAAAFgCAHQgCAEgEAEQgFAFgHADQgGACgKAAIgMAAIAAAcgAgMgBIAGAAIAJAAQAEgBACgCIADgFIABgFQAAgEgCgDIgFgEIgGgCIgJAAIgDAAg',
      );
    this.shape_73.setTransform(13.75, 9.7);

    this.shape_74 = new cjs.Shape();
    this.shape_74.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAsIAAgJIASAAIAAg6IgSAAIAAgIIAIAAQAEgBADgBQACgBACgDQACgCAAgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_74.setTransform(87.35, 59.175);

    this.shape_75 = new cjs.Shape();
    this.shape_75.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgQQAAgQAJgJQAJgJANAAQAOgBAHAJQAHAHAAAOIAAAGIgvAAQAAAFABAFQACAFADADQADACAFABQADACAFAAQAHAAAGgDQAHgDADgCIABAAIAAAMIgMAEIgMABQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgIgEgGQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_75.setTransform(64.075, 43.75);

    this.shape_76 = new cjs.Shape();
    this.shape_76.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAZQgIgJAAgQQAAgPAIgJQAIgKANAAQAOAAAIAKQAIAJAAAPQAAAQgIAJQgIAKgOAAQgNAAgIgKgAgNgSQgFAGAAAMQAAAMAFAHQAFAGAIAAQAJAAAFgGQAFgHAAgMQAAgMgFgGQgFgGgJAAQgIAAgFAGg',
      );
    this.shape_76.setTransform(51.725, 43.775);

    this.shape_77 = new cjs.Shape();
    this.shape_77.graphics
      .f('#000000')
      .s()
      .p(
        'AgMAuIAAg3IgIAAIAAgKIAIAAIAAgBQgBgNAGgFQAGgHAKAAIAHAAIAFABIAAAKIgBAAIgEgBIgGAAQgGAAgEADQgCADAAAJIAAABIATAAIAAAKIgSAAIAAA3g',
      );
    this.shape_77.setTransform(46.4, 42.45);

    this.shape_78 = new cjs.Shape();
    this.shape_78.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgQQAAgQAJgJQAJgJANAAQAOgBAHAJQAHAHAAAOIAAAGIgvAAQAAAFABAFQACAFADADQADACAFABQADACAFAAQAHAAAGgDQAHgDADgCIABAAIAAAMIgMAEIgMABQgPAAgJgJgAgLgTQgGAFAAAIIAkAAQAAgIgEgGQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_78.setTransform(40.325, 43.75);

    this.shape_79 = new cjs.Shape();
    this.shape_79.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAtIgIgEIgBAEIgKAAIAAhaIALAAIAAAgQAFgEAFgCQAFgDAGAAQALAAAHAJQAHAJAAAPQAAAJgDAGQgCAHgEAEQgEAFgFACQgFACgGAAQgFAAgEgBgAgIgJIgJAFIAAAkQAFADADABIAIABQAIAAAFgHQAFgFAAgOQAAgLgEgFQgDgHgJAAQgEAAgFADg',
      );
    this.shape_79.setTransform(33.225, 42.6);

    this.shape_80 = new cjs.Shape();
    this.shape_80.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAhIAAhBIALAAIAAAKQAGgFAEgCQAFgDAFAAIAFAAIADABIAAALIAAAAIgFgBIgFAAQgGAAgEACIgIAGIAAAug',
      );
    this.shape_80.setTransform(116.925, 27.275);

    this.shape_81 = new cjs.Shape();
    this.shape_81.graphics
      .f('#000000')
      .s()
      .p(
        'AgJAtIgIgEIgBADIgKAAIAAhaIALAAIAAAhQAFgEAFgDQAFgCAGAAQALAAAHAJQAHAJAAAQQAAAHgDAHQgCAGgEAFQgEAEgFADQgFADgGAAQgFAAgEgCgAgIgJIgJAFIAAAkQAFADADAAIAIACQAIgBAFgFQAFgHAAgMQAAgMgEgFQgDgGgJgBQgEABgFACg',
      );
    this.shape_81.setTransform(103.125, 26.1);

    this.shape_82 = new cjs.Shape();
    this.shape_82.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAZQgKgIAAgRQAAgOAJgKQAJgKANAAQAOABAHAHQAHAIAAAPIAAAEIgvAAQAAAHABAEQACAEADADQADADAFACQADABAFAAQAHAAAGgCQAHgDADgDIABAAIAAAMIgMAEQgGACgGgBQgPABgJgKgAgLgTQgGAFAAAIIAkAAQAAgJgEgFQgFgEgIAAQgIAAgFAFg',
      );
    this.shape_82.setTransform(64.525, 27.25);

    this.shape_83 = new cjs.Shape();
    this.shape_83.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAtIAAglIAAgIIgCgFQgCgDgCgBQgDgBgFgBQgDABgFACQgFACgEADIAAAwIgLAAIAAhaIALAAIAAAhQAFgEAFgDQAFgCAGAAQAKAAAGAHQAFAGAAALIAAAqg',
      );
    this.shape_83.setTransform(57.175, 26);

    this.shape_84 = new cjs.Shape();
    this.shape_84.graphics
      .f('#000000')
      .s()
      .p(
        'AgOAhIgKgEIAAgNIAAAAQAFAEAGADQAHACAGAAQAGAAAEgCQAEgDAAgFQABgEgDgCQgCgCgGgBIgGgBIgHgCQgIgCgEgDQgDgFAAgGQAAgEACgEQABgDADgDQAEgDAFgCQAFgBAFAAIAMABIAKAEIAAALIgBAAQgEgDgGgCQgGgCgFAAQgGAAgEACQgEADAAAEQAAAEACACQADACAFACIAHABIAGABQAIACAEADQADAFAAAHQABAJgIAGQgHAFgMAAQgIAAgFgBg',
      );
    this.shape_84.setTransform(41.4, 27.275);

    this.shape_85 = new cjs.Shape();
    this.shape_85.graphics
      .f('#000000')
      .s()
      .p('AgFAsIAAhAIAKAAIAABAgAgFggIAAgLIALAAIAAALg');
    this.shape_85.setTransform(21.35, 26.15);

    this.shape_86 = new cjs.Shape();
    this.shape_86.graphics
      .f('#000000')
      .s()
      .p(
        'AgTAhIAAhBIALAAIAAAKQAGgFAEgCQAFgDAFAAIAFAAIADABIAAALIAAAAIgFgBIgFAAQgGAAgEACIgIAGIAAAug',
      );
    this.shape_86.setTransform(115.925, 10.775);

    this.shape_87 = new cjs.Shape();
    this.shape_87.graphics
      .f('#000000')
      .s()
      .p(
        'AAlAiIAAglIgBgIIgBgGIgEgEQgDgBgFAAQgEAAgFACIgJAGIAAADIAAAEIAAApIgKAAIAAglIAAgIQAAgEgCgCQgBgDgDgBQgCgBgFAAQgEAAgFACIgJAGIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAGgDAFAAQAHAAAFADQADADADAFQAGgGAGgCQAFgDAHAAQAKAAAGAHQAFAHAAALIAAAqg',
      );
    this.shape_87.setTransform(92.375, 10.675);

    this.shape_88 = new cjs.Shape();
    this.shape_88.graphics
      .f('#000000')
      .s()
      .p(
        'AAQAiIAAglIAAgIIgCgGQgCgDgCgBQgDgBgFAAQgDAAgFACQgFACgEAEIAAAwIgLAAIAAhBIALAAIAAAIQAFgFAFgCQAFgDAGAAQAKAAAGAHQAFAGAAAMIAAAqg',
      );
    this.shape_88.setTransform(75.125, 10.675);

    this.shape_89 = new cjs.Shape();
    this.shape_89.graphics
      .f('#000000')
      .s()
      .p('AAbArIgIgYIglAAIgJAYIgMAAIAhhWIAOAAIAgBWgAgOAJIAdAAIgPgpg');
    this.shape_89.setTransform(63, 9.7);

    this.shape_90 = new cjs.Shape();
    this.shape_90.graphics
      .f('#000000')
      .s()
      .p(
        'AgjArIAAhWIAkAAIAOACQAGABAFADQAEADAEAGQACAFAAAIQAAAFgCAHQgCAEgEAEQgFAFgGADQgHACgJAAIgOAAIAAAcgAgNgBIAHAAIAIAAQAEgBADgCIADgFIABgFQAAgEgCgDIgEgEIgHgCIgIAAIgFAAg',
      );
    this.shape_90.setTransform(13.8, 9.7);

    this.text = new cjs.Text('', "12px 'Verdana'");
    this.text.textAlign = 'center';
    this.text.lineHeight = 17;
    this.text.parent = this;
    this.text.setTransform(588.1, -493);

    this.shape_91 = new cjs.Shape();
    this.shape_91.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArQgHgBgFgDIAAgMIABAAQAFADAHACQAGACAGAAIAHgBQAEgBADgDQADgDABgDQABgDAAgGQAAgEgBgDQgBgDgDgCIgIgCIgIgBIgKABIgJAAIAAgrIA0AAIAAAKIgpAAIAAAWIAGAAIAEAAQAGAAAFACQAGABAFADQAEADACAEQAEAFAAAIQAAAGgDAGQgCAFgEAEQgEAEgGACQgGADgHAAIgNgCg',
      );
    this.shape_91.setTransform(87.3, 75.8);

    this.shape_92 = new cjs.Shape();
    this.shape_92.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArIgMgDIAAgMIABAAQAFADAHACQAGACAHAAIAGgBIAHgEIAEgGQACgDAAgEQAAgFgCgDQgBgDgDgCIgGgCIgIgBIgFAAIAAgIIAEAAQAIAAAGgFQAFgDAAgIQAAgCgCgDIgDgEQgDgCgDAAIgFAAQgGAAgGACQgGACgGADIAAAAIAAgMIALgEIANgBIAKABIAJADQAEADADAEQACAEAAAGQAAAGgFAGQgGAFgHACIAAABIAHACIAGADIAFAGQACADAAAHQAAAFgDAGQgCAEgEAFQgEADgGACQgGADgGAAQgHAAgHgDg',
      );
    this.shape_92.setTransform(61.375, 75.7);

    this.shape_93 = new cjs.Shape();
    this.shape_93.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAmQgIgHAAgLQAAgIAFgGQAEgFAHgDIAAgBQgHgDgDgFQgDgEAAgHQAAgKAHgGQAIgHAMABQANAAAIAFQAIAHAAAJQAAAGgEAGQgDAGgIADIAAAAQAJADAEAFQAEAFAAAIQAAAMgJAHQgIAIgOAAQgNAAgJgIgAgPAHQgDAFAAAHQAAAHAFAFQAGAGAIAAQAIAAAFgFQAFgEAAgHQAAgGgCgDQgDgDgGgEIgGgCIgIgDQgFADgEAEgAgLggQgEADAAAGQAAAEABADQADADAFACIAGAEIAHACQAGgEACgEQADgEAAgGQgBgFgFgEQgEgEgIAAQgGAAgFAEg',
      );
    this.shape_93.setTransform(39.8, 75.7);

    this.shape_94 = new cjs.Shape();
    this.shape_94.graphics
      .f('#000000')
      .s()
      .p(
        'AgRArQgGgCgFgCIAAgMIABAAQAFADAGACQAHACAGAAIAIgBQADgBADgDQADgCABgEQACgEgBgEQABgFgCgDQgBgDgEgCIgHgCIgIgBIgLABIgIAAIAAgsIAzAAIAAALIgnAAIAAAWIAEAAIAFAAQAHAAAEABQAGABAEAEQAFADACAEQADAFAAAIQAAAGgCAFQgCAGgEAEQgEAEgGACQgGACgGAAIgPgBg',
      );
    this.shape_94.setTransform(61.45, 59.3);

    this.shape_95 = new cjs.Shape();
    this.shape_95.graphics.f('#000000').s().p('AgRAFIAAgJIAjAAIAAAJg');
    this.shape_95.setTransform(50.575, 59.725);

    this.shape_96 = new cjs.Shape();
    this.shape_96.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAmQgIgHAAgMQAAgHAFgGQAEgFAHgDIAAAAQgHgEgDgFQgDgEAAgHQAAgJAHgHQAIgGAMgBQANAAAIAHQAIAGAAAKQAAAFgEAGQgDAGgIADIAAABQAJACAEAFQAEAFAAAIQAAALgJAIQgIAIgOgBQgNABgJgIgAgPAHQgDAFAAAGQAAAIAFAGQAGAFAIAAQAIAAAFgEQAFgFAAgHQAAgGgCgDQgDgDgGgEIgGgCIgIgDQgFACgEAFgAgLggQgEADAAAGQAAAEABADQADADAFACIAGADIAHADQAGgDACgFQADgEAAgFQgBgHgFgDQgEgEgIAAQgGAAgFAEg',
      );
    this.shape_96.setTransform(39.8, 59.2);

    this.shape_97 = new cjs.Shape();
    this.shape_97.graphics
      .f('#000000')
      .s()
      .p(
        'AgdAsIAAgMIANgKIALgLQAKgLAFgFQAEgHAAgHQAAgHgEgEQgFgDgHAAQgGAAgGACQgGACgGADIAAAAIAAgMIALgEIANgBQANgBAHAHQAIAGAAALQAAAFgCAFIgDAIIgGAGIgHAIIgMAMIgMAKIAuAAIAAAKg',
      );
    this.shape_97.setTransform(85.15, 26.1);

    this.shape_98 = new cjs.Shape();
    this.shape_98.graphics
      .f('#000000')
      .s()
      .p('AgiARIAAgJIBFAAIAAAJgAgigHIAAgJIBFAAIAAAJg');
    this.shape_98.setTransform(76.375, 26.75);

    this.shape_99 = new cjs.Shape();
    this.shape_99.graphics
      .f('#000000')
      .s()
      .p(
        'AAJArIAAgYIgpAAIAAgOIApgvIALAAIAAA0IANAAIAAAJIgNAAIAAAYgAgYAKIAhAAIAAgng',
      );
    this.shape_99.setTransform(63.35, 26.2);

    this.shape_100 = new cjs.Shape();
    this.shape_100.graphics.f('#000000').s().p('AgRAFIAAgJIAjAAIAAAJg');
    this.shape_100.setTransform(52.675, 26.725);

    this.shape_101 = new cjs.Shape();
    this.shape_101.graphics
      .f('#000000')
      .s()
      .p(
        'AgKArQgGgCgDgDQgFgGgDgIQgDgHAAgMQAAgKACgJQADgJAGgIQAEgGAJgEQAHgDAKAAIAGAAIAGABIAAALIgBAAIgFgBIgHgBQgMAAgHAIQgHAHgCAOIAKgFQAEgBAGAAIAJABQAFABAEADQAGAEACAEQADAGAAAHQAAAOgJAIQgJAJgNAAQgFAAgFgDgAgJgBIgJADIAAACIAAADQAAAKACAFQACAFADAEQADACADABQADACACAAQAJAAAFgFQAFgFAAgLQAAgFgCgEQgCgDgDgCQgCgBgEgBIgGgBIgJABg',
      );
    this.shape_101.setTransform(42, 26.2);

    this.shape_102 = new cjs.Shape();
    this.shape_102.graphics
      .f('#000000')
      .s()
      .p(
        'AAJArIAAgYIgpAAIAAgNIAqgxIAKAAIAAA0IANAAIAAAKIgNAAIAAAYgAgYAJIAhAAIAAgmg',
      );
    this.shape_102.setTransform(89.2, 9.7);

    this.shape_103 = new cjs.Shape();
    this.shape_103.graphics
      .f('#000000')
      .s()
      .p('AgiARIAAgKIBFAAIAAAKgAgigHIAAgJIBFAAIAAAJg');
    this.shape_103.setTransform(76.375, 10.25);

    this.shape_104 = new cjs.Shape();
    this.shape_104.graphics.f('#000000').s().p('AgRAFIAAgJIAjAAIAAAJg');
    this.shape_104.setTransform(52.675, 10.225);

    this.shape_105 = new cjs.Shape();
    this.shape_105.graphics
      .f('#000000')
      .s()
      .p(
        'AgKArQgGgBgDgFQgFgEgDgJQgDgIAAgLQAAgLACgIQADgKAGgGQAEgHAJgDQAHgFAKAAIAGABIAGABIAAALIgBAAIgFgCIgHgBQgMABgHAHQgHAJgCANIAKgFQAEgBAGAAIAJABQAFABAEADQAGAEACAEQADAFAAAIQAAANgJAJQgJAJgNgBQgFAAgFgCgAgJgBIgJADIAAADIAAACQAAAKACAGQACAEADAEQADACADABQADACACAAQAJAAAFgFQAFgGAAgJQAAgGgCgEQgCgDgDgDQgCAAgEgBIgGgBIgJABg',
      );
    this.shape_105.setTransform(42, 9.7);

    this.shape_106 = new cjs.Shape();
    this.shape_106.graphics
      .f('#000000')
      .s()
      .p(
        'AgQAtIgFgBIAAgLIAAAAIAFACIAHAAQAMAAAIgHQAGgIACgOIgLAFQgFABgEAAIgKgBQgEgBgFgDQgEgDgDgFQgDgFAAgIQAAgNAJgJQAIgIANAAQAGAAAFACQAFACAFAEQAEAEADAIQADAIAAAMQAAAKgCAKQgEAJgEAHQgGAGgIAEQgHADgLAAIgFAAgAgNgdQgFAFAAAJQAAAGACADQABAEAEACIAGACIAGABIAJgCIAJgCIAAgDIAAgDQAAgJgCgFQgBgGgEgDIgGgEIgGgBQgIAAgFAGg',
      );
    this.shape_106.setTransform(90.9, 26.175);

    this.shape_107 = new cjs.Shape();
    this.shape_107.graphics
      .f('#000000')
      .s()
      .p(
        'AgKArQgFgCgEgDQgFgGgDgIQgDgHAAgMQAAgKADgJQACgJAGgIQAEgGAJgEQAHgDAKAAIAHAAIAFABIAAALIgCAAIgEgBIgHgBQgLAAgIAIQgHAHgCAOIAKgFQAEgBAGAAIAJABQAFABAEADQAFAEADAEQADAGAAAHQAAAOgJAIQgJAJgNAAQgFAAgFgDgAgJgBIgJADIAAACIAAADQAAAKACAFQACAFADAEQACACAEABQADACACAAQAJAAAFgFQAFgFAAgLQAAgFgBgEQgDgDgDgCQgDgBgDgBIgGgBIgJABg',
      );
    this.shape_107.setTransform(43.7, 26.2);

    this.shape_108 = new cjs.Shape();
    this.shape_108.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAsIAAgJIASAAIAAg6IgSAAIAAgIIAHAAQAEgBACgBQADgBACgDQABgCABgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_108.setTransform(36.15, 26.175);

    this.shape_109 = new cjs.Shape();
    this.shape_109.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAmQgIgHAAgMQAAgHAFgGQAEgFAHgDIAAAAQgHgEgDgEQgEgFABgHQAAgJAIgHQAHgGAMgBQANAAAIAHQAIAGAAAKQAAAFgEAGQgDAGgIADIAAAAQAJADAEAFQAEAFAAAIQAAALgJAIQgIAIgOgBQgNABgJgIgAgPAHQgDAFAAAGQAAAIAFAGQAGAFAIAAQAIAAAFgEQAFgFAAgHQAAgGgCgDQgCgDgHgEIgGgCIgJgDQgEACgEAFgAgLggQgEADAAAGQgBAEACADQADADAFADIAGACIAHADQAGgDACgFQACgEABgFQAAgHgGgDQgEgEgIAAQgHAAgEAEg',
      );
    this.shape_109.setTransform(65.1, 9.7);

    this.shape_110 = new cjs.Shape();
    this.shape_110.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAsIAAgJIASAAIAAg6IgSAAIAAgIIAHAAQAEgBACgBQADgBACgDQABgCABgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_110.setTransform(43.8, 9.675);

    this.shape_111 = new cjs.Shape();
    this.shape_111.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAsIAAgJIASAAIAAg6IgSAAIAAgIIAHAAQAEgBACgBQADgBACgDQABgCABgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_111.setTransform(36.15, 9.675);

    this.shape_112 = new cjs.Shape();
    this.shape_112.graphics
      .f('#000000')
      .s()
      .p(
        'AgcAsIAAgMIAMgKIAMgLQAJgLAEgFQAFgHAAgHQAAgHgFgEQgEgDgHAAQgFAAgGACQgHACgGADIgBAAIAAgMIALgEIAOgBQAMgBAIAHQAIAGAAALQAAAFgBAFIgEAIIgFAGIgIAIIgMAMIgNAKIAuAAIAAAKg',
      );
    this.shape_112.setTransform(91.05, 26.1);

    this.shape_113 = new cjs.Shape();
    this.shape_113.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAmQgJgHAAgMQAAgHAEgGQAEgFAIgDIAAAAQgHgEgDgEQgDgFAAgHQgBgJAJgHQAHgGAMgBQANAAAIAHQAIAGAAAKQAAAFgEAGQgEAGgGADIAAAAQAHADAFAFQAEAFAAAIQAAALgIAIQgJAIgOgBQgNABgIgIgAgPAHQgDAFAAAGQAAAIAGAGQAFAFAHAAQAJAAAFgEQAFgFAAgHQAAgGgCgDQgDgDgGgEIgHgCIgIgDQgEACgEAFgAgLggQgEADgBAGQAAAEACADQADADAFADIAGACIAHADQAGgDACgFQACgEAAgFQABgHgGgDQgFgEgHAAQgGAAgFAEg',
      );
    this.shape_113.setTransform(90.95, 9.7);

    this.shape_114 = new cjs.Shape();
    this.shape_114.graphics
      .f('#000000')
      .s()
      .p(
        'AgXAsIAAgJIASAAIAAg6IgSAAIAAgIIAIAAQAEgBADgBQACgBACgDQACgCAAgEIAIAAIAABOIASAAIAAAJg',
      );
    this.shape_114.setTransform(57.65, 9.675);

    this.shape_115 = new cjs.Shape();
    this.shape_115.graphics
      .f('#000000')
      .s()
      .p(
        'AgRAtIgEgBIAAgLIAAAAIAFACIAHAAQAMAAAIgHQAGgIACgOIgLAFQgFABgEAAIgKgBQgEgBgFgDQgEgDgDgFQgDgFAAgIQAAgNAJgJQAIgIANAAQAGAAAFACQAGACAEAEQAFAEACAIQADAIAAAMQAAAKgCAKQgEAJgEAHQgGAGgIAEQgHADgLAAIgGAAgAgNgdQgFAFAAAJQAAAGABADQACAEAEACIAGACIAGABIAJgCIAJgCIAAgDIAAgDQAAgJgCgFQgCgGgDgDIgGgEIgGgBQgIAAgFAGg',
      );
    this.shape_115.setTransform(28.25, 9.675);

    this.shape_116 = new cjs.Shape();
    this.shape_116.graphics
      .f('#000000')
      .s()
      .p(
        'AgKArQgFgCgEgDQgFgGgDgIQgDgHAAgMQAAgKADgJQACgJAGgIQAEgGAJgEQAHgDAKAAIAHAAIAEABIAAALIgBAAIgEgBIgHgBQgLAAgIAIQgIAHgBAOIAKgFQAFgBAFAAIAJABQAFABAEADQAFAEADAEQADAGAAAHQAAAOgJAIQgJAJgNAAQgFAAgFgDgAgJgBIgJADIAAACIAAADQAAAKACAFQACAFADAEQADACADABQADACACAAQAJAAAFgFQAFgFAAgLQAAgFgBgEQgCgDgEgCQgDgBgDgBIgGgBIgJABg',
      );
    this.shape_116.setTransform(57.55, 26.2);

    this.shape_117 = new cjs.Shape();
    this.shape_117.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArQgHgCgFgCIAAgMIABAAQAFADAHACQAGACAGAAIAHgBQAEgBADgDQADgCABgEQABgEAAgFQAAgEgBgDQgBgDgDgCIgIgCIgIgBIgKABIgJAAIAAgsIA0AAIAAALIgoAAIAAAWIAFAAIAEAAQAGAAAFABQAGABAFAEQAEADACAEQAEAFAAAIQAAAGgDAFQgCAGgEAEQgEAEgGACQgGACgHAAIgNgBg',
      );
    this.shape_117.setTransform(65.25, 9.8);

    this.shape_118 = new cjs.Shape();
    this.shape_118.graphics
      .f('#000000')
      .s()
      .p(
        'AgWAmQgIgHAAgMQAAgHAEgGQAFgFAHgDIAAAAQgHgEgDgEQgEgFABgHQgBgJAJgHQAIgGALgBQANAAAIAHQAIAGAAAKQAAAFgEAGQgEAGgGADIAAAAQAHADAFAFQAEAFAAAIQAAALgJAIQgIAIgOgBQgNABgJgIgAgPAHQgDAFAAAGQAAAIAFAGQAGAFAHAAQAJAAAFgEQAFgFAAgHQAAgGgCgDQgDgDgGgEIgHgCIgIgDQgEACgEAFgAgLggQgEADgBAGQAAAEACADQADADAFADIAGACIAHADQAGgDACgFQACgEABgFQAAgHgGgDQgEgEgIAAQgHAAgEAEg',
      );
    this.shape_118.setTransform(35.95, 9.7);

    this.shape_119 = new cjs.Shape();
    this.shape_119.graphics
      .f('#000000')
      .s()
      .p(
        'AgQArQgHgCgFgCIAAgMIACAAQAEADAHACQAGACAGAAIAHgBQAEgBADgDQADgCABgEQABgEAAgFQAAgEgBgDQgBgDgDgCIgIgCIgIgBIgKABIgJAAIAAgsIA0AAIAAALIgpAAIAAAWIAGAAIAEAAQAGAAAGABQAFABAFAEQAEADACAEQAEAFAAAIQgBAGgCAFQgCAGgEAEQgEAEgGACQgGACgHAAIgNgBg',
      );
    this.shape_119.setTransform(28.45, 9.8);

    this.shape_120 = new cjs.Shape();
    this.shape_120.graphics
      .f('#000000')
      .s()
      .p(
        'AgVAmQgJgHAAgLQAAgIAEgGQAEgFAIgDIAAgBQgHgDgDgFQgDgEAAgHQgBgKAJgGQAHgHAMABQANAAAIAFQAIAHAAAKQAAAFgEAGQgEAGgGADIAAAAQAHADAFAFQAEAFAAAIQAAAMgIAHQgJAIgOAAQgNAAgIgIgAgPAHQgDAFAAAHQAAAHAGAFQAFAGAHAAQAJAAAFgFQAFgEAAgHQAAgGgCgDQgDgDgGgEIgHgCIgIgDQgEADgEAEgAgLggQgEADgBAGQAAAEACADQADADAFACIAGAEIAHACQAGgEACgEQACgEAAgFQABgGgGgEQgFgEgHAAQgGAAgFAEg',
      );
    this.shape_120.setTransform(98.6, 26.2);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_9, p: { x: 37.625 } },
            { t: this.shape_8, p: { x: 50.575, y: 10.225 } },
            { t: this.shape_7, p: { x: 63.6 } },
            { t: this.shape_6, p: { x: 76.425, y: 10.25 } },
            { t: this.shape_5 },
            { t: this.shape_4, p: { x: 37.675 } },
            { t: this.shape_3, p: { x: 50.575 } },
            { t: this.shape_2, p: { x: 63.475 } },
            { t: this.shape_1, p: { x: 76.425, y: 26.75 } },
            { t: this.shape, p: { x: 89.375 } },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_15, p: { x: 37.8, y: 9.675 } },
              { t: this.shape_8, p: { x: 50.575, y: 10.225 } },
              { t: this.shape_14, p: { x: 63.525, y: 9.7 } },
              { t: this.shape_6, p: { x: 76.425, y: 10.25 } },
              { t: this.shape_13, p: { x: 89.25, y: 9.7 } },
              { t: this.shape_12, p: { x: 37.7 } },
              { t: this.shape_3, p: { x: 50.575 } },
              { t: this.shape_11, p: { x: 63.65 } },
              { t: this.shape_1, p: { x: 76.425, y: 26.75 } },
              { t: this.shape_10, p: { x: 89.375 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_23, p: { x: 24.8 } },
              { t: this.shape_22 },
              { t: this.shape_21, p: { x: 50.625 } },
              { t: this.shape_6, p: { x: 63.525, y: 10.25 } },
              { t: this.shape_14, p: { x: 76.475, y: 9.7 } },
              { t: this.shape_20 },
              { t: this.shape_19 },
              { t: this.shape_18, p: { x: 24.85 } },
              { t: this.shape_8, p: { x: 37.675, y: 26.725 } },
              { t: this.shape_17, p: { x: 50.625 } },
              { t: this.shape_1, p: { x: 63.525, y: 26.75 } },
              { t: this.shape_10, p: { x: 76.475 } },
              { t: this.shape_3, p: { x: 89.375 } },
              { t: this.shape_16 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_29 },
              { t: this.shape_8, p: { x: 46.775, y: 10.225 } },
              { t: this.shape_28 },
              { t: this.shape_6, p: { x: 72.625, y: 10.25 } },
              { t: this.shape_27 },
              { t: this.shape_26 },
              { t: this.shape_25, p: { x: 33.75 } },
              { t: this.shape_3, p: { x: 46.775 } },
              { t: this.shape_24 },
              { t: this.shape_1, p: { x: 72.625, y: 26.75 } },
              { t: this.shape_11, p: { x: 85.7 } },
              { t: this.shape, p: { x: 93.225 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_38, p: { x: 26.25 } },
              { t: this.shape_37, p: { x: 33.825 } },
              { t: this.shape_8, p: { x: 46.775, y: 10.225 } },
              { t: this.shape_14, p: { x: 59.725, y: 9.7 } },
              { t: this.shape_36, p: { x: 67.325 } },
              { t: this.shape_6, p: { x: 80.275, y: 10.25 } },
              { t: this.shape_35 },
              { t: this.shape_9, p: { x: 100.825 } },
              { t: this.shape_34 },
              { t: this.shape_33, p: { x: 29.975 } },
              { t: this.shape_3, p: { x: 42.925 } },
              { t: this.shape_10, p: { x: 55.875 } },
              { t: this.shape_32, p: { x: 63.475 } },
              { t: this.shape_1, p: { x: 76.425, y: 26.75 } },
              { t: this.shape_31 },
              { t: this.shape_30 },
              { t: this.shape_2, p: { x: 104.625 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_39 },
              { t: this.shape_38, p: { x: 33.9 } },
              { t: this.shape_8, p: { x: 46.775, y: 10.225 } },
              { t: this.shape_21, p: { x: 59.725 } },
              { t: this.shape_14, p: { x: 67.375, y: 9.7 } },
              { t: this.shape_6, p: { x: 80.275, y: 10.25 } },
              { t: this.shape_35 },
              { t: this.shape_7, p: { x: 100.95 } },
              { t: this.shape_25, p: { x: 22.25 } },
              { t: this.shape_12, p: { x: 30.05 } },
              { t: this.shape_3, p: { x: 42.925 } },
              { t: this.shape_17, p: { x: 55.875 } },
              { t: this.shape_10, p: { x: 63.525 } },
              { t: this.shape_1, p: { x: 76.425, y: 26.75 } },
              { t: this.shape_31 },
              { t: this.shape_30 },
              { t: this.shape, p: { x: 104.675 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_73 },
              { t: this.shape_72, p: { x: 21.625 } },
              { t: this.shape_71, p: { x: 29.225 } },
              { t: this.shape_70, p: { x: 34.525 } },
              { t: this.shape_69, p: { x: 45.875 } },
              { t: this.shape_68, p: { x: 52.3 } },
              { t: this.shape_67 },
              { t: this.shape_66, p: { x: 75.175, y: 10.675 } },
              { t: this.shape_65, p: { x: 82.725 } },
              { t: this.shape_64, p: { x: 92.425, y: 10.675 } },
              { t: this.shape_63, p: { x: 102.175 } },
              { t: this.shape_62, p: { x: 109.275 } },
              { t: this.shape_61, p: { x: 115.975, y: 10.775 } },
              { t: this.shape_60, p: { x: 13.075 } },
              { t: this.shape_59 },
              { t: this.shape_58, p: { x: 25.975 } },
              { t: this.shape_57, p: { x: 33.525 } },
              { t: this.shape_56 },
              { t: this.shape_55 },
              { t: this.shape_54, p: { x: 53.475 } },
              { t: this.shape_53 },
              { t: this.shape_52 },
              { t: this.shape_51 },
              { t: this.shape_50 },
              { t: this.shape_49, p: { x: 84.425 } },
              { t: this.shape_48 },
              { t: this.shape_47, p: { x: 99.275 } },
              { t: this.shape_46 },
              { t: this.shape_45 },
              { t: this.shape_44 },
              { t: this.shape_43 },
              { t: this.shape_42 },
              { t: this.shape_41, p: { y: 59.725, x: 50.575 } },
              { t: this.shape_13, p: { x: 61.25, y: 59.2 } },
              { t: this.shape_6, p: { x: 74.275, y: 59.75 } },
              { t: this.shape_40 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_90 },
              { t: this.shape_72, p: { x: 21.675 } },
              { t: this.shape_71, p: { x: 29.275 } },
              { t: this.shape_70, p: { x: 34.575 } },
              { t: this.shape_69, p: { x: 45.925 } },
              { t: this.shape_68, p: { x: 52.35 } },
              { t: this.shape_89 },
              { t: this.shape_88 },
              { t: this.shape_65, p: { x: 82.675 } },
              { t: this.shape_87 },
              { t: this.shape_63, p: { x: 102.125 } },
              { t: this.shape_62, p: { x: 109.225 } },
              { t: this.shape_86 },
              { t: this.shape_64, p: { x: 13.925, y: 27.175 } },
              { t: this.shape_85 },
              { t: this.shape_66, p: { x: 26.825, y: 27.175 } },
              { t: this.shape_57, p: { x: 34.375 } },
              { t: this.shape_84 },
              { t: this.shape_54, p: { x: 51.025 } },
              { t: this.shape_83 },
              { t: this.shape_82 },
              { t: this.shape_58, p: { x: 76.125 } },
              { t: this.shape_47, p: { x: 83.675 } },
              { t: this.shape_60, p: { x: 93.375 } },
              { t: this.shape_81 },
              { t: this.shape_49, p: { x: 110.225 } },
              { t: this.shape_80 },
              { t: this.shape_79 },
              { t: this.shape_78 },
              { t: this.shape_77 },
              { t: this.shape_76 },
              { t: this.shape_61, p: { x: 58.525, y: 43.775 } },
              { t: this.shape_75 },
              { t: this.shape_1, p: { x: 80.975, y: 43.25 } },
              { t: this.shape_15, p: { x: 94.05, y: 42.675 } },
              { t: this.shape_13, p: { x: 39.75, y: 59.2 } },
              { t: this.shape_41, p: { y: 59.725, x: 50.575 } },
              { t: this.shape_14, p: { x: 61.375, y: 59.2 } },
              { t: this.shape_6, p: { x: 74.275, y: 59.75 } },
              { t: this.shape_74, p: { x: 87.35, y: 59.175 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_105 },
              { t: this.shape_104 },
              { t: this.shape_23, p: { x: 63.5 } },
              { t: this.shape_103 },
              { t: this.shape_102 },
              { t: this.shape_101 },
              { t: this.shape_100 },
              { t: this.shape_99 },
              { t: this.shape_98 },
              { t: this.shape_97 },
              { t: this.shape_96 },
              { t: this.shape_95, p: { x: 50.575, y: 59.725 } },
              { t: this.shape_94 },
              { t: this.shape_6, p: { x: 74.275, y: 59.75 } },
              { t: this.shape_14, p: { x: 87.225, y: 59.2 } },
              { t: this.shape_93 },
              { t: this.shape_41, p: { y: 76.225, x: 50.575 } },
              { t: this.shape_92 },
              { t: this.shape_1, p: { x: 74.275, y: 76.25 } },
              { t: this.shape_91 },
              { t: this.text },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_111 },
              { t: this.shape_110 },
              { t: this.shape_95, p: { x: 54.375, y: 10.225 } },
              { t: this.shape_109 },
              { t: this.shape_6, p: { x: 78.075, y: 10.25 } },
              { t: this.shape_14, p: { x: 91.025, y: 9.7 } },
              { t: this.shape_108, p: { x: 36.15, y: 26.175 } },
              { t: this.shape_107 },
              { t: this.shape_41, p: { y: 26.725, x: 54.375 } },
              { t: this.shape_10, p: { x: 65.175 } },
              { t: this.shape_1, p: { x: 78.075, y: 26.75 } },
              { t: this.shape_106 },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_115, p: { y: 9.675 } },
              { t: this.shape_37, p: { x: 35.975 } },
              { t: this.shape_95, p: { x: 46.725, y: 10.225 } },
              { t: this.shape_114 },
              { t: this.shape_36, p: { x: 65.125 } },
              { t: this.shape_6, p: { x: 78.075, y: 10.25 } },
              { t: this.shape_113 },
              { t: this.shape_9, p: { x: 98.625 } },
              { t: this.shape, p: { x: 28.375 } },
              { t: this.shape_33, p: { x: 35.975 } },
              { t: this.shape_41, p: { y: 26.725, x: 46.725 } },
              { t: this.shape_74, p: { x: 57.65, y: 26.175 } },
              { t: this.shape_32, p: { x: 65.125 } },
              { t: this.shape_1, p: { x: 78.075, y: 26.75 } },
              { t: this.shape_112 },
              { t: this.shape_2, p: { x: 98.625 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_119 },
              { t: this.shape_118 },
              { t: this.shape_95, p: { x: 46.725, y: 10.225 } },
              { t: this.shape_13, p: { x: 57.4, y: 9.7 } },
              { t: this.shape_117 },
              { t: this.shape_6, p: { x: 78.075, y: 10.25 } },
              { t: this.shape_108, p: { x: 91.15, y: 9.675 } },
              { t: this.shape_14, p: { x: 98.675, y: 9.7 } },
              { t: this.shape_115, p: { y: 26.175 } },
              { t: this.shape_10, p: { x: 36.025 } },
              { t: this.shape_41, p: { y: 26.725, x: 46.725 } },
              { t: this.shape_116 },
              { t: this.shape_4, p: { x: 65.175 } },
              { t: this.shape_1, p: { x: 78.075, y: 26.75 } },
              { t: this.shape, p: { x: 91.025 } },
              { t: this.shape_25, p: { x: 98.55 } },
            ],
          },
          1,
        )
        .to(
          {
            state: [
              { t: this.shape_119 },
              { t: this.shape_118 },
              { t: this.shape_95, p: { x: 46.725, y: 10.225 } },
              { t: this.shape_13, p: { x: 57.4, y: 9.7 } },
              { t: this.shape_117 },
              { t: this.shape_6, p: { x: 78.075, y: 10.25 } },
              { t: this.shape_108, p: { x: 91.15, y: 9.675 } },
              { t: this.shape_14, p: { x: 98.675, y: 9.7 } },
              { t: this.shape_115, p: { y: 26.175 } },
              { t: this.shape_18, p: { x: 36.1 } },
              { t: this.shape_41, p: { y: 26.725, x: 46.725 } },
              { t: this.shape_116 },
              { t: this.shape_10, p: { x: 65.175 } },
              { t: this.shape_1, p: { x: 78.075, y: 26.75 } },
              { t: this.shape_112 },
              { t: this.shape_120 },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(0, -495, 593.2, 596);

  (lib.blocker = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('rgba(255,255,255,0)').s().p('AuDK8IAA13IcHAAIAAV3g');
    this.shape.setTransform(90, 70);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.blocker,
    new cjs.Rectangle(0, 0, 180, 140),
    null,
  );

  (lib.Scoreboard_progressMeter_fill = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFF00').s().p('AvnCWIAAkrIfPAAIAAErg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter_fill,
    new cjs.Rectangle(0, -15, 200, 30),
    null,
  );

  (lib.Scoreboard_changeRoundBtn = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgRAhIgKgEIAAgRIABAAIAEACIAFADIAGADIAIABQAEAAADgCQADgBAAgDQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBIgGgCIgFgBIgGgCQgIgCgEgEQgEgEAAgIQAAgFACgDQACgEAEgDQAEgDAGgCQAFgCAHAAQAHAAAFACQAGABAEACIAAAQIgBAAIgEgCIgEgCIgGgCIgHgBQgDAAgDACQgBAAgBABQAAAAAAABQgBAAAAABQAAAAAAABQAAAAAAABQAAAAAAABQAAAAABAAQAAABAAAAQACACAEABIAGABIAHACQAHACADADQAEAFAAAHQAAAFgCAEQgCAEgEADQgEADgGACQgGACgHAAQgHAAgHgCg',
      );
    this.shape.setTransform(19.525, 9.825);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgZAlQgGgJAAgQQAAgJACgFQACgGAEgFQAEgEAFgDQAFgCAGAAIAHABIAIAEIAAgdIAUAAIAABbIgUAAIAAgHIgFADIgEADIgEACIgGABQgLAAgHgKgAgGgCQgEAFAAAJQAAAKADAEQADAEAFAAQADAAADgBIAFgCIAAggIgEgBIgEAAQgHAAgDAEg',
      );
    this.shape_1.setTransform(12.325, 8.65);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_2.setTransform(4.975, 9.725);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAcQgGgHAAgMIAAgqIAVAAIAAAhIAAAHIABAGIADACQACACADAAIAFgCIAFgCIAAguIAVAAIAABBIgVAAIAAgIIgKAIQgDACgGAAQgKAAgFgGg',
      );
    this.shape_3.setTransform(-2.775, 9.9);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAZQgJgIAAgRQAAgQAJgIQAJgKAPAAQAQAAAJAKQAJAJAAAPQAAARgJAIQgIAKgRAAQgPAAgJgKgAgEgTIgEAEQgCACgBAEIgBAJIABAKIACAGIAFAEIAEABIAFgBIAEgEIADgGIABgKIgBgJIgDgFQgCgDgCgBIgFgBIgEAAg',
      );
    this.shape_4.setTransform(-10.3, 9.8);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAOAsIgYghIgHAAIAAAhIgWAAIAAhWIAjAAIAMAAQAFABAEADQAFADADAEQADAFAAAHQAAAKgFAGQgEAGgIADIAdAmgAgRgDIAGAAIAIgBIAEgCIADgEIABgGQAAgEgBgCQgBgCgDgBIgEgBIgGAAIgHAAg',
      );
    this.shape_5.setTransform(-17.775, 8.75);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgWAaQgKgJAAgRQAAgOAKgKQAJgKAPAAQAQAAAHAIQAIAJAAAPIAAAGIgsAAIACAIQABADADABQADACACABIAIABIAHgBIAGgCIAFgCIADgCIADAAIAAARIgFABIgGACIgHABIgIABQgSAAgKgJgAgHgRQgEAEAAAFIAYAAQgBgGgCgEQgDgCgGAAQgFAAgDADg',
      );
    this.shape_6.setTransform(19.025, -4.7);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgOAtIgKgCIAAgQIACAAIAEABIAEABIAFABIAFABIAIgBIAFgDQACgCAAgDIABgHIAAgBQgEADgEABQgEACgEAAQgNAAgHgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAFgCQAFgCAGAAIAIABIAHADIABgDIATAAIAAA6QAAAJgCAGQgDAHgEADQgFAEgGABQgHACgHAAIgMgBgAgGgZQgEAFAAAIIAAAHIADAFIADADIAFABIAGgBIAFgCIAAgdIgEgBIgEgBQgHAAgDAFg',
      );
    this.shape_7.setTransform(11.425, -3.525);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_8.setTransform(4.075, -4.775);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAdQgGgGAAgJQAAgHADgFQADgDAGgDQAFgDAIgBIAPgBIAAgBQAAgFgDgCQgFgCgHAAIgIABIgKADIgBAAIAAgQIAKgCIANgBQAQAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgDADIgFADIgEACIgIABQgIAAgGgGgAACADIgFABQgDABgCACQgBACAAADQAAAFACACQADABAEAAIAFgBIAFgDIAAgOIgIABg',
      );
    this.shape_9.setTransform(-3.625, -4.675);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKAtIAAggIAAgIIgBgFIgDgDIgGgBIgEABIgFADIAAAtIgVAAIAAhaIAVAAIAAAhQAFgFAEgCQAEgCAGAAQAKAAAFAHQAGAFAAAMIAAAqg',
      );
    this.shape_10.setTransform(-10.825, -5.95);

    this.shape_11 = new cjs.Shape();
    this.shape_11.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYAiQgLgMAAgWQAAgUALgMQAMgMASAAIAKAAIAIACIAGACIAGADIAAAVIgCAAIgEgDIgGgEIgGgDIgIgCQgFAAgDACQgDABgEAEQgDADgDAGQgCAGAAAGQAAAIACAGQADAFADAEQAEADADACQAEABAFAAIAIgBIAGgEIAFgDIAEgEIACAAIAAAVIgGADIgGACIgHACIgLAAQgSAAgMgLg',
      );
    this.shape_11.setTransform(-18.7, -5.775);

    this.shape_12 = new cjs.Shape();
    this.shape_12.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgRAhIgKgEIAAgRIABAAIAEACIAFADIAGADIAIABQAEAAADgCQADgBAAgDQAAgBAAAAQAAgBAAAAQAAgBgBAAQAAAAAAgBIgGgCIgFgBIgGgCQgIgCgEgEQgEgEAAgIQAAgFACgDQACgEAEgDQAEgDAGgCQAFgCAHAAQAHAAAFACQAGABAEACIAAAQIgBAAIgEgCIgEgCIgGgCIgHgBQgDAAgDACQgBAAgBABQAAAAAAABQgBAAAAABQAAAAAAABQAAAAAAABQAAAAAAABQAAAAABAAQAAABAAAAQACACAEABIAGABIAHACQAHACADADQAEAFAAAHQAAAFgCAEQgCAEgEADQgEADgGACQgGACgHAAQgHAAgHgCg',
      );
    this.shape_12.setTransform(19.525, 9.825);

    this.shape_13 = new cjs.Shape();
    this.shape_13.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgZAlQgGgJAAgQQAAgJACgFQACgGAEgFQAEgEAFgDQAFgCAGAAIAHABIAIAEIAAgdIAUAAIAABbIgUAAIAAgHIgFADIgEADIgEACIgGABQgLAAgHgKgAgGgCQgEAFAAAJQAAAKADAEQADAEAFAAQADAAADgBIAFgCIAAggIgEgBIgEAAQgHAAgDAEg',
      );
    this.shape_13.setTransform(12.325, 8.65);

    this.shape_14 = new cjs.Shape();
    this.shape_14.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_14.setTransform(4.975, 9.725);

    this.shape_15 = new cjs.Shape();
    this.shape_15.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAcQgGgHAAgMIAAgqIAVAAIAAAhIAAAHIABAGIADACQACACADAAIAFgCIAFgCIAAguIAVAAIAABBIgVAAIAAgIIgKAIQgDACgGAAQgKAAgFgGg',
      );
    this.shape_15.setTransform(-2.775, 9.9);

    this.shape_16 = new cjs.Shape();
    this.shape_16.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAZQgJgIAAgRQAAgQAJgIQAJgKAPAAQAQAAAJAKQAJAJAAAPQAAARgJAIQgIAKgRAAQgPAAgJgKgAgEgTIgEAEQgCACgBAEIgBAJIABAKIACAGIAFAEIAEABIAFgBIAEgEIADgGIABgKIgBgJIgDgFQgCgDgCgBIgFgBIgEAAg',
      );
    this.shape_16.setTransform(-10.3, 9.8);

    this.shape_17 = new cjs.Shape();
    this.shape_17.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAOAsIgYghIgHAAIAAAhIgWAAIAAhWIAjAAIAMAAQAFABAEADQAFADADAEQADAFAAAHQAAAKgFAGQgEAGgIADIAdAmgAgRgDIAGAAIAIgBIAEgCIADgEIABgGQAAgEgBgCQgBgCgDgBIgEgBIgGAAIgHAAg',
      );
    this.shape_17.setTransform(-17.775, 8.75);

    this.shape_18 = new cjs.Shape();
    this.shape_18.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgWAaQgKgJAAgRQAAgOAKgKQAJgKAPAAQAQAAAHAIQAIAJAAAPIAAAGIgsAAIACAIQABADADABQADACACABIAIABIAHgBIAGgCIAFgCIADgCIADAAIAAARIgFABIgGACIgHABIgIABQgSAAgKgJgAgHgRQgEAEAAAFIAYAAQgBgGgCgEQgDgCgGAAQgFAAgDADg',
      );
    this.shape_18.setTransform(19.025, -4.7);

    this.shape_19 = new cjs.Shape();
    this.shape_19.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgOAtIgKgCIAAgQIACAAIAEABIAEABIAFABIAFABIAIgBIAFgDQACgCAAgDIABgHIAAgBQgEADgEABQgEACgEAAQgNAAgHgIQgHgIAAgQQAAgIACgGQACgGAEgFQAEgEAFgCQAFgCAGAAIAIABIAHADIABgDIATAAIAAA6QAAAJgCAGQgDAHgEADQgFAEgGABQgHACgHAAIgMgBgAgGgZQgEAFAAAIIAAAHIADAFIADADIAFABIAGgBIAFgCIAAgdIgEgBIgEgBQgHAAgDAFg',
      );
    this.shape_19.setTransform(11.425, -3.525);

    this.shape_20 = new cjs.Shape();
    this.shape_20.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAiIAAghIAAgHIgBgGIgDgDIgGgBIgEABIgFADIAAAuIgVAAIAAhBIAVAAIAAAHQAFgEAEgCQAEgDAGAAQAKAAAFAHQAGAGAAAMIAAAqg',
      );
    this.shape_20.setTransform(4.075, -4.775);

    this.shape_21 = new cjs.Shape();
    this.shape_21.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAdQgGgGAAgJQAAgHADgFQADgDAGgDQAFgDAIgBIAPgBIAAgBQAAgFgDgCQgFgCgHAAIgIABIgKADIgBAAIAAgQIAKgCIANgBQAQAAAIAGQAIAFAAAMIAAAsIgVAAIAAgHIgDADIgFADIgEACIgIABQgIAAgGgGgAACADIgFABQgDABgCACQgBACAAADQAAAFACACQADABAEAAIAFgBIAFgDIAAgOIgIABg',
      );
    this.shape_21.setTransform(-3.625, -4.675);

    this.shape_22 = new cjs.Shape();
    this.shape_22.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AAKAtIAAggIAAgIIgBgFIgDgDIgGgBIgEABIgFADIAAAtIgVAAIAAhaIAVAAIAAAhQAFgFAEgCQAEgCAGAAQAKAAAFAHQAGAFAAAMIAAAqg',
      );
    this.shape_22.setTransform(-10.825, -5.95);

    this.shape_23 = new cjs.Shape();
    this.shape_23.graphics
      .f('#9CDCFA')
      .s()
      .p(
        'AgYAiQgLgMAAgWQAAgUALgMQAMgMASAAIAKAAIAIACIAGACIAGADIAAAVIgCAAIgEgDIgGgEIgGgDIgIgCQgFAAgDACQgDABgEAEQgDADgDAGQgCAGAAAGQAAAIACAGQADAFADAEQAEADADACQAEABAFAAIAIgBIAGgEIAFgDIAEgEIACAAIAAAVIgGADIgGACIgHACIgLAAQgSAAgMgLg',
      );
    this.shape_23.setTransform(-18.7, -5.775);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_11 },
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to(
          {
            state: [
              { t: this.shape_23 },
              { t: this.shape_22 },
              { t: this.shape_21 },
              { t: this.shape_20 },
              { t: this.shape_19 },
              { t: this.shape_18 },
              { t: this.shape_17 },
              { t: this.shape_16 },
              { t: this.shape_15 },
              { t: this.shape_14 },
              { t: this.shape_13 },
              { t: this.shape_12 },
            ],
          },
          1,
        )
        .wait(1),
    );

    // Layer 2
    this.shape_24 = new cjs.Shape();
    this.shape_24.graphics.f('#000000').s().p('Aj3ClIAAlJIHuAAIAAFJg');
    this.shape_24.setTransform(-0.05, 2.1);

    this.timeline.addTween(cjs.Tween.get(this.shape_24).wait(2));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-24.8, -15.4, 49.5, 34);

  (lib.redX = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#FF0000')
      .ss(5, 0, 0, 3)
      .p('ACWCWIiWiWIiVCWAAAAAICWiVAiViVICVCV');
    this.shape.setTransform(0, 0.0029);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.5, -17.5, 35, 35);

  (lib.roundBtnshine = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .lf(
        ['rgba(255,255,255,0)', 'rgba(255,255,255,0.2)'],
        [0, 1],
        0,
        22.5,
        0,
        -22.5,
      )
      .s()
      .p('AiuDhQgyAAAAgyIAAldQAAgyAyAAIFdAAQAyAAAAAyIAAFdQAAAygyAAg');

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-22.5, -22.5, 45, 45);

  (lib.roundBtnhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('rgba(255,255,255,0.498)')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape.setTransform(0, 0.025);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_1.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtnhover,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.GameFrame_veil = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#FFFFFF').s().p('Eg/RAvqMAAAhfTMB+jAAAMAAABfTg');
    this.shape.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameFrame_veil,
    new cjs.Rectangle(-5, -5, 810, 610),
    null,
  );

  (lib.EndScreenbuttonhover = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(255,255,255,0.098)')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonhover,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.EndScreenbuttonbg = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5645DA')
      .s()
      .p(
        'AqJDIQhTAAg7g6Qg6g7AAhTQAAhSA6g7QA7g6BTAAIUTAAQBTAAA6A6QA7A7AABSQAABTg7A7Qg6A6hTAAg',
      );

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreenbuttonbg,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.ValueTextBlack_fields = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // line
    this.line = new lib.ValueTextBlack_line();
    this.line.name = 'line';

    this.timeline.addTween(cjs.Tween.get(this.line).wait(1));

    // denominator
    this.denominator = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.denominator.name = 'denominator';
    this.denominator.textAlign = 'center';
    this.denominator.lineHeight = 23;
    this.denominator.lineWidth = 91;
    this.denominator.parent = this;
    this.denominator.setTransform(0.35, -4.6);

    this.timeline.addTween(cjs.Tween.get(this.denominator).wait(1));

    // numerator
    this.numerator = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.numerator.name = 'numerator';
    this.numerator.textAlign = 'center';
    this.numerator.lineHeight = 23;
    this.numerator.lineWidth = 91;
    this.numerator.parent = this;
    this.numerator.setTransform(0.1, -23.35);

    this.timeline.addTween(cjs.Tween.get(this.numerator).wait(1));

    // extraTinyText
    this.extraTinyText = new cjs.Text('1', "bold 16px 'Open Sans Condensed'");
    this.extraTinyText.name = 'extraTinyText';
    this.extraTinyText.textAlign = 'center';
    this.extraTinyText.lineHeight = 23;
    this.extraTinyText.lineWidth = 71;
    this.extraTinyText.parent = this;
    this.extraTinyText.setTransform(-1.15, -11.9);

    this.timeline.addTween(cjs.Tween.get(this.extraTinyText).wait(1));

    // tinyText
    this.tinyText = new cjs.Text('1', "bold 20px 'Open Sans Condensed'");
    this.tinyText.name = 'tinyText';
    this.tinyText.textAlign = 'center';
    this.tinyText.lineHeight = 29;
    this.tinyText.lineWidth = 91;
    this.tinyText.parent = this;
    this.tinyText.setTransform(0.05, -14.6);

    this.timeline.addTween(cjs.Tween.get(this.tinyText).wait(1));

    // smallText
    this.smallText = new cjs.Text('1', "bold 26px 'Open Sans Condensed'");
    this.smallText.name = 'smallText';
    this.smallText.textAlign = 'center';
    this.smallText.lineHeight = 37;
    this.smallText.lineWidth = 91;
    this.smallText.parent = this;
    this.smallText.setTransform(-1.15, -18.7);

    this.timeline.addTween(cjs.Tween.get(this.smallText).wait(1));

    // largeText
    this.largeText = new cjs.Text('1', "bold 32px 'Open Sans Condensed'");
    this.largeText.name = 'largeText';
    this.largeText.textAlign = 'center';
    this.largeText.lineHeight = 46;
    this.largeText.lineWidth = 91;
    this.largeText.parent = this;
    this.largeText.setTransform(-1, -24.2);

    this.timeline.addTween(cjs.Tween.get(this.largeText).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ValueTextBlack_fields,
    new cjs.Rectangle(-48.6, -26.2, 96.5, 50.9),
    null,
  );

  (lib.comsuntexsymbolsPositiveFeedback = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // text
    this.text = new lib.PostitiveFeedback_text();
    this.text.name = 'text';
    this.text.setTransform(0.7, 0.45);

    this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

    // bg
    this.bg = new lib.PostivieFeedback_bg();
    this.bg.name = 'bg';
    this.bg.setTransform(-4, 0.45);

    this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .rf(
        ['#FFFFFF', 'rgba(255,255,255,0)'],
        [0.749, 1],
        -0.1,
        -0.1,
        0,
        -0.1,
        -0.1,
        47.4,
      )
      .s()
      .p(
        'AvCFUQmPiMAAjIQAAjGGPiOQGPiNIzAAQI0AAGOCNQGPCOABDGQgBDImPCMQmOCOo0AAQozAAmPiOg',
      );
    this.shape.setTransform(-0.2, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsPositiveFeedback,
    new cjs.Rectangle(-136.3, -48.2, 272.3, 96.4),
    null,
  );

  (lib.rules = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.examples = new lib.Examples();
    this.examples.name = 'examples';
    this.examples.setTransform(-759.45, -17.6, 1, 1, 0, 0, 0, 48.5, 16.9);

    this.equatn = new lib.eq();
    this.equatn.name = 'equatn';
    this.equatn.setTransform(-764.45, 16.95, 1, 1, 0, 0, 0, 63.5, 17.5);

    this.ruleTxt = new lib.ruletext();
    this.ruleTxt.name = 'ruleTxt';
    this.ruleTxt.setTransform(65.5, 162.5, 1, 1, 0, 0, 0, 0.5, 0.5);

    this.ruleHdr = new lib.ruleheader();
    this.ruleHdr.name = 'ruleHdr';
    this.ruleHdr.setTransform(67, 107.5, 1, 1, 0, 0, 0, 67, 117.2);

    this.opBtn1 = new lib.OperationButtons();
    this.opBtn1.name = 'opBtn1';
    this.opBtn1.setTransform(65.8, 30.2, 1.5, 1.5, 0, 0, 0, 0, -0.2);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.opBtn1 },
            { t: this.ruleHdr },
            { t: this.ruleTxt },
            { t: this.equatn },
            { t: this.examples },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.rules,
    new cjs.Rectangle(-827.9, -34.5, 956.9, 222.7),
    null,
  );

  (lib.Scoreboard_progressMeter = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // outline
    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#003366').ss(2, 1, 1).p('AvniVIfPAAIAAErI/PAAg');
    this.shape.setTransform(100, 0);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // fill
    this.percentCompleteTxt = new cjs.Text('', "bold 14px 'Roboto'", '#FFFFFF');
    this.percentCompleteTxt.name = 'percentCompleteTxt';
    this.percentCompleteTxt.lineHeight = 19;
    this.percentCompleteTxt.lineWidth = 28;
    this.percentCompleteTxt.parent = this;
    this.percentCompleteTxt.setTransform(205, -9.25, 1, 1.0024);

    this.progressMeterFill = new lib.Scoreboard_progressMeter_fill();
    this.progressMeterFill.name = 'progressMeterFill';
    this.progressMeterFill.setTransform(100, 0, 1, 1, 0, 0, 0, 100, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.progressMeterFill },
            { t: this.percentCompleteTxt },
          ],
        })
        .wait(1),
    );

    // Layer 2
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#003366')
      .ss(2, 1, 1)
      .p('AvniVIfPAAIAAErI/PAAg');
    this.shape_1.setTransform(100, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(0,51,102,0.047)')
      .s()
      .p('AvnCWIAAkrIfPAAIAAErg');
    this.shape_2.setTransform(100, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }, { t: this.shape_1 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.Scoreboard_progressMeter,
    new cjs.Rectangle(-1, -16, 235.9, 32),
    null,
  );

  (lib.Scoreboard_muteBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#333333')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape.setTransform(11.05, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#666666')
      .s()
      .p(
        'AACCOQAzhOgBhAQABhAgzhNIAMgIQA3BLABBKQgBBKg3BMgAgoBxQAqg2AAg7QAAg6gqg2IALgJQAXAZAMAgQANAiAAAeQAABBgvA4gAhEBSQAZghAAgxQABgpgXgjIgDgGIAMgIQAfApAAAxQAAAygfAog',
      );
    this.shape_1.setTransform(11.05, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [] }, 2)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // Layer_1
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#333333')
      .s()
      .p('AgNAzIAAhlIBehOIAAEBgAhQAuIAAhbIAyAAIAABbg');
    this.shape_2.setTransform(-8.225, 0.025);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(4));

    // Layer_4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_3.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.Scoreboard_musicBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer_2
    this.instance = new lib.redX('synched', 0);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(2),
    );

    // Layer_7
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AieAZQAAgbAfgWIAMAFIgEADQgWARAAAYQAAAbAaATIgMAEQgfgWAAgcgAB0AUQAagSAAgaQAAgYgWgSIgEgEIAMgEQAfAWAAAcQAAAbgfAWg',
      );
    this.shape.setTransform(-0.475, 7.5);
    this.shape._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.shape).wait(3).to({ _off: false }, 0).wait(1),
    );

    // Layer_5
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#333333')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_1.setTransform(-1.05, -1.45);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#CCCCCC')
      .s()
      .p(
        'AhiCOQgKgHABgNQAAgVATgRQATgQAYAAQAMAAAJAEIAAi5ICFgkIAADUQAAAWgUAQQgTARgYAAQgPAAgKgIQgIgHgBgOQAAgUAUgRQATgRAYAAQANAAAIAGIAAiYIhsAcIAACzQAAAUgTARQgUARgWAAQgRAAgIgIg',
      );
    this.shape_2.setTransform(-1.05, -1.45);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }] })
        .to({ state: [{ t: this.shape_2 }] }, 2)
        .wait(2),
    );

    // Layer_4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AilDLQhFhUAAh3QAAh2BFhUQBEhUBhAAQBhAABFBUQBFBUAAB2QAAB3hFBUQhFBUhhAAQhhAAhEhUg',
      );
    this.shape_3.setTransform(0.0244, -0.0169, 0.8511, 0.6969);

    this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(4));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-20, -20, 40, 40);

  (lib.ProgressPanel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.correctTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.correctTxt.name = 'correctTxt';
    this.correctTxt.lineHeight = 21;
    this.correctTxt.lineWidth = 28;
    this.correctTxt.parent = this;
    this.correctTxt.setTransform(273.65, -8.9, 1, 1.0024);

    this.roundTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.roundTxt.name = 'roundTxt';
    this.roundTxt.lineHeight = 21;
    this.roundTxt.lineWidth = 20;
    this.roundTxt.parent = this;
    this.roundTxt.setTransform(68.05, -8.2856, 1, 1.0024);

    this.gameTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.gameTxt.name = 'gameTxt';
    this.gameTxt.lineHeight = 21;
    this.gameTxt.lineWidth = 25;
    this.gameTxt.parent = this;
    this.gameTxt.setTransform(156.25, -8.3, 1, 1.0024);

    this.correctLbl = new cjs.Text('Correct:', "bold 15px 'Roboto'", '#FFFFFF');
    this.correctLbl.name = 'correctLbl';
    this.correctLbl.lineHeight = 20;
    this.correctLbl.lineWidth = 57;
    this.correctLbl.parent = this;
    this.correctLbl.setTransform(203.9, -8.45, 1.0021, 0.9976);

    this.bonusTxt = new cjs.Text('', "bold 16px 'Roboto'", '#FFFFFF');
    this.bonusTxt.name = 'bonusTxt';
    this.bonusTxt.lineHeight = 21;
    this.bonusTxt.lineWidth = 48;
    this.bonusTxt.parent = this;
    this.bonusTxt.setTransform(537.5, -9.3, 1, 1.0024);

    this.progressMeterMc = new lib.Scoreboard_progressMeter();
    this.progressMeterMc.name = 'progressMeterMc';
    this.progressMeterMc.setTransform(290.15, -0.7, 1, 1, 0, 0, 0, 100, -0.5);

    this.bonusLbl = new cjs.Text(
      'Bonus \nStickers:  ',
      "bold 12px 'Roboto'",
      '#FFFFFF',
    );
    this.bonusLbl.name = 'bonusLbl';
    this.bonusLbl.textAlign = 'center';
    this.bonusLbl.lineHeight = 12;
    this.bonusLbl.lineWidth = 68;
    this.bonusLbl.parent = this;
    this.bonusLbl.setTransform(493.55, -13.2, 1.0014, 0.9976);

    this.gameLbl = new cjs.Text('GAME:  ', "bold 14px 'Roboto'", '#FFFFFF');
    this.gameLbl.name = 'gameLbl';
    this.gameLbl.lineHeight = 19;
    this.gameLbl.lineWidth = 45;
    this.gameLbl.parent = this;
    this.gameLbl.setTransform(98.5, -7.45, 1.0021, 0.9976);

    this.roundLbl = new cjs.Text('ROUND:', "bold 14px 'Roboto'", '#FFFFFF');
    this.roundLbl.name = 'roundLbl';
    this.roundLbl.lineHeight = 19;
    this.roundLbl.lineWidth = 54;
    this.roundLbl.parent = this;
    this.roundLbl.setTransform(1, -7.45, 1.0021, 0.9976);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.roundLbl },
            { t: this.gameLbl },
            { t: this.bonusLbl },
            { t: this.progressMeterMc },
            { t: this.bonusTxt },
            { t: this.correctLbl },
            { t: this.gameTxt },
            { t: this.roundTxt },
            { t: this.correctTxt },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.ProgressPanel,
    new cjs.Rectangle(-1, -16.2, 588, 32),
    null,
  );

  (lib.roundBtn4 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAjCSIgVAAIAAgwIAAgUIh3AAIgUAAIAAg3ICHioIBMAAIAAAUIAACWIAVAAIATAAIAAAUIAAAhIgoAAIAABEgAhFAZIAkAAIAvAAIAAg8IAAgtg',
      );
    this.shape.setTransform(-0.15, -0.5);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AAPCSIAAgUIAzAAIAAhEIAoAAIAAghIAUAAIAAA1IgnAAIAABEgAh9BOIAAgUIB4AAIAAAUgABCAFIAAiWIAVAAIAACWgAhZAFIBUhpIAAAtIgwA8g',
      );
    this.shape_1.setTransform(1.85, 1.5);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#FF0000', '#990000'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn4,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn3 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#000000')
      .s()
      .p(
        'AhICQQgagGgQgHIAMADQAaAFAkAAQAgAAAVgGQAWgHARgMQAQgNAJgSQAIgRAAgVQAAgSgGgLQgGgLgJgHIgKgHQAJABAKAEQAMAEAJAHQAJAIAGALQAGALAAASQAAAVgIARQgJASgQANQgRAMgWAHQgWAGgfAAQgkAAgagFgAArgOQgLgEgKgBIAAgDQAZgFAPgTQAPgUAAgYQAAgSgIgOQgIgNgQgKIgFgDIABAAQAVAFANAIQAQAKAIANQAIAOAAASQAAAYgPAUQgPATgZAFIAAACIgJgEgAhqhHIAAgWIATgGQAWgHASAAIASABQAKACAIADIAHAFIgNgBQgSAAgWAHQgVAGgUAMg',
      );
    this.shape.setTransform(2.825, 0.6875);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AgnAgIgRgHIAAgBIAHAAQAKAGANAFIgNgDgAA0gYIgZAAIgQAAIAAgKIALAAQANAAAKADQAHACAFAFIgFAAg',
      );
    this.shape_1.setTransform(-2.9375, 4.95);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhICSIgMgDQgSgFgMgFIAAhAIAIAAQAKAGAMAFIASAHIAMADQAQAFAPAAQALAAAMgCQANgCAKgGQAHgGAEgHQAEgGAAgOQAAgMgFgHIgEgDQgFgFgHgCQgJgDgNAAIgLAAIgOAAIgQAAIAAgzIARAAIAbgBQAKgBAJgEQAIgEAEgGQAFgGAAgMQAAgJgFgFIgEgEIgHgEQgIgEgKgCIgRAAQgSAAgWAGIgTAGQgLAFgLAHIgIAAIAAg/QARgGAbgHQAcgFAcAAQAaAAAVAEQARAEAMAGIAFADQAQAKAIANQAIAOAAATQAAAXgPAUQgPATgZAFIAAADQAKABALAEIAJADIACABIAKAHQAJAJAGALQAGAKAAATQAAAUgIASQgJARgQANQgRANgWAGQgWAGgfAAQgkABgagGg',
      );
    this.shape_2.setTransform(-0.175, -0.55);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [{ t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }],
        })
        .wait(1),
    );

    // Layer 4
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .rf(['#351DE2', '#2C2659'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_4.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn3,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn2 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhxCLIAAgUIDPAAIAAgkIAUAAIAAA4gAgjA/IAZgUQARgNASgQQAcgaAOgZQAOgZAAgbQAAgdgNgUIAEAEQAdAXAAAqQAAAcgOAYQgOAYgcAaQgRARgSANgAhphKIAAgcQALgGAMgFQATgHASAAQAYgBANALQAHAGACAIQgKgFgQAAQgSABgTAHQgUAIgRALg',
      );
    this.shape.setTransform(2.625, 2.15);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhdCUIgUAAIAAgwQAagTAagVQAbgVAPgQQAXgXAKgQQAKgRAAgQQAAgKgDgHQgDgIgHgGQgMgLgYAAQgSAAgTAIQgMAEgLAGIgOAJIgGAAIAAhBQANgGAcgGQAagGAcAAQA1AAAdAXQAJAHAHAJQANAUAAAdQAAAbgOAZQgOAYgcAaQgSARgSANIgYAUIAtAAIBUAAIAAAUIAAAjg',
      );
    this.shape_1.setTransform(0.625, -0.825);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#1BB448', '#265945'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn2,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.roundBtn1 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 5
    this.btnHover = new lib.roundBtnhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 3
    this.instance = new lib.roundBtnshine('synched', 0);

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('rgba(0,0,0,0.498)')
      .s()
      .p(
        'AhgCSIAAgUICtAAIAAgfIAUAAIAAAzgAARBLIAAjcIAUAAIAADcgAhgg6IAAgUIApAAIAAAUg',
      );
    this.shape.setTransform(1.5, 1.425);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhMCSIgUAAIAAgzIA9AAIAAiFIAAgUIgpAAIgUAAIAAgvQAOAAANgCQANgCAJgEQAJgFAFgHQAGgIABgMIA/AAIAAAUIAADcIAUAAIAoAAIAAAUIAAAfg',
      );
    this.shape_1.setTransform(-0.5, -0.575);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .wait(1),
    );

    // Layer 4
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#003366')
      .ss(3, 1, 1)
      .p('AjHkcIGPAAQBkAAAABkIAAFxQAABkhkAAImPAAQhkAAAAhkIAAlxQAAhkBkAAg');
    this.shape_2.setTransform(0, 0.025);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .rf(['#A415EA', '#541D67'], [0, 1], 0, 0, 0, 0, 0, 38.3)
      .s()
      .p('AjHEdQhkAAAAhkIAAlxQAAhkBkAAIGPAAQBkAAAABkIAAFxQAABkhkAAg');
    this.shape_3.setTransform(0, 0.025);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.roundBtn1,
    new cjs.Rectangle(-31.5, -29.9, 63, 59.9),
    null,
  );

  (lib.nextBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgOBZIgNgFIgNgGQgFgDgEgGIAPgUQAGAGAHAEQAIAEAJAAQANAAAIgHQAHgHAAgNIAAgHQgGAGgHADQgIAEgJAAQgLAAgKgFQgKgFgGgJQgHgIgDgMQgEgLAAgOIAAgCQAAgOAEgMQADgMAHgIQAGgKAKgEQAKgFALABQALgBAHAEQAJAEAFAGIACgMIAeAAIAAB6QAAANgEAKQgFALgIAGQgIAIgLADQgLAEgNAAIgMgBgAgIg6QgGADgCAEQgEAFgCAHQgBAIAAAHIAAACQAAAJABAGQACAGAEAFQACAFAGADQAEACAGAAQAIAAAFgCQAGgDADgGIAAg1QgDgFgGgDQgFgDgIAAQgFAAgFADg',
      );
    this.shape.setTransform(62.3, 4.25);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAVBAIAAhQQAAgFgCgFQgBgDgDgDIgGgDIgJgBQgGAAgFADQgGADgDAGIAABYIgiAAIAAh+IAgAAIABAQQAHgJAJgEQAIgFALABQAJgBAIADQAHADAFAFQAGAGADAJQADAKAAANIAABPg',
      );
    this.shape_1.setTransform(48.975, 1.75);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgQBYIAAh+IAhAAIAAB+gAgHg2QgDgBgDgCIgEgGIgBgHQAAgIAFgFQAFgEAIgBIAIACIAGADQACADACADIABAHIgBAHIgEAGQgDACgDABQgEABgEAAQgDAAgEgBg',
      );
    this.shape_2.setTransform(39.125, -0.65);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgjBZIgDgBIgEAAIgDgBIAAgaIACAAIADAAIAIgBIAHgBIAEgFIADgGIAEgJIgth/IAlAAIAWBPIAYhPIAkAAIgzCRIgEALQgDAFgEAFQgFAFgGADQgHADgKAAIgFAAg',
      );
    this.shape_3.setTransform(29.925, 4.4);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgdA/QgIgDgGgFQgGgFgDgHQgDgHAAgIQAAgKADgIQAEgIAHgEQAIgGALgCQALgDANAAIAPAAIAAgHQAAgJgEgGQgFgFgIAAQgJAAgFAEQgFAEAAAIIghAAQAAgJADgHQAEgHAHgGQAHgFAKgEQAKgDALAAQALAAAKADQAJADAHAFQAHAGAEAIQADAJAAALIAAA0IABAKIABAIIABAGIACAFIAAACIgiAAQgCgEgBgHQgFAGgIAEQgHAEgLAAQgJAAgIgDgAgHAHQgFACgDACQgDADgCADQgBAEAAAEQAAAGAEAFQAEAEAIAAIAHgBIAHgDIAFgEIADgFIAAgVIgOAAQgFAAgFABg',
      );
    this.shape_4.setTransform(17.475, 1.875);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics.f('#FFFFFF').s().p('AgQBaIAAizIAhAAIAACzg');
    this.shape_5.setTransform(7.95, -0.8);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag4BZIAAivIAfAAIABANQAGgIAJgDQAHgEAKAAQAMAAAJAFQAJAEAHAIQAFAJAEAMQADAMAAAOIAAADQAAAOgDALQgEALgFAJQgHAJgJAEQgJAGgMAAQgJgBgIgDQgIgEgFgGIAAA8gAgOg5QgFACgDAHIAAAyQADAHAFADQAFADAJAAQAGAAAEgDQAFgDADgFQADgEABgHQACgHAAgHIAAgDQAAgHgCgHQgCgHgCgFQgDgFgFgDQgFgDgFAAQgJAAgFAEg',
      );
    this.shape_6.setTransform(-1.75, 4.2);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'Ag4BZIAAivIAgAAIABANQAGgIAHgDQAIgEAJAAQANAAAJAFQAKAEAFAIQAHAJADAMQADAMAAAOIAAADQAAAOgDALQgDALgHAJQgFAJgKAEQgJAGgMAAQgJgBgIgDQgHgEgGgGIAAA8gAgOg5QgFACgDAHIAAAyQADAHAFADQAGADAIAAQAFAAAGgDQAEgDADgFQACgEACgHQABgHAAgHIAAgDQAAgHgBgHQgBgHgEgFQgDgFgEgDQgFgDgFAAQgIAAgGAEg',
      );
    this.shape_7.setTransform(-21.25, 4.2);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgLgFgJgIQgIgJgEgLQgFgLABgNIAAgEQAAgOADgMQAFgMAHgIQAIgJALgFQALgFAMAAQAPAAAKAFQAKAEAIAIQAGAIAEAMQADALAAAOIAAAOIhPAAQAAAGADAFQADAFAEAEQAEADAFACQAEACAHAAQAJAAAIgDQAHgEAGgHIARATQgDAEgFAEIgLAIIgNAFQgJACgIAAQgOAAgMgFgAgHgjQgEABgEAEQgDADgBAFIgDALIAuAAIAAgDIgBgJQgCgFgDgDQgCgDgFgCQgDgBgHAAQgEAAgEACg',
      );
    this.shape_8.setTransform(-34.6, 1.875);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgMgFgIgIQgIgJgEgLQgFgLABgNIAAgEQAAgOADgMQAFgMAIgIQAHgJALgFQALgFAMAAQAOAAALAFQAKAEAHAIQAHAIAEAMQAEALAAAOIAAAOIhQAAQAAAGADAFQADAFAEAEQAEADAFACQAEACAGAAQAKAAAIgDQAHgEAGgHIARATQgDAEgFAEIgLAIIgNAFQgJACgIAAQgOAAgMgFgAgHgjQgFABgDAEQgCADgCAFIgDALIAuAAIAAgDIgBgJQgCgFgDgDQgCgDgFgCQgDgBgHAAQgEAAgEACg',
      );
    this.shape_9.setTransform(-47.55, 1.875);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p('AAcBVIgrhEIgSAUIAAAwIgkAAIAAipIAkAAIAABNIAPgVIArg4IArAAIg9BLIA/Beg');
    this.shape_10.setTransform(-60.925, -0.325);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.nextBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.moreBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 3
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgUA9QgLgFgJgIQgIgJgEgLQgEgLAAgNIAAgEQAAgOADgMQAFgMAIgIQAHgJALgFQALgFAMAAQAOAAALAFQAKAEAHAIQAIAIADAMQAEALAAAOIAAAOIhQAAQAAAGADAFQACAFAFAEQAEADAFACQAEACAGAAQAKAAAHgDQAJgEAFgHIARATQgDAEgFAEIgLAIIgNAFQgIACgJAAQgOAAgMgFgAgHgjQgEABgDAEQgEADgBAFIgDALIAuAAIAAgDIgBgJQgBgFgEgDQgCgDgEgCQgFgBgGAAQgEAAgEACg',
      );
    this.shape.setTransform(22.75, 1.875);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AA5BAIAAhPQAAgHgBgEQgCgEgDgCQgCgDgEAAIgHgBQgIAAgGAEQgFAEgDAGIAAACIAAABIAABTIggAAIAAhPQAAgHgCgEQAAgDgDgDIgGgDIgJgBQgHAAgFADQgFADgDAGIAABYIgiAAIAAh+IAgAAIABAPQAGgIAKgEQAIgFAMABQAMgBAIAFQAIAEAFALQAGgJAJgGQAKgEANAAQAJgBAIADQAHADAGAFQAFAGADAKQADAIAAAOIAABPg',
      );
    this.shape_1.setTransform(5.75, 1.75);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgYA9QgMgFgHgJQgIgIgEgMQgEgMAAgOIAAgBQAAgOAEgMQAEgMAIgIQAHgJALgFQAMgFANAAQAOAAAMAFQALAFAIAJQAHAIAEAMQAEAMAAAOIAAABQAAAOgEAMQgEAMgHAIQgIAJgLAFQgLAFgPAAQgNAAgLgFgAgLgiQgFADgDAFQgDAFgCAHQgBAGAAAIIAAABQAAAIABAHQACAGADAGQADAEAFADQAFADAGAAQAHAAAFgDQAFgDADgEQADgGACgGQABgHAAgIIAAgBQAAgIgBgGQgCgHgDgFQgDgFgFgDQgFgDgHAAQgGAAgFADg',
      );
    this.shape_2.setTransform(-11.425, 1.875);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AAjBVIAAhJIhEAAIAABJIgkAAIAAipIAkAAIAABFIBEAAIAAhFIAjAAIAACpg');
    this.shape_3.setTransform(-26.7, -0.325);

    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.btnHover },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.moreBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.continueBtn = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('Ag1BQIAAifIBqAAIAAAeIhBAAIAAAfIA9AAIAAAdIg9AAIAABFg');
    this.shape.setTransform(66.3, -0.6);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p('AgqBQIAAgcIAXAAIAAhnIgXAAIAAgcIBVAAIAAAcIgXAAIAABnIAXAAIAAAcg');
    this.shape_1.setTransform(53.975, -0.6);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AgUBQIg3ifIAqAAIAiBrIAihrIApAAIg3Cfg');
    this.shape_2.setTransform(41.225, -0.6);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgoAwQgTgRAAgeQAAgcARgSQARgSAeAAQAcAAANAPQAOAPAAAcIAAANIhRAAQAAAIADAGQAEAFAEAEQAFADAFABQAHACAIAAIAMgCIAMgDIAIgFIAHgEIAEAAIAAAfIgIADIgLAEIgNACIgQABQggAAgSgQgAgPggQgFAHgBALIAsAAQAAgMgGgGQgEgGgMAAQgJAAgHAGg',
      );
    this.shape_3.setTransform(20.85, 1.325);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AguAyQgJgLgBgWIAAhOIAmAAIAAA7IABAPQAAAGACAEQACAEADACQAEABAGAAQAEAAAFgBIAKgGIAAhUIAmAAIAAB3IgmAAIAAgNQgKAJgIADQgIAFgLAAQgRAAgLgMg',
      );
    this.shape_4.setTransform(7.2, 1.55);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AASA+IAAg8IAAgOQgBgGgBgEQgCgEgEgCQgEgCgGAAIgIACQgEABgGAEIAABVIglAAIAAh4IAlAAIAAAOQAJgIAJgFQAHgEALAAQATAAAJALQALAMgBAWIAABOg',
      );
    this.shape_5.setTransform(-6.8, 1.2);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FFFFFF')
      .s()
      .p('AgSBTIAAh3IAlAAIAAB3gAgTg1IAAgdIAnAAIAAAdg');
    this.shape_6.setTransform(-17.225, -0.95);

    this.shape_7 = new cjs.Shape();
    this.shape_7.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgTBFQgKgJAAgWIAAg3IgOAAIAAgaIAOAAIAAgjIAkAAIAAAjIAlAAIAAAaIglAAIAAAqIABALQAAAEABAEQACAEAEACQAEACAHAAIAIgBIAHgCIADAAIAAAaIgNADIgRABQgWAAgLgKg',
      );
    this.shape_7.setTransform(-25.05, -0.225);

    this.shape_8 = new cjs.Shape();
    this.shape_8.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AATA+IAAg8IgBgOQgBgGgBgEQgCgEgEgCQgEgCgFAAIgJACQgEABgGAEIAABVIgmAAIAAh4IAmAAIAAAOQAJgIAJgFQAIgEALAAQASAAAKALQAKAMgBAWIAABOg',
      );
    this.shape_8.setTransform(-36.7, 1.2);

    this.shape_9 = new cjs.Shape();
    this.shape_9.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgtAvQgQgRAAgeQAAgdAQgRQARgRAcAAQAeAAAQARQAQARAAAdQAAAegQARQgQARgeAAQgcAAgRgRgAgIgjQgEACgEAEQgDAFgCAHQgCAHAAAKQAAALACAHIAFALQADAEAEACQAFACAEAAQAFAAAFgCQAEgCADgEQADgEACgHQACgGAAgMQAAgKgCgHQgCgHgDgEQgDgFgEgBQgEgCgGAAQgEAAgEABg',
      );
    this.shape_9.setTransform(-50.625, 1.375);

    this.shape_10 = new cjs.Shape();
    this.shape_10.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgsA+QgVgXAAgnQAAglAVgXQAVgWAjAAIARABIAPADIAMAFIAKAEIAAAmIgEAAIgHgFIgKgIQgGgEgGgCQgHgCgIAAQgIAAgIACQgFADgHAHQgGAGgEAKQgEALAAAOQAAAOAEALQAEAJAHAHQAGAGAGACQAIADAIAAQAHAAAIgDQAHgCAFgDIAJgHIAHgGIAEAAIAAAmIgKAEIgMAFIgOADIgSABQgjAAgVgVg',
      );
    this.shape_10.setTransform(-64.75, -0.6);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_10 },
            { t: this.shape_9 },
            { t: this.shape_8 },
            { t: this.shape_7 },
            { t: this.shape_6 },
            { t: this.shape_5 },
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .wait(1),
    );

    // Layer 3
    this.btnHover = new lib.EndScreenbuttonhover();
    this.btnHover.name = 'btnHover';

    this.timeline.addTween(cjs.Tween.get(this.btnHover).wait(1));

    // Layer 2
    this.instance = new lib.EndScreenbuttonbg();

    this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.continueBtn,
    new cjs.Rectangle(-85, -20, 170, 40),
    null,
  );

  (lib.EndScreen = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.stickersText = new cjs.Text(
      'Congratulations!',
      "bold 32px 'Roboto'",
      '#003399',
    );
    this.stickersText.name = 'stickersText';
    this.stickersText.textAlign = 'center';
    this.stickersText.lineHeight = 44;
    this.stickersText.lineWidth = 498;
    this.stickersText.parent = this;
    this.stickersText.setTransform(396.95, 319.5);

    this.beforeScoreText = new cjs.Text(
      'You scored',
      "bold 30px 'Roboto'",
      '#003399',
    );
    this.beforeScoreText.name = 'beforeScoreText';
    this.beforeScoreText.textAlign = 'center';
    this.beforeScoreText.lineHeight = 42;
    this.beforeScoreText.lineWidth = 451;
    this.beforeScoreText.parent = this;
    this.beforeScoreText.setTransform(401.5, 121.35);

    this.pointsText = new cjs.Text('0', "bold 60px 'Roboto'", '#003399');
    this.pointsText.name = 'pointsText';
    this.pointsText.textAlign = 'center';
    this.pointsText.lineHeight = 78;
    this.pointsText.lineWidth = 196;
    this.pointsText.parent = this;
    this.pointsText.setTransform(400.95, 144.8);

    this.afterScoreText = new cjs.Text(
      'points',
      "bold 30px 'Roboto'",
      '#003399',
    );
    this.afterScoreText.name = 'afterScoreText';
    this.afterScoreText.textAlign = 'center';
    this.afterScoreText.lineHeight = 42;
    this.afterScoreText.lineWidth = 488;
    this.afterScoreText.parent = this;
    this.afterScoreText.setTransform(401.95, 203.7);

    this.messageText = new cjs.Text(
      'Congratulations!',
      "bold 40px 'Roboto'",
      '#003399',
    );
    this.messageText.name = 'messageText';
    this.messageText.textAlign = 'center';
    this.messageText.lineHeight = 54;
    this.messageText.lineWidth = 498;
    this.messageText.parent = this;
    this.messageText.setTransform(396.95, 243.95);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.messageText },
            { t: this.afterScoreText },
            { t: this.pointsText },
            { t: this.beforeScoreText },
            { t: this.stickersText },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.continueBtn = new lib.continueBtn();
    this.continueBtn.name = 'continueBtn';
    this.continueBtn.setTransform(424.95, 421);

    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(586.1, 421, 0.7647, 1);

    this.nextBtn = new lib.nextBtn();
    this.nextBtn.name = 'nextBtn';
    this.nextBtn.setTransform(242.05, 421);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.nextBtn },
            { t: this.moreBtn },
            { t: this.continueBtn },
          ],
        })
        .wait(1),
    );

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape.setTransform(400, 275);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // shadow
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgmRAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBMjAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_1.setTransform(405, 280);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // veil
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_2.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.EndScreen,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.comsuntexsymbolsValueTextBlack = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // fields
    this.fields = new lib.ValueTextBlack_fields();
    this.fields.name = 'fields';

    this.timeline.addTween(cjs.Tween.get(this.fields).wait(1));

    // glow
    this.textGlow = new lib.ValueText_glow();
    this.textGlow.name = 'textGlow';

    this.timeline.addTween(cjs.Tween.get(this.textGlow).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsValueTextBlack,
    new cjs.Rectangle(-48.6, -30, 96.5, 60),
    null,
  );

  (lib.textMovieClip = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };
    this.frame_3 = function () {
      this.stop();
    };
    this.frame_4 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1)
        .call(this.frame_3)
        .wait(1)
        .call(this.frame_4)
        .wait(1),
    );

    // Layer 1
    this.textb = new lib.comsuntexsymbolsValueTextBlack();
    this.textb.name = 'textb';
    this.textb.setTransform(-0.05, 0.95, 1.2185, 1.0002, 0, 0, 0, -0.1, 0);

    this.timeline.addTween(cjs.Tween.get(this.textb).wait(5));

    // Layer 2
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape.setTransform(-0.2, 1.95);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#DCF3A8')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape_1.setTransform(-0.2, 1.95);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f()
      .s('#FFFFFF')
      .ss(1, 1, 1)
      .p(
        'AGiAAQAABKh6A0Qh7A0itAAQisAAh7g0Qh6g0AAhKQAAhJB6g0QAhgOAkgKQBkgcB+AAQB/AABkAcQAkAKAhAOQB6A0AABJg',
      );
    this.shape_2.setTransform(-1.8, 1.4);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkmB+Qh7g0AAhKQAAhJB7g0QAggOAkgKQBkgcB+AAQB/AABkAcQAkAKAgAOQB7A0AABJQAABKh7A0Qh6A0itAAQisAAh6g0g',
      );
    this.shape_3.setTransform(-1.8, 1.4);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f()
      .s('#DCF3A8')
      .ss(1, 1, 1)
      .p(
        'AGiAAQAABKh6A0Qh7A0itAAQisAAh7g0Qh6g0AAhKQAAhJB6g0QAhgOAkgKQBkgcB+AAQB/AABkAcQAkAKAhAOQB6A0AABJg',
      );
    this.shape_4.setTransform(-1.8, 1.4);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#DCF3A8')
      .s()
      .p(
        'AkmB+Qh7g0AAhKQAAhJB7g0QAggOAkgKQBkgcB+AAQB/AABkAcQAkAKAgAOQB7A0AABJQAABKh7A0Qh6A0itAAQisAAh6g0g',
      );
    this.shape_5.setTransform(-1.8, 1.4);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-59.2, -29, 117.6, 60);

  (lib.start = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = { button: 0 };
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // Layer 1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape.setTransform(132.825, -102.975);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AAKA1IgZgpIAAApIgdAAIAAhpIAsAAQAIAAAGACQAGACAFAFQAJAKAAAOQAAAHgCAGQgDAGgFADQgEAFgJACIAhArgAgPgFIAEAAQAJAAACgCIAEgFIABgGIgBgGIgEgEQgCgDgJAAIgEAAg',
      );
    this.shape_1.setTransform(124.55, -102.975);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p('AAaA1IgHgSIglAAIgHASIgeAAIAphpIAeAAIAoBpgAgKAOIAWAAIgMghg');
    this.shape_2.setTransform(113.325, -102.975);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FFFFFF')
      .s()
      .p('AgNA1IAAhSIgXAAIAAgXIBJAAIAAAXIgXAAIAABSg');
    this.shape_3.setTransform(104.525, -102.975);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AgmArIAMgWQAMALAMAAQAGAAAEgDQACgDAAgEQAAgFgDgCQgEgCgIgDQgQgFgFgEQgIgGAAgPQAAgQALgKQAKgJAOAAQASAAAQAIIgLAWQgJgHgJAAQgGAAgCADQgDADAAADQAAAFAGADIAMAEQAOAEAGAHQAGAGAAAMQAAAVgNAJQgMAIgPAAQgUAAgRgNg',
      );
    this.shape_4.setTransform(96.175, -102.95);

    this.clockDisplay = new lib.comsuntexsymbolsValueTextBlack();
    this.clockDisplay.name = 'clockDisplay';
    this.clockDisplay.setTransform(
      115.65,
      -101.5,
      1.2185,
      1.25,
      0,
      0,
      0,
      -0.4,
      0,
    );
    this.clockDisplay.alpha = 0.3984;

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_4 },
            { t: this.shape_3 },
            { t: this.shape_2 },
            { t: this.shape_1 },
            { t: this.shape },
          ],
        })
        .to({ state: [{ t: this.clockDisplay }] }, 1)
        .wait(1),
    );

    // Layer 2
    this.startblock = new lib.sb();
    this.startblock.name = 'startblock';
    this.startblock.setTransform(115.8, -103.2, 1, 1, 0, 0, 0, 36.8, 15.8);

    this.timeline.addTween(cjs.Tween.get(this.startblock).wait(2));

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(56.9, -139, 117.6, 75);

  (lib.numberPanel = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // Layer 1
    this.t = new lib.textMovieClip();
    this.t.name = 't';
    this.t.setTransform(30, 52.05, 1.0917, 1, 0, 0, 0, 0, 8);

    this.text3 = new lib.comsuntexsymbolsValueTextBlack();
    this.text3.name = 'text3';
    this.text3.setTransform(29.85, 3.85, 1.3309, 1.0002, 0, 0, 0, -0.1, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.text3 }, { t: this.t }] })
        .wait(3),
    );

    // tile
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FF7D32')
      .s()
      .p('AmyH0QhBAAAAhBIAAtlQAAhBBBAAINlAAQBBAAAABBIAANlQAABBhBAAg');
    this.shape.setTransform(27.5, 22);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FF9F71')
      .s()
      .p('AmyH0QhBAAAAhBIAAtlQAAhBBBAAINlAAQBBAAAABBIAANlQAABBhBAAg');
    this.shape_1.setTransform(27.5, 22);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#D0DA4F')
      .s()
      .p('AmyH0QhBAAAAhBIAAtlQAAhBBBAAINlAAQBBAAAABBIAANlQAABBhBAAg');
    this.shape_2.setTransform(27.5, 22);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-34.7, -28, 128.4, 103);

  (lib.mPiece = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // Layer 1
    this.t = new lib.textMovieClip();
    this.t.name = 't';
    this.t.setTransform(0, 9.05, 1, 1, 0, 0, 0, 0, 8);

    this.timeline.addTween(cjs.Tween.get(this.t).wait(2));

    // Layer_1
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AibCbQhAhAAAhbQAAhaBAhAQBBhBBaAAQBbAABBBBQBABAAABaQAABbhABAQhBBBhbAAQhaAAhBhBg',
      );
    this.shape.setTransform(0.8, -0.05);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f()
      .s('#FFFFFF')
      .ss(1, 1, 1)
      .p(
        'AGiAAQAABKh6A0Qh7A0itAAQisAAh7g0Qh6g0AAhKQAAhJB6g0QAhgOAkgKQBkgcB+AAQB/AABkAcQAkAKAhAOQB6A0AABJg',
      );
    this.shape_1.setTransform(-1.8, 1.4);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AkmB+Qh7g0AAhKQAAhJB7g0QAggOAkgKQBkgcB+AAQB/AABkAcQAkAKAgAOQB7A0AABJQAABKh7A0Qh6A0itAAQisAAh6g0g',
      );
    this.shape_2.setTransform(-1.8, 1.4);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape_2 }, { t: this.shape_1 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-59.2, -28, 117.6, 60);

  (lib.gameGrid = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = { current: 0, '4cols': 1 };
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // current
    this.row2col3 = new lib.numberPanel();
    this.row2col3.name = 'row2col3';
    this.row2col3.setTransform(918.1, 373.1, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row1col3 = new lib.numberPanel();
    this.row1col3.name = 'row1col3';
    this.row1col3.setTransform(918.1, 193.1, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row0col3 = new lib.numberPanel();
    this.row0col3.name = 'row0col3';
    this.row0col3.setTransform(918.1, 12.5, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row2col0 = new lib.numberPanel();
    this.row2col0.name = 'row2col0';
    this.row2col0.setTransform(90.25, 373.1, 1.8199, 1.7668, 0, 0, 0, 17.2, 13);

    this.row2col2 = new lib.numberPanel();
    this.row2col2.name = 'row2col2';
    this.row2col2.setTransform(466.1, 374.1, 1.8198, 1.7673, 0, 0, 0, 17.1, 13);

    this.row2col1 = new lib.numberPanel();
    this.row2col1.name = 'row2col1';
    this.row2col1.setTransform(
      278.15,
      373.1,
      1.8199,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row1col2 = new lib.numberPanel();
    this.row1col2.name = 'row1col2';
    this.row1col2.setTransform(466.1, 193.1, 1.8198, 1.7668, 0, 0, 0, 17.1, 13);

    this.row1col1 = new lib.numberPanel();
    this.row1col1.name = 'row1col1';
    this.row1col1.setTransform(
      278.15,
      193.1,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.1,
      13,
    );

    this.row1col0 = new lib.numberPanel();
    this.row1col0.name = 'row1col0';
    this.row1col0.setTransform(
      90.25,
      193.3,
      1.8198,
      1.7673,
      0,
      0,
      0,
      17.2,
      13.1,
    );

    this.row0col2 = new lib.numberPanel();
    this.row0col2.name = 'row0col2';
    this.row0col2.setTransform(466.1, 12.5, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row0col1 = new lib.numberPanel();
    this.row0col1.name = 'row0col1';
    this.row0col1.setTransform(278.15, 12.5, 1.82, 1.7668, 0, 0, 0, 17.1, 13);

    this.row0col0 = new lib.numberPanel();
    this.row0col0.name = 'row0col0';
    this.row0col0.setTransform(90.25, 12.35, 1.82, 1.7668, 0, 0, 0, 17.2, 12.9);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.row0col0, p: { scaleX: 1.82, x: 90.25 } },
            { t: this.row0col1, p: { scaleX: 1.82, x: 278.15 } },
            { t: this.row0col2, p: { scaleX: 1.82, x: 466.1 } },
            { t: this.row1col0, p: { scaleX: 1.8198, x: 90.25 } },
            { t: this.row1col1, p: { scaleX: 1.8198, x: 278.15 } },
            { t: this.row1col2, p: { scaleX: 1.8198, x: 466.1 } },
            { t: this.row2col1, p: { scaleX: 1.8199, x: 278.15 } },
            { t: this.row2col2, p: { scaleX: 1.8198, x: 466.1 } },
            { t: this.row2col0, p: { scaleX: 1.8199, x: 90.25 } },
            { t: this.row0col3, p: { scaleX: 1.82, x: 918.1 } },
            { t: this.row1col3, p: { scaleX: 1.82, x: 918.1 } },
            { t: this.row2col3, p: { scaleX: 1.82, x: 918.1 } },
          ],
        })
        .to(
          {
            state: [
              { t: this.row0col0, p: { scaleX: 1.6015, x: 86.45 } },
              { t: this.row0col1, p: { scaleX: 1.6015, x: 249.45 } },
              { t: this.row0col2, p: { scaleX: 1.6015, x: 412.55 } },
              { t: this.row1col0, p: { scaleX: 1.6013, x: 86.45 } },
              { t: this.row1col1, p: { scaleX: 1.6013, x: 249.45 } },
              { t: this.row1col2, p: { scaleX: 1.6013, x: 412.55 } },
              { t: this.row2col1, p: { scaleX: 1.6014, x: 249.45 } },
              { t: this.row2col2, p: { scaleX: 1.6013, x: 412.55 } },
              { t: this.row2col0, p: { scaleX: 1.6014, x: 86.45 } },
              { t: this.row0col3, p: { scaleX: 1.6015, x: 575.1 } },
              { t: this.row1col3, p: { scaleX: 1.6015, x: 575.1 } },
              { t: this.row2col3, p: { scaleX: 1.6015, x: 575.1 } },
            ],
          },
          1,
        )
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-4.3, -59.9, 1061.8, 543.6);

  (lib.GameStage = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 3
    this.startButton = new lib.start();
    this.startButton.name = 'startButton';
    this.startButton.setTransform(600.2, 619.45, 1, 1, 0, 0, 0, 39.2, 18.2);

    this.timeline.addTween(cjs.Tween.get(this.startButton).wait(1));

    // Layer 2
    this.meterLabels = new lib.lbls();
    this.meterLabels.name = 'meterLabels';
    this.meterLabels.setTransform(675, 253.05, 1, 1, 0, 0, 0, 0.5, 0);

    this.roundMeter = new lib.verticalMeter();
    this.roundMeter.name = 'roundMeter';
    this.roundMeter.setTransform(660.95, 257, 1, 0.71, 0, 0, 0, 30.7, -21);

    this.gameMeter = new lib.verticalMeter();
    this.gameMeter.name = 'gameMeter';
    this.gameMeter.setTransform(718.95, 257, 1, 0.71, 0, 0, 0, 30.7, -21);

    this.rulesclip = new lib.rules();
    this.rulesclip.name = 'rulesclip';
    this.rulesclip.setTransform(675.95, 184.95, 1, 1, 0, 0, 0, 65, 142.8);

    this.rectngl = new lib.mRectangle();
    this.rectngl.name = 'rectngl';
    this.rectngl.setTransform(676.75, 279.8, 1, 0.9991, 0, 0, 0, 67.5, 268.2);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.rectngl },
            { t: this.rulesclip },
            { t: this.gameMeter },
            { t: this.roundMeter },
            { t: this.meterLabels },
          ],
        })
        .wait(1),
    );

    // stuff...
    this.mPiece = new lib.mPiece();
    this.mPiece.name = 'mPiece';
    this.mPiece.setTransform(145.1, -41.95, 1, 1, 0, 0, 0, 23.2, 25.9);

    this.testWindow = new lib.gameGrid();
    this.testWindow.name = 'testWindow';
    this.testWindow.setTransform(160.35, 199.4, 1, 1, 0, 0, 0, 170.8, 130.1);

    this.blocker = new lib.blocker();
    this.blocker.name = 'blocker';
    this.blocker.setTransform(217.5, 236.75, 3.0072, 3.7325, 0, 0, 0, 69, 57);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.blocker },
            { t: this.testWindow },
            { t: this.mPiece },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.GameStage,
    new cjs.Rectangle(-217, -95.8, 1264, 648.8),
    null,
  );

  (lib.comsuntexsymbolsScoreboard = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // text
    this.progressPanel = new lib.ProgressPanel();
    this.progressPanel.name = 'progressPanel';
    this.progressPanel.setTransform(283.95, 20.7, 1, 1, 0, 0, 0, 274.1, 0);

    this.timeline.addTween(cjs.Tween.get(this.progressPanel).wait(1));

    // buttons
    this.muteBtn = new lib.Scoreboard_muteBtn();
    this.muteBtn.name = 'muteBtn';
    this.muteBtn.setTransform(778.45, 20);

    this.musicBtn = new lib.Scoreboard_musicBtn();
    this.musicBtn.name = 'musicBtn';
    this.musicBtn.setTransform(738.45, 20);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.musicBtn }, { t: this.muteBtn }] })
        .wait(1),
    );

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics.f('#000000').s().p('Eg+zADSIAAmjMB9nAAAIAAGjg');
    this.shape.setTransform(400, 21);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsScoreboard,
    new cjs.Rectangle(-2, 0, 804, 42),
    null,
  );

  (lib.PracticeMenu = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 2
    this.text = new cjs.Text(
      'Select a practice round:',
      "bold 24px 'Roboto'",
      '#003399',
    );
    this.text.textAlign = 'center';
    this.text.lineHeight = 35;
    this.text.parent = this;
    this.text.setTransform(398.05, 244.75);

    this.round4Btn = new lib.roundBtn4();
    this.round4Btn.name = 'round4Btn';
    this.round4Btn.setTransform(550, 330.6, 1.1111, 1.1106);

    this.round3Btn = new lib.roundBtn3();
    this.round3Btn.name = 'round3Btn';
    this.round3Btn.setTransform(450, 330.6, 1.1111, 1.1106);

    this.round2Btn = new lib.roundBtn2();
    this.round2Btn.name = 'round2Btn';
    this.round2Btn.setTransform(350, 330.6, 1.1111, 1.1106);

    this.round1Btn = new lib.roundBtn1();
    this.round1Btn.name = 'round1Btn';
    this.round1Btn.setTransform(250, 330.6, 1.1111, 1.1106);

    this.text_1 = new cjs.Text(
      "You've finished earning stickers,\nbut you can still practice!",
      "bold 26px 'Roboto'",
      '#003399',
    );
    this.text_1.textAlign = 'center';
    this.text_1.lineHeight = 37;
    this.text_1.parent = this;
    this.text_1.setTransform(399.05, 135.9);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.text_1 },
            { t: this.round1Btn },
            { t: this.round2Btn },
            { t: this.round3Btn },
            { t: this.round4Btn },
            { t: this.text },
          ],
        })
        .wait(1),
    );

    // Layer 4
    this.moreBtn = new lib.moreBtn();
    this.moreBtn.name = 'moreBtn';
    this.moreBtn.setTransform(398.05, 425.4);

    this.timeline.addTween(cjs.Tween.get(this.moreBtn).wait(1));

    // bg
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape.setTransform(400, 280);

    this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

    // shadow
    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('rgba(0,0,0,0.098)')
      .s()
      .p(
        'EgiXAfQQh8AAhYhYQhYhYAAh8MAAAg1HQAAh8BYhYQBYhYB8AAMBEvAAAQB8AABYBYQBYBYAAB8MAAAA1HQAAB8hYBYQhYBYh8AAg',
      );
    this.shape_1.setTransform(405, 285);

    this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

    // veil
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('rgba(255,255,255,0.498)')
      .s()
      .p('Eg+fAu4MAAAhdvMB8/AAAMAAABdvg');
    this.shape_2.setTransform(400, 300);

    this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.PracticeMenu,
    new cjs.Rectangle(0, 0, 800, 600),
    null,
  );

  (lib.comsuntexsymbolsGameFrame = function (
    mode,
    startPosition,
    loop,
    reversed,
  ) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // veil
    this.veil = new lib.GameFrame_veil();
    this.veil.name = 'veil';
    this.veil.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.veil).wait(1));

    // changeRoundBtn
    this.changeRoundBtn = new lib.Scoreboard_changeRoundBtn();
    this.changeRoundBtn.name = 'changeRoundBtn';
    this.changeRoundBtn.setTransform(672.3, 578.8);

    this.timeline.addTween(cjs.Tween.get(this.changeRoundBtn).wait(1));

    // scoreboard
    this.scoreboard = new lib.comsuntexsymbolsScoreboard();
    this.scoreboard.name = 'scoreboard';
    this.scoreboard.setTransform(355.1, 573, 1, 1, 0, 0, 0, 355.1, 13);

    this.timeline.addTween(cjs.Tween.get(this.scoreboard).wait(1));

    // practiceMenu
    this.practiceMenu = new lib.PracticeMenu();
    this.practiceMenu.name = 'practiceMenu';
    this.practiceMenu.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.practiceMenu).wait(1));

    // endScreen
    this.endScreen = new lib.EndScreen();
    this.endScreen.name = 'endScreen';
    this.endScreen.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.endScreen).wait(1));

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.comsuntexsymbolsGameFrame,
    new cjs.Rectangle(-5, -5, 810, 610),
    null,
  );

  // stage content:
  (lib.VIFRulesAddSub = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // gameFrame
    this.gameFrame = new lib.comsuntexsymbolsGameFrame();
    this.gameFrame.name = 'gameFrame';
    this.gameFrame.setTransform(400, 300, 1, 1, 0, 0, 0, 400, 300);

    this.timeline.addTween(cjs.Tween.get(this.gameFrame).wait(1));

    // gameStage
    this.gameStage = new lib.GameStage();
    this.gameStage.name = 'gameStage';
    this.gameStage.setTransform(396, 273.8, 1, 1, 0, 0, 0, 396, 273.8);

    this.timeline.addTween(cjs.Tween.get(this.gameStage).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(183, 204.2, 864, 400.8);
  // library properties:
  lib.properties = {
    id: '3D6A2DC00D1C524A8A9801BF8166275F',
    width: 800,
    height: 600,
    fps: 24,
    color: '#FFFFFF',
    opacity: 1.0,
    manifest: [],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['3D6A2DC00D1C524A8A9801BF8166275F'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
    stage,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
}
